
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $5440e9199a418654$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $5440e9199a418654$var$R = typeof Reflect === 'object' ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === 'function' ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === 'function') $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
$5440e9199a418654$exports = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}



// @ts-nocheck
// NOTE (csantos): This file was taken directly from twilio-video and has been renamed from JS to TS only.
// It needs to be re-written as part of the overall updating of the files to TS.
class $e2f41017236580ee$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * Construct a {@link Backoff}.
     * @param {object} options
     * @property {number} min - Initial timeout in milliseconds [100]
     * @property {number} max - Max timeout [10000]
     * @property {number} jitter - Apply jitter [0]
     * @property {number} factor - Multiplication factor for Backoff operation [2]
     * @property {boolean} useInitialValue - Whether to use the initial value on the first backoff call [false]
     */ constructor(options){
        super();
        Object.defineProperties(this, {
            _attempts: {
                value: 0,
                writable: true
            },
            _duration: {
                enumerable: false,
                get () {
                    if (this._useInitialValue && this._attempts === 0) return this._min;
                    let ms = this._min * Math.pow(this._factor, this._attempts);
                    if (this._jitter) {
                        const rand = Math.random();
                        const deviation = Math.floor(rand * this._jitter * ms);
                        // tslint:disable-next-line
                        ms = (Math.floor(rand * 10) & 1) === 0 ? ms - deviation : ms + deviation;
                    }
                    // tslint:disable-next-line
                    return Math.min(ms, this._max) | 0;
                }
            },
            _factor: {
                value: options.factor || 2
            },
            _jitter: {
                value: options.jitter > 0 && options.jitter <= 1 ? options.jitter : 0
            },
            _max: {
                value: options.max || 10000
            },
            _min: {
                value: options.min || 100
            },
            _timeoutID: {
                value: null,
                writable: true
            },
            _useInitialValue: {
                value: options.useInitialValue || false
            }
        });
    }
    backoff() {
        const duration = this._duration;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
        this.emit('backoff', this._attempts, duration);
        this._timeoutID = setTimeout(()=>{
            this.emit('ready', this._attempts, duration);
            this._attempts++;
        }, duration);
    }
    reset() {
        this._attempts = 0;
        if (this._timeoutID) {
            clearTimeout(this._timeoutID);
            this._timeoutID = null;
        }
    }
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $5c96a02c592fcff1$var$ownKeys = function(o) {
    $5c96a02c592fcff1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $5c96a02c592fcff1$var$ownKeys(o);
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $5c96a02c592fcff1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};



var $fe91437b241bf996$exports = {};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === 'function' && define.amd) define(definition);
    else if ($fe91437b241bf996$exports) $fe91437b241bf996$exports = definition();
    else root.log = definition();
})($fe91437b241bf996$exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === 'function') return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === 'debug') methodName = 'log';
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === 'trace' && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, 'log');
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods() {
        /*jshint validthis:true */ var level = this.getLevel();
        // Replace the actual methods.
        for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
        // Return any important warnings.
        if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, _level, _loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
        // Private instance variables.
        var self = this;
        /**
       * The level inherited from a parent logger (or a global default). We
       * cache this here rather than delegating to the parent so that it stays
       * in sync with the actual logging methods that we have installed (the
       * parent could change levels but we might not have rebuilt the loggers
       * in this child yet).
       * @type {number}
       */ var inheritedLevel;
        /**
       * The default level for this logger, if any. If set, this overrides
       * `inheritedLevel`.
       * @type {number|null}
       */ var defaultLevel;
        /**
       * A user-specific level for this logger. If set, this overrides
       * `defaultLevel`.
       * @type {number|null}
       */ var userLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if (typeof name === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || 'silent').toUpperCase();
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var cookieName = encodeURIComponent(storageKey);
                var location = cookie.indexOf(cookieName + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        function normalizeLevel(input) {
            var level = input;
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
            else throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            if (userLevel != null) return userLevel;
            else if (defaultLevel != null) return defaultLevel;
            else return inheritedLevel;
        };
        self.setLevel = function(level, persist) {
            userLevel = normalizeLevel(level);
            if (persist !== false) persistLevelIfPossible(userLevel);
            // NOTE: in v2, this should call rebuild(), which updates children.
            return replaceLoggingMethods.call(self);
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = normalizeLevel(level);
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            userLevel = null;
            clearPersistedLevel();
            replaceLoggingMethods.call(self);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        self.rebuild = function() {
            if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
            replaceLoggingMethods.call(self);
            if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
        };
        // Initialize all the internal levels.
        inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
        var initialLevel = getPersistedLevel();
        if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
        replaceLoggingMethods.call(self);
    }
    /*
     *
     * Top-level API
     *
     */ defaultLogger = new Logger();
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger['default'] = defaultLogger;
    return defaultLogger;
});





/**
 * Base class for all possible errors that the library can receive from the
 * Twilio backend.
 */ class $ff231d151f409dfb$export$2e2bcd8739ae039 extends Error {
    /**
     * @internal
     */ constructor(messageOrError, error){
        super();
        Object.setPrototypeOf(this, $ff231d151f409dfb$export$2e2bcd8739ae039.prototype);
        const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
        const originalError = typeof messageOrError === 'object' ? messageOrError : error;
        this.message = `${this.name} (${this.code}): ${message}`;
        this.originalError = originalError;
    }
}


/* tslint:disable max-classes-per-file max-line-length */ /**
 * This is a generated file. Any modifications here will be overwritten. See scripts/errors.js.
 */ var $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7;
(function(AuthorizationErrors) {
    /**
     * Error received from the Twilio backend.
     */ class AccessTokenInvalid extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20101;
            this.description = 'Invalid access token';
            this.explanation = 'Twilio was unable to validate your Access Token';
            this.name = 'AccessTokenInvalid';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AccessTokenInvalid.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AccessTokenInvalid = AccessTokenInvalid;
    /**
     * Error received from the Twilio backend.
     */ class AccessTokenExpired extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20104;
            this.description = 'Access token expired or expiration date invalid';
            this.explanation = 'The Access Token provided to the Twilio API has expired, the expiration time specified in the token was invalid, or the expiration time specified was too far in the future';
            this.name = 'AccessTokenExpired';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AccessTokenExpired.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AccessTokenExpired = AccessTokenExpired;
    /**
     * Error received from the Twilio backend.
     */ class AuthenticationFailed extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 20151;
            this.description = 'Authentication Failed';
            this.explanation = 'The Authentication with the provided JWT failed';
            this.name = 'AuthenticationFailed';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AuthenticationFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AuthenticationFailed = AuthenticationFailed;
})($4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7 || ($4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7 = {}));
var $4bc3a86d2ffe35f2$export$ac558a19be5cca90;
(function(SignatureValidationErrors) {
    /**
     * Error received from the Twilio backend.
     */ class AccessTokenSignatureValidationFailed extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The access token has an invalid Account SID, API Key, or API Key Secret.'
            ];
            this.code = 31202;
            this.description = 'Signature validation failed.';
            this.explanation = 'The provided access token failed signature validation.';
            this.name = 'AccessTokenSignatureValidationFailed';
            this.solutions = [
                'Ensure the Account SID, API Key, and API Key Secret are valid when generating your access token.'
            ];
            Object.setPrototypeOf(this, SignatureValidationErrors.AccessTokenSignatureValidationFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignatureValidationErrors.AccessTokenSignatureValidationFailed = AccessTokenSignatureValidationFailed;
})($4bc3a86d2ffe35f2$export$ac558a19be5cca90 || ($4bc3a86d2ffe35f2$export$ac558a19be5cca90 = {}));
var $4bc3a86d2ffe35f2$export$41fe58768873a487;
(function(ClientErrors) {
    /**
     * Error received from the Twilio backend.
     */ class BadRequest extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31400;
            this.description = 'Bad Request (HTTP/SIP)';
            this.explanation = 'The request could not be understood due to malformed syntax.';
            this.name = 'BadRequest';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.BadRequest.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.BadRequest = BadRequest;
    /**
     * Error received from the Twilio backend.
     */ class NotFound extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The outbound call was made to an invalid phone number.',
                'The TwiML application sid is missing a Voice URL.'
            ];
            this.code = 31404;
            this.description = 'Not Found (HTTP/SIP)';
            this.explanation = 'The server has not found anything matching the request.';
            this.name = 'NotFound';
            this.solutions = [
                'Ensure the phone number dialed is valid.',
                'Ensure the TwiML application is configured correctly with a Voice URL link.'
            ];
            Object.setPrototypeOf(this, ClientErrors.NotFound.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.NotFound = NotFound;
    /**
     * Error received from the Twilio backend.
     */ class TemporarilyUnavailable extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31480;
            this.description = 'Temporarily Unavailable (SIP)';
            this.explanation = 'The callee is currently unavailable.';
            this.name = 'TemporarilyUnavailable';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.TemporarilyUnavailable.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.TemporarilyUnavailable = TemporarilyUnavailable;
    /**
     * Error received from the Twilio backend.
     */ class BusyHere extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31486;
            this.description = 'Busy Here (SIP)';
            this.explanation = 'The callee is busy.';
            this.name = 'BusyHere';
            this.solutions = [];
            Object.setPrototypeOf(this, ClientErrors.BusyHere.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    ClientErrors.BusyHere = BusyHere;
})($4bc3a86d2ffe35f2$export$41fe58768873a487 || ($4bc3a86d2ffe35f2$export$41fe58768873a487 = {}));
var $4bc3a86d2ffe35f2$export$d17e9c5dda943f12;
(function(SIPServerErrors) {
    /**
     * Error received from the Twilio backend.
     */ class Decline extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31603;
            this.description = 'Decline (SIP)';
            this.explanation = 'The callee does not wish to participate in the call.';
            this.name = 'Decline';
            this.solutions = [];
            Object.setPrototypeOf(this, SIPServerErrors.Decline.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SIPServerErrors.Decline = Decline;
})($4bc3a86d2ffe35f2$export$d17e9c5dda943f12 || ($4bc3a86d2ffe35f2$export$d17e9c5dda943f12 = {}));
var $4bc3a86d2ffe35f2$export$a0a7c95426af7b48;
(function(GeneralErrors) {
    /**
     * Error received from the Twilio backend.
     */ class UnknownError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31000;
            this.description = 'Unknown Error';
            this.explanation = 'An unknown error has occurred. See error details for more information.';
            this.name = 'UnknownError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.UnknownError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.UnknownError = UnknownError;
    /**
     * Error received from the Twilio backend.
     */ class ApplicationNotFoundError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31001;
            this.description = 'Application Not Found';
            this.explanation = '';
            this.name = 'ApplicationNotFoundError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ApplicationNotFoundError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ApplicationNotFoundError = ApplicationNotFoundError;
    /**
     * Error received from the Twilio backend.
     */ class ConnectionDeclinedError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31002;
            this.description = 'Connection Declined';
            this.explanation = '';
            this.name = 'ConnectionDeclinedError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionDeclinedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionDeclinedError = ConnectionDeclinedError;
    /**
     * Error received from the Twilio backend.
     */ class ConnectionTimeoutError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31003;
            this.description = 'Connection Timeout';
            this.explanation = 'The server could not produce a response within a suitable amount of time.';
            this.name = 'ConnectionTimeoutError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionTimeoutError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionTimeoutError = ConnectionTimeoutError;
    /**
     * Error received from the Twilio backend.
     */ class ConnectionError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31005;
            this.description = 'Connection error';
            this.explanation = 'A connection error occurred during the call';
            this.name = 'ConnectionError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.ConnectionError = ConnectionError;
    /**
     * Error received from the Twilio backend.
     */ class CallCancelledError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The incoming call was cancelled because it was not answered in time or it was accepted/rejected by another application instance registered with the same identity.'
            ];
            this.code = 31008;
            this.description = 'Call cancelled';
            this.explanation = 'Unable to answer because the call has ended';
            this.name = 'CallCancelledError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.CallCancelledError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.CallCancelledError = CallCancelledError;
    /**
     * Error received from the Twilio backend.
     */ class TransportError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31009;
            this.description = 'Transport error';
            this.explanation = 'No transport available to send or receive messages';
            this.name = 'TransportError';
            this.solutions = [];
            Object.setPrototypeOf(this, GeneralErrors.TransportError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    GeneralErrors.TransportError = TransportError;
})($4bc3a86d2ffe35f2$export$a0a7c95426af7b48 || ($4bc3a86d2ffe35f2$export$a0a7c95426af7b48 = {}));
var $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4;
(function(MalformedRequestErrors) {
    /**
     * Error received from the Twilio backend.
     */ class MalformedRequestError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Invalid content or MessageType passed to sendMessage method.'
            ];
            this.code = 31100;
            this.description = 'The request had malformed syntax.';
            this.explanation = 'The request could not be understood due to malformed syntax.';
            this.name = 'MalformedRequestError';
            this.solutions = [
                'Ensure content and MessageType passed to sendMessage method are valid.'
            ];
            Object.setPrototypeOf(this, MalformedRequestErrors.MalformedRequestError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MalformedRequestError = MalformedRequestError;
    /**
     * Error received from the Twilio backend.
     */ class MissingParameterArrayError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31101;
            this.description = 'Missing parameter array in request';
            this.explanation = '';
            this.name = 'MissingParameterArrayError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.MissingParameterArrayError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MissingParameterArrayError = MissingParameterArrayError;
    /**
     * Error received from the Twilio backend.
     */ class AuthorizationTokenMissingError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31102;
            this.description = 'Authorization token missing in request.';
            this.explanation = '';
            this.name = 'AuthorizationTokenMissingError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.AuthorizationTokenMissingError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.AuthorizationTokenMissingError = AuthorizationTokenMissingError;
    /**
     * Error received from the Twilio backend.
     */ class MaxParameterLengthExceededError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31103;
            this.description = 'Maximum parameter length has been exceeded.';
            this.explanation = 'Length of parameters cannot exceed MAX_PARAM_LENGTH.';
            this.name = 'MaxParameterLengthExceededError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.MaxParameterLengthExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.MaxParameterLengthExceededError = MaxParameterLengthExceededError;
    /**
     * Error received from the Twilio backend.
     */ class InvalidBridgeTokenError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31104;
            this.description = 'Invalid bridge token';
            this.explanation = '';
            this.name = 'InvalidBridgeTokenError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.InvalidBridgeTokenError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.InvalidBridgeTokenError = InvalidBridgeTokenError;
    /**
     * Error received from the Twilio backend.
     */ class InvalidClientNameError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Client name contains invalid characters.'
            ];
            this.code = 31105;
            this.description = 'Invalid client name';
            this.explanation = 'Client name should not contain control, space, delims, or unwise characters.';
            this.name = 'InvalidClientNameError';
            this.solutions = [
                'Make sure that client name does not contain any of the invalid characters.'
            ];
            Object.setPrototypeOf(this, MalformedRequestErrors.InvalidClientNameError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.InvalidClientNameError = InvalidClientNameError;
    /**
     * Error received from the Twilio backend.
     */ class ReconnectParameterInvalidError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31107;
            this.description = 'The reconnect parameter is invalid';
            this.explanation = '';
            this.name = 'ReconnectParameterInvalidError';
            this.solutions = [];
            Object.setPrototypeOf(this, MalformedRequestErrors.ReconnectParameterInvalidError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MalformedRequestErrors.ReconnectParameterInvalidError = ReconnectParameterInvalidError;
})($4bc3a86d2ffe35f2$export$43b0cf2a2da583e4 || ($4bc3a86d2ffe35f2$export$43b0cf2a2da583e4 = {}));
(function(AuthorizationErrors) {
    /**
     * Error received from the Twilio backend.
     */ class AuthorizationError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31201;
            this.description = 'Authorization error';
            this.explanation = 'The request requires user authentication. The server understood the request, but is refusing to fulfill it.';
            this.name = 'AuthorizationError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.AuthorizationError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.AuthorizationError = AuthorizationError;
    /**
     * Error received from the Twilio backend.
     */ class NoValidAccountError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31203;
            this.description = 'No valid account';
            this.explanation = '';
            this.name = 'NoValidAccountError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.NoValidAccountError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.NoValidAccountError = NoValidAccountError;
    /**
     * Error received from the Twilio backend.
     */ class InvalidJWTTokenError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31204;
            this.description = 'Invalid JWT token';
            this.explanation = '';
            this.name = 'InvalidJWTTokenError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.InvalidJWTTokenError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.InvalidJWTTokenError = InvalidJWTTokenError;
    /**
     * Error received from the Twilio backend.
     */ class JWTTokenExpiredError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31205;
            this.description = 'JWT token expired';
            this.explanation = '';
            this.name = 'JWTTokenExpiredError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.JWTTokenExpiredError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.JWTTokenExpiredError = JWTTokenExpiredError;
    /**
     * Error received from the Twilio backend.
     */ class RateExceededError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'Rate limit exceeded.'
            ];
            this.code = 31206;
            this.description = 'Rate exceeded authorized limit.';
            this.explanation = 'The request performed exceeds the authorized limit.';
            this.name = 'RateExceededError';
            this.solutions = [
                'Ensure message send rate does not exceed authorized limits.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.RateExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.RateExceededError = RateExceededError;
    /**
     * Error received from the Twilio backend.
     */ class JWTTokenExpirationTooLongError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31207;
            this.description = 'JWT token expiration too long';
            this.explanation = '';
            this.name = 'JWTTokenExpirationTooLongError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.JWTTokenExpirationTooLongError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.JWTTokenExpirationTooLongError = JWTTokenExpirationTooLongError;
    /**
     * Error received from the Twilio backend.
     */ class ReconnectAttemptError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 31209;
            this.description = 'Reconnect attempt is not authorized.';
            this.explanation = '';
            this.name = 'ReconnectAttemptError';
            this.solutions = [];
            Object.setPrototypeOf(this, AuthorizationErrors.ReconnectAttemptError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.ReconnectAttemptError = ReconnectAttemptError;
    /**
     * Error received from the Twilio backend.
     */ class CallMessageEventTypeInvalidError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Call Message Event Type is invalid and is not understood by Twilio Voice.'
            ];
            this.code = 31210;
            this.description = 'Call Message Event Type is invalid.';
            this.explanation = 'The Call Message Event Type is invalid and is not understood by Twilio Voice.';
            this.name = 'CallMessageEventTypeInvalidError';
            this.solutions = [
                'Ensure the Call Message Event Type is Valid and understood by Twilio Voice and try again.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.CallMessageEventTypeInvalidError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.CallMessageEventTypeInvalidError = CallMessageEventTypeInvalidError;
    /**
     * Error received from the Twilio backend.
     */ class PayloadSizeExceededError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The payload size of Call Message Event exceeds the authorized limit.'
            ];
            this.code = 31212;
            this.description = 'Call Message Event Payload size exceeded authorized limit.';
            this.explanation = 'The request performed to send a Call Message Event exceeds the payload size authorized limit';
            this.name = 'PayloadSizeExceededError';
            this.solutions = [
                'Reduce payload size of Call Message Event to be within the authorized limit and try again.'
            ];
            Object.setPrototypeOf(this, AuthorizationErrors.PayloadSizeExceededError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    AuthorizationErrors.PayloadSizeExceededError = PayloadSizeExceededError;
})($4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7 || ($4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7 = {}));
var $4bc3a86d2ffe35f2$export$21b1583df4547a66;
(function(UserMediaErrors) {
    /**
     * Error received from the Twilio backend.
     */ class PermissionDeniedError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The user denied the getUserMedia request.',
                'The browser denied the getUserMedia request.'
            ];
            this.code = 31401;
            this.description = 'UserMedia Permission Denied Error';
            this.explanation = 'The browser or end-user denied permissions to user media. Therefore we were unable to acquire input audio.';
            this.name = 'PermissionDeniedError';
            this.solutions = [
                'The user should accept the request next time prompted. If the browser saved the deny, the user should change that permission in their browser.',
                'The user should to verify that the browser has permission to access the microphone at this address.'
            ];
            Object.setPrototypeOf(this, UserMediaErrors.PermissionDeniedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    UserMediaErrors.PermissionDeniedError = PermissionDeniedError;
    /**
     * Error received from the Twilio backend.
     */ class AcquisitionFailedError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'NotFoundError - The deviceID specified was not found.',
                'The getUserMedia constraints were overconstrained and no devices matched.'
            ];
            this.code = 31402;
            this.description = 'UserMedia Acquisition Failed Error';
            this.explanation = 'The browser and end-user allowed permissions, however getting the media failed. Usually this is due to bad constraints, but can sometimes fail due to browser, OS or hardware issues.';
            this.name = 'AcquisitionFailedError';
            this.solutions = [
                'Ensure the deviceID being specified exists.',
                'Try acquiring media with fewer constraints.'
            ];
            Object.setPrototypeOf(this, UserMediaErrors.AcquisitionFailedError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    UserMediaErrors.AcquisitionFailedError = AcquisitionFailedError;
})($4bc3a86d2ffe35f2$export$21b1583df4547a66 || ($4bc3a86d2ffe35f2$export$21b1583df4547a66 = {}));
var $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1;
(function(SignalingErrors) {
    /**
     * Error received from the Twilio backend.
     */ class ConnectionError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [];
            this.code = 53000;
            this.description = 'Signaling connection error';
            this.explanation = 'Raised whenever a signaling connection error occurs that is not covered by a more specific error code.';
            this.name = 'ConnectionError';
            this.solutions = [];
            Object.setPrototypeOf(this, SignalingErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignalingErrors.ConnectionError = ConnectionError;
    /**
     * Error received from the Twilio backend.
     */ class ConnectionDisconnected extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The device running your application lost its Internet connection.'
            ];
            this.code = 53001;
            this.description = 'Signaling connection disconnected';
            this.explanation = 'Raised whenever the signaling connection is unexpectedly disconnected.';
            this.name = 'ConnectionDisconnected';
            this.solutions = [
                'Ensure the device running your application has access to a stable Internet connection.'
            ];
            Object.setPrototypeOf(this, SignalingErrors.ConnectionDisconnected.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    SignalingErrors.ConnectionDisconnected = ConnectionDisconnected;
})($4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1 || ($4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1 = {}));
var $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899;
(function(MediaErrors) {
    /**
     * Error received from the Twilio backend.
     */ class ClientLocalDescFailed extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client may not be using a supported WebRTC implementation.',
                'The Client may not have the necessary resources to create or apply a new media description.'
            ];
            this.code = 53400;
            this.description = 'Client is unable to create or apply a local media description';
            this.explanation = 'Raised whenever a Client is unable to create or apply a local media description.';
            this.name = 'ClientLocalDescFailed';
            this.solutions = [
                'If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ClientLocalDescFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ClientLocalDescFailed = ClientLocalDescFailed;
    /**
     * Error received from the Twilio backend.
     */ class ClientRemoteDescFailed extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client may not be using a supported WebRTC implementation.',
                'The Client may be connecting peer-to-peer with another Participant that is not using a supported WebRTC implementation.',
                'The Client may not have the necessary resources to apply a new media description.'
            ];
            this.code = 53402;
            this.description = 'Client is unable to apply a remote media description';
            this.explanation = 'Raised whenever the Client receives a remote media description but is unable to apply it.';
            this.name = 'ClientRemoteDescFailed';
            this.solutions = [
                'If you are experiencing this error using the JavaScript SDK, ensure you are running it with a supported WebRTC implementation.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ClientRemoteDescFailed.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ClientRemoteDescFailed = ClientRemoteDescFailed;
    /**
     * Error received from the Twilio backend.
     */ class ConnectionError extends (0, $ff231d151f409dfb$export$2e2bcd8739ae039) {
        /**
         * @internal
         */ constructor(messageOrError, error){
            super(messageOrError, error);
            this.causes = [
                'The Client was unable to establish a media connection.',
                'A media connection which was active failed liveliness checks.'
            ];
            this.code = 53405;
            this.description = 'Media connection failed';
            this.explanation = 'Raised by the Client or Server whenever a media connection fails.';
            this.name = 'ConnectionError';
            this.solutions = [
                'If the problem persists, try connecting to another region.',
                'Check your Client\'s network connectivity.',
                'If you\'ve provided custom ICE Servers then ensure that the URLs and credentials are valid.'
            ];
            Object.setPrototypeOf(this, MediaErrors.ConnectionError.prototype);
            const message = typeof messageOrError === 'string' ? messageOrError : this.explanation;
            const originalError = typeof messageOrError === 'object' ? messageOrError : error;
            this.message = `${this.name} (${this.code}): ${message}`;
            this.originalError = originalError;
        }
    }
    MediaErrors.ConnectionError = ConnectionError;
})($4bc3a86d2ffe35f2$export$8fcb1fc8290c4899 || ($4bc3a86d2ffe35f2$export$8fcb1fc8290c4899 = {}));
/**
 * @private
 */ const $4bc3a86d2ffe35f2$export$f00b6906b1a93af1 = new Map([
    [
        20101,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.AccessTokenInvalid
    ],
    [
        20104,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.AccessTokenExpired
    ],
    [
        20151,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.AuthenticationFailed
    ],
    [
        31202,
        $4bc3a86d2ffe35f2$export$ac558a19be5cca90.AccessTokenSignatureValidationFailed
    ],
    [
        31400,
        $4bc3a86d2ffe35f2$export$41fe58768873a487.BadRequest
    ],
    [
        31404,
        $4bc3a86d2ffe35f2$export$41fe58768873a487.NotFound
    ],
    [
        31480,
        $4bc3a86d2ffe35f2$export$41fe58768873a487.TemporarilyUnavailable
    ],
    [
        31486,
        $4bc3a86d2ffe35f2$export$41fe58768873a487.BusyHere
    ],
    [
        31603,
        $4bc3a86d2ffe35f2$export$d17e9c5dda943f12.Decline
    ],
    [
        31000,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.UnknownError
    ],
    [
        31001,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.ApplicationNotFoundError
    ],
    [
        31002,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.ConnectionDeclinedError
    ],
    [
        31003,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.ConnectionTimeoutError
    ],
    [
        31005,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.ConnectionError
    ],
    [
        31008,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.CallCancelledError
    ],
    [
        31009,
        $4bc3a86d2ffe35f2$export$a0a7c95426af7b48.TransportError
    ],
    [
        31100,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.MalformedRequestError
    ],
    [
        31101,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.MissingParameterArrayError
    ],
    [
        31102,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.AuthorizationTokenMissingError
    ],
    [
        31103,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.MaxParameterLengthExceededError
    ],
    [
        31104,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.InvalidBridgeTokenError
    ],
    [
        31105,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.InvalidClientNameError
    ],
    [
        31107,
        $4bc3a86d2ffe35f2$export$43b0cf2a2da583e4.ReconnectParameterInvalidError
    ],
    [
        31201,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.AuthorizationError
    ],
    [
        31203,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.NoValidAccountError
    ],
    [
        31204,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.InvalidJWTTokenError
    ],
    [
        31205,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.JWTTokenExpiredError
    ],
    [
        31206,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.RateExceededError
    ],
    [
        31207,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.JWTTokenExpirationTooLongError
    ],
    [
        31209,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.ReconnectAttemptError
    ],
    [
        31210,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.CallMessageEventTypeInvalidError
    ],
    [
        31212,
        $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7.PayloadSizeExceededError
    ],
    [
        31401,
        $4bc3a86d2ffe35f2$export$21b1583df4547a66.PermissionDeniedError
    ],
    [
        31402,
        $4bc3a86d2ffe35f2$export$21b1583df4547a66.AcquisitionFailedError
    ],
    [
        53000,
        $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1.ConnectionError
    ],
    [
        53001,
        $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1.ConnectionDisconnected
    ],
    [
        53400,
        $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899.ClientLocalDescFailed
    ],
    [
        53402,
        $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899.ClientRemoteDescFailed
    ],
    [
        53405,
        $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899.ConnectionError
    ]
]);
Object.freeze($4bc3a86d2ffe35f2$export$f00b6906b1a93af1);



/* tslint:disable max-classes-per-file */ // TODO: Consider refactoring this export (VBLOCKS-4589)
/**
 * NOTE(mhuynh): Replacing generic error codes with new (more specific) codes,
 * is a breaking change. If an error code is found in this set, we only perform
 * the transformation if the feature flag is enabled.
 *
 * With every major version bump, such that we are allowed to introduce breaking
 * changes as per semver specification, this array should be cleared.
 *
 * TODO: [VBLOCKS-2295] Remove this in 3.x
 */ const $d122425987f9ca02$var$PRECISE_SIGNALING_ERROR_CODES = new Set([
    /**
     * 310XX Errors
     */ 31001,
    31002,
    31003,
    /**
     * 311XX Errors
     */ 31101,
    31102,
    31103,
    31104,
    31105,
    31107,
    /**
     * 312XX Errors
     */ 31201,
    31202,
    31203,
    31204,
    31205,
    31207,
    /**
     * 314XX Errors
     */ 31404,
    31480,
    31486,
    /**
     * 316XX Errors
     */ 31603
]);
/**
 * Get an error constructor using the [[PRECISE_SIGNALING_ERROR_CODES]] set.
 * @internal
 * @param enableImprovedSignalingErrorPrecision - A boolean representing the
 * optional flag whether or not to use more precise error codes.
 * @param errorCode - The error code.
 * @returns This function returns `undefined` if the passed error code does not
 * correlate to an error or should not be constructed with a more precise error
 * constructor. A sub-class of {@link TwilioError} if the code does correlate to
 * an error.
 */ function $d122425987f9ca02$export$5a8950f600406bb3(enableImprovedSignalingErrorPrecision, errorCode) {
    if (typeof errorCode !== 'number') return;
    if (!$d122425987f9ca02$export$11996dd5b6c78b62(errorCode)) return;
    const shouldTransform = enableImprovedSignalingErrorPrecision ? true : !$d122425987f9ca02$var$PRECISE_SIGNALING_ERROR_CODES.has(errorCode);
    if (!shouldTransform) return;
    return $d122425987f9ca02$export$60a3bac005957e12(errorCode);
}
/**
 * The error that is thrown when an invalid argument is passed to a library API.
 */ class $d122425987f9ca02$export$9c711d4a95378233 extends Error {
    /**
     * @internal
     */ constructor(message){
        super(message);
        this.name = 'InvalidArgumentError';
    }
}
/**
 * The error that is thrown when the library has entered an invalid state.
 */ class $d122425987f9ca02$export$b251fc1661a3152d extends Error {
    /**
     * @internal
     */ constructor(message){
        super(message);
        this.name = 'InvalidStateError';
    }
}
/**
 * The error that is thrown when an attempt is made to use an API that is not
 * supported on the current platform.
 */ class $d122425987f9ca02$export$8aaa78fc27e196e7 extends Error {
    /**
     * @internal
     */ constructor(message){
        super(message);
        this.name = 'NotSupportedError';
    }
}
/**
 * This should only be used to look up error codes returned by a server
 * using the same repo of error codes.
 * @internal
 */ function $d122425987f9ca02$export$60a3bac005957e12(code) {
    const error = (0, $4bc3a86d2ffe35f2$export$f00b6906b1a93af1).get(code);
    if (!error) throw new $d122425987f9ca02$export$9c711d4a95378233(`Error code ${code} not found`);
    return error;
}
/**
 * This should only be used to look up error codes returned by a server
 * using the same repo of error codes.
 * @internal
 */ function $d122425987f9ca02$export$11996dd5b6c78b62(code) {
    return (0, $4bc3a86d2ffe35f2$export$f00b6906b1a93af1).has(code);
}



/**
 * This file is generated on build. To make changes, see /templates/constants.ts
 */ const $1ec27394c1cce6bb$export$b8b9d90f9e5bd72b = '@twilio/voice-sdk';
const $1ec27394c1cce6bb$export$f1af843f4d252578 = '2.18.5';
const $1ec27394c1cce6bb$export$d5db989063a1308b = 'https://sdk.twilio.com/js/client/sounds/releases/1.0.0';
const $1ec27394c1cce6bb$export$76d6f2318155ab63 = `${$1ec27394c1cce6bb$export$d5db989063a1308b}/cowbell.mp3?cache=${$1ec27394c1cce6bb$export$f1af843f4d252578}`;
const $1ec27394c1cce6bb$export$40ba67aa4f553679 = 20000;


/**
 * {@link Log} provides logging features throughout the sdk using loglevel module
 * See https://github.com/pimterry/loglevel for documentation
 * @private
 */ class $596211e588505f95$export$2e2bcd8739ae039 {
    /**
     * Return the `loglevel` instance maintained internally.
     * @param [options] - Optional settings
     * @returns The `loglevel` instance.
     */ static getLogLevelInstance(options) {
        if (!$596211e588505f95$export$2e2bcd8739ae039.loglevelInstance) try {
            $596211e588505f95$export$2e2bcd8739ae039.loglevelInstance = (options && options.LogLevelModule ? options.LogLevelModule : $fe91437b241bf996$exports).getLogger((0, $1ec27394c1cce6bb$export$b8b9d90f9e5bd72b));
        } catch (_a) {
            // tslint:disable-next-line
            console.warn('Cannot create custom logger');
            $596211e588505f95$export$2e2bcd8739ae039.loglevelInstance = console;
        }
        return $596211e588505f95$export$2e2bcd8739ae039.loglevelInstance;
    }
    /**
     * @constructor
     * @param [tag] - tag name for the logs
     * @param [options] - Optional settings
     */ constructor(tag, options){
        this._log = $596211e588505f95$export$2e2bcd8739ae039.getLogLevelInstance(options);
        this._prefix = `[TwilioVoice][${tag}]`;
    }
    /**
     * Log a debug message
     * @param args - Any number of arguments to be passed to loglevel.debug
     */ debug(...args) {
        this._log.debug(this._prefix, ...args);
    }
    /**
     * Log an error message
     * @param args - Any number of arguments to be passed to loglevel.error
     */ error(...args) {
        this._log.error(this._prefix, ...args);
    }
    /**
     * Log an info message
     * @param args - Any number of arguments to be passed to loglevel.info
     */ info(...args) {
        this._log.info(this._prefix, ...args);
    }
    /**
     * Set a default log level to disable all logging below the given level
     */ setDefaultLevel(level) {
        if (this._log.setDefaultLevel) this._log.setDefaultLevel(level);
        else // tslint:disable-next-line
        console.warn('Logger cannot setDefaultLevel');
    }
    /**
     * Log a warning message
     * @param args - Any number of arguments to be passed to loglevel.warn
     */ warn(...args) {
        this._log.warn(this._prefix, ...args);
    }
}
/**
 * Log levels
 */ $596211e588505f95$export$2e2bcd8739ae039.levels = $fe91437b241bf996$exports.levels;
const $596211e588505f95$export$efa9a398d6368992 = $596211e588505f95$export$2e2bcd8739ae039.getLogLevelInstance();





const $446fdaf403657943$var$DEFAULT_TEST_SOUND_URL = `${(0, $1ec27394c1cce6bb$export$d5db989063a1308b)}/outgoing.mp3`;
/**
 * A smart collection containing a Set of active output devices.
 */ class $446fdaf403657943$export$2e2bcd8739ae039 {
    /**
     * @internal
     */ constructor(_name, _availableDevices, _beforeChange, _isSupported){
        this._name = _name;
        this._availableDevices = _availableDevices;
        this._beforeChange = _beforeChange;
        this._isSupported = _isSupported;
        /**
         * The currently active output devices.
         */ this._activeDevices = new Set();
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('OutputDeviceCollection');
    }
    /**
     * Delete a device from the collection. If no devices remain, the 'default'
     * device will be added as the sole device. If no `default` device exists,
     * the first available device will be used. On browsers without output
     * selection, the collection is left empty.
     * @param device - The device to delete from the collection
     * @returns whether the device was present before it was deleted
     */ delete(device) {
        this._log.debug('.delete', device);
        const wasDeleted = !!this._activeDevices.delete(device);
        // Without sink support _beforeChange rejects, and nothing can catch it.
        if (!this._isSupported) return wasDeleted;
        const defaultDevice = this._availableDevices.get('default') || Array.from(this._availableDevices.values())[0];
        if (!this._activeDevices.size && defaultDevice) this._activeDevices.add(defaultDevice);
        // Call _beforeChange so that the implementation can react when a device is
        // removed or lost.
        const deviceIds = Array.from(this._activeDevices.values()).map((deviceInfo)=>deviceInfo.deviceId);
        // Nothing can await a synchronous method. The wrapper also tolerates a
        // _beforeChange that returns a non-promise or throws.
        new Promise((resolve)=>{
            resolve(this._beforeChange(this._name, deviceIds));
        }).catch((reason)=>{
            this._log.warn(`Unable to update audio output devices. ${reason}`);
        });
        return wasDeleted;
    }
    /**
     * Get the current set of devices.
     */ get() {
        return this._activeDevices;
    }
    /**
     * Replace the current set of devices with a new set of devices.
     * @param deviceIdOrIds - An ID or array of IDs of devices to replace the existing devices with.
     * @returns Rejects if this feature is not supported, any of the supplied IDs are not found,
     * or no IDs are passed.
     */ set(deviceIdOrIds) {
        this._log.debug('.set', deviceIdOrIds);
        if (!this._isSupported) return Promise.reject(new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('This browser does not support audio output selection'));
        const deviceIds = Array.isArray(deviceIdOrIds) ? deviceIdOrIds : [
            deviceIdOrIds
        ];
        if (!deviceIds.length) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)('Must specify at least one device to set'));
        const missingIds = [];
        const devices = deviceIds.map((id)=>{
            const device = this._availableDevices.get(id);
            if (!device) missingIds.push(id);
            return device;
        });
        if (missingIds.length) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)(`Devices not found: ${missingIds.join(', ')}`));
        return new Promise((resolve)=>{
            resolve(this._beforeChange(this._name, deviceIds));
        }).then(()=>{
            this._activeDevices.clear();
            devices.forEach(this._activeDevices.add, this._activeDevices);
        });
    }
    /**
     * Test the devices by playing audio through them.
     * @param [soundUrl] - An optional URL. If none is specified, we will
     *   play a default test tone.
     * @returns Resolves with the result of the underlying HTMLAudioElements' play() calls.
     */ test(soundUrl = $446fdaf403657943$var$DEFAULT_TEST_SOUND_URL) {
        if (!this._isSupported) return Promise.reject(new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('This browser does not support audio output selection'));
        if (!this._activeDevices.size) return Promise.reject(new (0, $d122425987f9ca02$export$b251fc1661a3152d)('No active output devices to test'));
        return Promise.all(Array.from(this._activeDevices).map((device)=>{
            let el;
            // (rrowland) We need to wait for the oncanplay event because of a regression introduced
            // in Chrome M72: https://bugs.chromium.org/p/chromium/issues/detail?id=930876
            return new Promise((resolve)=>{
                el = new Audio(soundUrl);
                el.oncanplay = resolve;
            }).then(()=>el.setSinkId(device.deviceId).then(()=>el.play()));
        }));
    }
}


// @ts-nocheck
class $9f73265e90d58dbf$export$2e2bcd8739ae039 {
    constructor(options){
        Object.defineProperties(this, {
            deviceId: {
                get () {
                    return options.deviceId;
                }
            },
            groupId: {
                get () {
                    return options.groupId;
                }
            },
            kind: {
                get () {
                    return options.kind;
                }
            },
            label: {
                get () {
                    return options.label;
                }
            }
        });
    }
}


var $a96769417395afb9$exports = {};

$parcel$export($a96769417395afb9$exports, "average", () => $a96769417395afb9$export$cc6710ee5f037d57);
$parcel$export($a96769417395afb9$exports, "difference", () => $a96769417395afb9$export$acaf96a27438246b);
$parcel$export($a96769417395afb9$exports, "isElectron", () => $a96769417395afb9$export$f2f6a8999f8ebd30);
$parcel$export($a96769417395afb9$exports, "isChrome", () => $a96769417395afb9$export$6446a186d09e379e);
$parcel$export($a96769417395afb9$exports, "isFirefox", () => $a96769417395afb9$export$b7d78993b74f766d);
$parcel$export($a96769417395afb9$exports, "isLegacyEdge", () => $a96769417395afb9$export$e1183ffde9eeca17);
$parcel$export($a96769417395afb9$exports, "isSafari", () => $a96769417395afb9$export$95df08bae54cb4df);
$parcel$export($a96769417395afb9$exports, "queryToJson", () => $a96769417395afb9$export$f974f2dd97548511);
$parcel$export($a96769417395afb9$exports, "flatMap", () => $a96769417395afb9$export$5b8affa63fc6df16);
$parcel$export($a96769417395afb9$exports, "promisifyEvents", () => $a96769417395afb9$export$ac8784c501f5df0a);
$parcel$export($a96769417395afb9$exports, "sortByMimeTypes", () => $a96769417395afb9$export$7805aadce86aebbf);
$parcel$export($a96769417395afb9$exports, "Exception", () => $a96769417395afb9$export$e2f174de097e0bcd);
// @ts-nocheck
/**
 * Exception class.
 * @class
 * @name Exception
 * @exports Exception as Twilio.Exception
 * @memberOf Twilio
 * @param {string} message The exception message
 */ function $a96769417395afb9$var$TwilioException(message) {
    if (!(this instanceof $a96769417395afb9$var$TwilioException)) return new $a96769417395afb9$var$TwilioException(message);
    this.message = message;
}
/**
 * Returns the exception message.
 *
 * @return {string} The exception message.
 */ $a96769417395afb9$var$TwilioException.prototype.toString = function() {
    return `Twilio.Exception: ${this.message}`;
};
function $a96769417395afb9$export$cc6710ee5f037d57(values) {
    return values && values.length ? values.reduce((t, v)=>t + v) / values.length : 0;
}
function $a96769417395afb9$export$acaf96a27438246b(lefts, rights, getKey) {
    getKey = getKey || ((a)=>a);
    const rightKeys = new Set(rights.map(getKey));
    return lefts.filter((left)=>!rightKeys.has(getKey(left)));
}
function $a96769417395afb9$export$f2f6a8999f8ebd30(navigator) {
    return !!navigator.userAgent.match('Electron');
}
function $a96769417395afb9$export$6446a186d09e379e(window1, navigator) {
    const isCriOS = !!navigator.userAgent.match('CriOS');
    const isHeadlessChrome = !!navigator.userAgent.match('HeadlessChrome');
    const isGoogle = typeof window1.chrome !== 'undefined' && navigator.vendor === 'Google Inc.' && navigator.userAgent.indexOf('OPR') === -1 && navigator.userAgent.indexOf('Edge') === -1;
    return isCriOS || $a96769417395afb9$export$f2f6a8999f8ebd30(navigator) || isGoogle || isHeadlessChrome;
}
function $a96769417395afb9$export$b7d78993b74f766d(navigator) {
    navigator = navigator || (typeof window === 'undefined' ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === 'string' && /firefox|fxios/i.test(navigator.userAgent);
}
/**
 * Chromium-based Edge has a user-agent of "Edg/" where legacy Edge has a
 * user-agent of "Edge/".
 */ function $a96769417395afb9$export$e1183ffde9eeca17(navigator) {
    navigator = navigator || (typeof window === 'undefined' ? $parcel$global.navigator : window.navigator);
    return !!navigator && typeof navigator.userAgent === 'string' && /edge\/\d+/i.test(navigator.userAgent);
}
function $a96769417395afb9$export$95df08bae54cb4df(navigator) {
    return !!navigator.vendor && navigator.vendor.indexOf('Apple') !== -1 && navigator.userAgent && navigator.userAgent.indexOf('CriOS') === -1 && navigator.userAgent.indexOf('FxiOS') === -1;
}
function $a96769417395afb9$export$f974f2dd97548511(params) {
    if (!params) return '';
    return params.split('&').reduce((output, pair)=>{
        const parts = pair.split('=');
        const key = parts[0];
        const value = decodeURIComponent((parts[1] || '').replace(/\+/g, '%20'));
        if (key) output[key] = value;
        return output;
    }, {});
}
/**
 * Map a list to an array of arrays, and return the flattened result.
 * @param {Array<*>|Set<*>|Map<*>} list
 * @param {function(*): Array<*>} [mapFn]
 * @returns Array<*>
 */ function $a96769417395afb9$export$5b8affa63fc6df16(list, mapFn) {
    const listArray = list instanceof Map || list instanceof Set ? Array.from(list.values()) : list;
    mapFn = mapFn || ((item)=>item);
    return listArray.reduce((flattened, item)=>{
        const mapped = mapFn(item);
        return flattened.concat(mapped);
    }, []);
}
/**
 * Converts an EventEmitter's events into a promise and automatically
 * cleans up handlers once the promise is resolved or rejected.
 */ function $a96769417395afb9$export$ac8784c501f5df0a(emitter, resolveEventName, rejectEventName) {
    return new Promise((resolve, reject)=>{
        function resolveHandler() {
            emitter.removeListener(rejectEventName, rejectHandler);
            resolve();
        }
        function rejectHandler() {
            emitter.removeListener(resolveEventName, resolveHandler);
            reject();
        }
        emitter.once(resolveEventName, resolveHandler);
        emitter.once(rejectEventName, rejectHandler);
    });
}
function $a96769417395afb9$export$7805aadce86aebbf(codecs, preferredOrder) {
    const preferredCodecs = preferredOrder.map((codec)=>'audio/' + codec.toLowerCase());
    return codecs.sort((a, b)=>{
        const indexA = preferredCodecs.indexOf(a.mimeType.toLowerCase());
        const indexB = preferredCodecs.indexOf(b.mimeType.toLowerCase());
        const orderA = indexA >= 0 ? indexA : Number.MAX_VALUE;
        const orderB = indexB >= 0 ? indexB : Number.MAX_VALUE;
        return orderA - orderB;
    });
}
const $a96769417395afb9$export$e2f174de097e0bcd = $a96769417395afb9$var$TwilioException;


/**
 * Aliases for audio kinds, used for labelling.
 */ const $0188738af1717958$var$kindAliases = {
    audioinput: 'Audio Input',
    audiooutput: 'Audio Output'
};
/**
 * Provides input and output audio-based functionality in one convenient class.
 */ class $0188738af1717958$var$AudioHelper extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * The currently set audio constraints set by setAudioConstraints(). Starts as null.
     */ get audioConstraints() {
        return this._audioConstraints;
    }
    /**
     * The active input device. Having no inputDevice specified by `setInputDevice()`
     * will disable input selection related functionality.
     */ get inputDevice() {
        return this._inputDevice;
    }
    /**
     * The current input stream coming from the microphone device or
     * the processed audio stream if there is an {@link AudioProcessor}.
     */ get inputStream() {
        return this._localProcessedStream || this._selectedInputDeviceStream;
    }
    /**
     * The processed stream if a local {@link AudioProcessor} was previously added.
     * @deprecated Use {@link AudioHelper#localProcessedStream} instead.
     */ get processedStream() {
        this._log.warn('AudioHelper#processedStream is deprecated. Please use AudioHelper#localProcessedStream instead.');
        return this._localProcessedStream;
    }
    /**
     * The processed stream if a local {@link AudioProcessor} was previously added.
     */ get localProcessedStream() {
        return this._localProcessedStream;
    }
    /**
     * The processed stream if a remote {@link AudioProcessor} was previously added.
     */ get remoteProcessedStream() {
        return this._remoteProcessedStream;
    }
    /**
     * @internal
     * @param onActiveOutputsChanged - A callback to be called when the user changes the active output devices.
     * @param onActiveInputChanged - A callback to be called when the user changes the active input device.
     * @param [options]
     */ constructor(onActiveOutputsChanged, onActiveInputChanged, options){
        super();
        /**
         * A Map of all audio input devices currently available to the browser by their device ID.
         */ this.availableInputDevices = new Map();
        /**
         * A Map of all audio output devices currently available to the browser by their device ID.
         */ this.availableOutputDevices = new Map();
        /**
         * The currently set audio constraints set by setAudioConstraints().
         */ this._audioConstraints = null;
        /**
         * The audio stream of the default device.
         * This is populated when _openDefaultDeviceWithConstraints is called,
         * See _selectedInputDeviceStream for differences.
         * TODO: Combine these two workflows (3.x?)
         */ this._defaultInputDeviceStream = null;
        /**
         * Whether each sound is enabled.
         */ this._enabledSounds = {
            [(0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Disconnect]: true,
            [(0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Incoming]: true,
            [(0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Outgoing]: true
        };
        /**
         * The current input device.
         */ this._inputDevice = null;
        /**
         * The internal promise created when calling setInputDevice
         */ this._inputDevicePromise = null;
        /**
         * Whether the {@link AudioHelper} is currently polling the input stream's volume.
         */ this._isPollingInputVolume = false;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('AudioHelper');
        /**
         * Internal reference to the local processed stream.
         */ this._localProcessedStream = null;
        /**
         * Internal reference to the remote processed stream.
         */ this._remoteProcessedStream = null;
        /**
         * The selected input stream coming from the microphone device.
         * This is populated when the setInputDevice is called, meaning,
         * the end user manually selected it, which is different than
         * the defaultInputDeviceStream.
         * TODO: Combine these two workflows (3.x?)
         */ this._selectedInputDeviceStream = null;
        /**
         * A record of unknown devices (Devices without labels)
         */ this._unknownDeviceIndexes = {
            audioinput: {},
            audiooutput: {}
        };
        /**
         * Update the available input and output devices
         * @internal
         */ this._updateAvailableDevices = ()=>{
            if (!this._mediaDevices || !this._enumerateDevices) return Promise.reject('Enumeration not supported');
            return this._enumerateDevices().then((devices)=>{
                this._updateDevices(devices.filter((d)=>d.kind === 'audiooutput'), this.availableOutputDevices, this._removeLostOutput);
                this._updateDevices(devices.filter((d)=>d.kind === 'audioinput'), this.availableInputDevices, this._removeLostInput);
                const defaultDevice = this.availableOutputDevices.get('default') || Array.from(this.availableOutputDevices.values())[0];
                [
                    this.speakerDevices,
                    this.ringtoneDevices
                ].forEach((outputDevices)=>{
                    if (!outputDevices.get().size && this.availableOutputDevices.size && this.isOutputSelectionSupported) outputDevices.set(defaultDevice.deviceId).catch((reason)=>{
                        this._log.warn(`Unable to set audio output devices. ${reason}`);
                    });
                });
            });
        };
        /**
         * Remove an input device from inputs
         * @param lostDevice
         * @returns Whether the device was active
         */ this._removeLostInput = (lostDevice)=>{
            if (!this.inputDevice || this.inputDevice.deviceId !== lostDevice.deviceId) return false;
            this._destroyLocalProcessedStream();
            this._replaceStream(null);
            this._inputDevice = null;
            this._maybeStopPollingVolume();
            const defaultDevice = this.availableInputDevices.get('default') || Array.from(this.availableInputDevices.values())[0];
            if (defaultDevice) this.setInputDevice(defaultDevice.deviceId);
            return true;
        };
        /**
         * Remove an input device from outputs
         * @param lostDevice
         * @returns Whether the device was active
         */ this._removeLostOutput = (lostDevice)=>{
            const wasSpeakerLost = this.speakerDevices.delete(lostDevice);
            const wasRingtoneLost = this.ringtoneDevices.delete(lostDevice);
            return wasSpeakerLost || wasRingtoneLost;
        };
        options = Object.assign({
            AudioContext: typeof AudioContext !== 'undefined' && AudioContext,
            setSinkId: typeof HTMLAudioElement !== 'undefined' && HTMLAudioElement.prototype.setSinkId
        }, options);
        this._beforeSetInputDevice = options.beforeSetInputDevice || (()=>Promise.resolve());
        this._updateUserOptions(options);
        this._audioProcessorEventObserver = options.audioProcessorEventObserver;
        this._mediaDevices = options.mediaDevices || navigator.mediaDevices;
        this._onActiveInputChanged = onActiveInputChanged;
        this._enumerateDevices = typeof options.enumerateDevices === 'function' ? options.enumerateDevices : this._mediaDevices && this._mediaDevices.enumerateDevices.bind(this._mediaDevices);
        const isAudioContextSupported = !!(options.AudioContext || options.audioContext);
        const isEnumerationSupported = !!this._enumerateDevices;
        if (options.enabledSounds) this._enabledSounds = options.enabledSounds;
        const isSetSinkSupported = typeof options.setSinkId === 'function';
        this.isOutputSelectionSupported = isEnumerationSupported && isSetSinkSupported;
        this.isVolumeSupported = isAudioContextSupported;
        if (this.isVolumeSupported) {
            this._audioContext = options.audioContext || options.AudioContext && new options.AudioContext();
            if (this._audioContext) {
                this._inputVolumeAnalyser = this._audioContext.createAnalyser();
                this._inputVolumeAnalyser.fftSize = 32;
                this._inputVolumeAnalyser.smoothingTimeConstant = 0.3;
            }
        }
        this.ringtoneDevices = new (0, $446fdaf403657943$export$2e2bcd8739ae039)('ringtone', this.availableOutputDevices, onActiveOutputsChanged, this.isOutputSelectionSupported);
        this.speakerDevices = new (0, $446fdaf403657943$export$2e2bcd8739ae039)('speaker', this.availableOutputDevices, onActiveOutputsChanged, this.isOutputSelectionSupported);
        this.addListener('newListener', (eventName)=>{
            if (eventName === 'inputVolume') this._maybeStartPollingVolume();
        });
        this.addListener('removeListener', (eventName)=>{
            if (eventName === 'inputVolume') this._maybeStopPollingVolume();
        });
        this.once('newListener', ()=>{
            // NOTE (rrowland): Ideally we would only check isEnumerationSupported here, but
            //   in at least one browser version (Tested in FF48) enumerateDevices actually
            //   returns bad data for the listed devices. Instead, we check for
            //   isOutputSelectionSupported to avoid these quirks that may negatively affect customers.
            if (!this.isOutputSelectionSupported) this._log.warn('Warning: This browser does not support audio output selection.');
            if (!this.isVolumeSupported) this._log.warn(`Warning: This browser does not support Twilio's volume indicator feature.`);
        });
        if (isEnumerationSupported) this._initializeEnumeration();
        // NOTE (kchoy): Currently microphone permissions are not supported in firefox, and Safari V15 and older.
        // https://github.com/mozilla/standards-positions/issues/19#issuecomment-370158947
        // https://caniuse.com/permissions-api
        if (navigator && navigator.permissions && typeof navigator.permissions.query === 'function') navigator.permissions.query({
            name: 'microphone'
        }).then((microphonePermissionStatus)=>{
            if (microphonePermissionStatus.state !== 'granted') {
                const handleStateChange = ()=>{
                    this._updateAvailableDevices();
                    this._stopMicrophonePermissionListener();
                };
                microphonePermissionStatus.addEventListener('change', handleStateChange);
                this._microphonePermissionStatus = microphonePermissionStatus;
                this._onMicrophonePermissionStatusChanged = handleStateChange;
            }
        }).catch((reason)=>this._log.warn(`Warning: unable to listen for microphone permission changes. ${reason}`));
        else this._log.warn('Warning: current browser does not support permissions API.');
    }
    /**
     * Destroy this AudioHelper instance
     * @internal
     */ _destroy() {
        this._stopDefaultInputDeviceStream();
        this._stopSelectedInputDeviceStream();
        this._destroyLocalProcessedStream();
        this._destroyRemoteProcessedStream();
        this._maybeStopPollingVolume();
        this.removeAllListeners();
        this._stopMicrophonePermissionListener();
        this._unbind();
    }
    /**
     * Destroys the remote processed stream and updates references.
     * @internal
     */ _destroyRemoteProcessedStream() {
        if (this._remoteProcessor && this._remoteProcessedStream) {
            this._log.info('destroying remote processed stream');
            const remoteProcessedStream = this._remoteProcessedStream;
            this._remoteProcessedStream.getTracks().forEach((track)=>track.stop());
            this._remoteProcessedStream = null;
            this._remoteProcessor.destroyProcessedStream(remoteProcessedStream);
            this._audioProcessorEventObserver.emit('destroy', true);
        }
    }
    /**
     * Promise to wait for the input device, if setInputDevice is called outside of the SDK.
     * @internal
     */ _getInputDevicePromise() {
        return this._inputDevicePromise;
    }
    /**
     * The current AudioProcessorEventObserver instance.
     * @internal
     */ _getAudioProcessorEventObserver() {
        return this._audioProcessorEventObserver;
    }
    /**
     * Route remote stream to the processor if it exists.
     * @internal
     */ _maybeCreateRemoteProcessedStream(stream) {
        if (this._remoteProcessor) {
            this._log.info('Creating remote processed stream');
            return this._remoteProcessor.createProcessedStream(stream).then((processedStream)=>{
                this._remoteProcessedStream = processedStream;
                this._audioProcessorEventObserver.emit('create', true);
                return this._remoteProcessedStream;
            });
        }
        return Promise.resolve(stream);
    }
    /**
     * Start polling volume if it's supported and there's an input stream to poll.
     * @internal
     */ _maybeStartPollingVolume() {
        if (!this.isVolumeSupported || !this.inputStream) return;
        this._updateVolumeSource();
        if (this._isPollingInputVolume || !this._inputVolumeAnalyser) return;
        const bufferLength = this._inputVolumeAnalyser.frequencyBinCount;
        const buffer = new Uint8Array(bufferLength);
        this._isPollingInputVolume = true;
        const emitVolume = ()=>{
            if (!this._isPollingInputVolume) return;
            if (this._inputVolumeAnalyser) {
                this._inputVolumeAnalyser.getByteFrequencyData(buffer);
                const inputVolume = (0, $a96769417395afb9$export$cc6710ee5f037d57)(buffer);
                this.emit('inputVolume', inputVolume / 255);
            }
            requestAnimationFrame(emitVolume);
        };
        requestAnimationFrame(emitVolume);
    }
    /**
     * Stop polling volume if it's currently polling and there are no listeners.
     * @internal
     */ _maybeStopPollingVolume() {
        if (!this.isVolumeSupported) return;
        if (!this._isPollingInputVolume || this.inputStream && this.listenerCount('inputVolume')) return;
        if (this._inputVolumeSource) {
            this._inputVolumeSource.disconnect();
            delete this._inputVolumeSource;
        }
        this._isPollingInputVolume = false;
    }
    /**
     * Call getUserMedia with specified constraints
     * @internal
     */ _openDefaultDeviceWithConstraints(constraints) {
        this._log.info('Opening default device with constraints', constraints);
        return this._getUserMedia(constraints).then((stream)=>{
            this._log.info('Opened default device. Updating available devices.');
            // Ensures deviceId's and labels are populated after the gUM call
            // by calling enumerateDevices
            this._updateAvailableDevices().catch((error)=>{
                // Ignore error, we don't want to break the call flow
                this._log.warn('Unable to updateAvailableDevices after gUM call', error);
            });
            this._defaultInputDeviceStream = stream;
            return this._maybeCreateLocalProcessedStream(stream);
        });
    }
    /**
     * Stop the default audio stream
     * @internal
     */ _stopDefaultInputDeviceStream() {
        if (this._defaultInputDeviceStream) {
            this._log.info('stopping default device stream');
            this._defaultInputDeviceStream.getTracks().forEach((track)=>track.stop());
            this._defaultInputDeviceStream = null;
            this._destroyLocalProcessedStream();
        }
    }
    /**
     * Unbind the listeners from mediaDevices.
     * @internal
     */ _unbind() {
        var _a;
        if ((_a = this._mediaDevices) === null || _a === void 0 ? void 0 : _a.removeEventListener) this._mediaDevices.removeEventListener('devicechange', this._updateAvailableDevices);
    }
    /**
     * Update AudioHelper options that can be changed by the user
     * @internal
     */ _updateUserOptions(options) {
        if (typeof options.enumerateDevices === 'function') this._enumerateDevices = options.enumerateDevices;
        if (typeof options.getUserMedia === 'function') this._getUserMedia = options.getUserMedia;
    }
    /**
     * Adds an {@link AudioProcessor} object and returns a Promise representing the result.
     * To add a remote AudioProcessor, pass `true`. To add a local AudioProcessor, pass `false`.
     * The default value is `false`.
     *
     * If `isRemote` is `false`, the AudioHelper routes the input audio stream through the
     * processor before sending the audio stream to Twilio. If `isRemote` is `true`, the AudioHelper
     * routes the output audio stream through the processor before playing it on the speaker.
     *
     * See the {@link AudioProcessor} interface for an example.
     *
     * @param processor The AudioProcessor to add.
     * @param isRemote If set to true, the processor will be applied to the remote
     * audio track. Default value is false.
     * @returns
     */ addProcessor(processor, isRemote = false) {
        this._log.debug('.addProcessor');
        if (this._localProcessor && !isRemote) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('Can only have one Local AudioProcessor at a time.');
        if (this._remoteProcessor && isRemote) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('Can only have one Remote AudioProcessor at a time.');
        if (typeof processor !== 'object' || processor === null) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Missing AudioProcessor argument.');
        if (typeof processor.createProcessedStream !== 'function') throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Missing createProcessedStream() method.');
        if (typeof processor.destroyProcessedStream !== 'function') throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Missing destroyProcessedStream() method.');
        if (isRemote) {
            this._remoteProcessor = processor;
            this._audioProcessorEventObserver.emit('add', true);
            return Promise.resolve();
        } else {
            this._localProcessor = processor;
            this._audioProcessorEventObserver.emit('add', false);
            return this._restartInputStreams();
        }
    }
    /**
     * Enable or disable the disconnect sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ disconnect(doEnable) {
        this._log.debug('.disconnect', doEnable);
        return this._maybeEnableSound((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Disconnect, doEnable);
    }
    /**
     * Enable or disable the incoming sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ incoming(doEnable) {
        this._log.debug('.incoming', doEnable);
        return this._maybeEnableSound((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Incoming, doEnable);
    }
    /**
     * Enable or disable the outgoing sound.
     * @param doEnable Passing `true` will enable the sound and `false` will disable the sound.
     * Not passing this parameter will not alter the enable-status of the sound.
     * @returns The enable-status of the sound.
     */ outgoing(doEnable) {
        this._log.debug('.outgoing', doEnable);
        return this._maybeEnableSound((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Outgoing, doEnable);
    }
    /**
     * Removes an {@link AudioProcessor} and returns a Promise representing the result.
     * To remove a remote AudioProcessor, pass `true`. To remove a local AudioProcessor,
     * pass `false`. The default value is `false`.
     *
     * If `isRemote` is `false`, the AudioHelper uses the audio stream from the selected
     * input device for existing or future calls. If `isRemote` is `true`, the AudioHelper
     * uses the audio stream from the selected output device for existing or future calls.
     *
     * @param processor The AudioProcessor to remove.
     * @param isRemote If set to true, the processor will be removed from the remote
     * audio track. Default value is false.
     * @returns
     */ removeProcessor(processor, isRemote = false) {
        this._log.debug('.removeProcessor');
        if (typeof processor !== 'object' || processor === null) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Missing AudioProcessor argument.');
        if (this._localProcessor !== processor && !isRemote) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Cannot remove a Local AudioProcessor that has not been previously added.');
        if (this._remoteProcessor !== processor && isRemote) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Cannot remove a Remote AudioProcessor that has not been previously added.');
        if (isRemote) {
            this._destroyRemoteProcessedStream();
            this._remoteProcessor = null;
            this._audioProcessorEventObserver.emit('remove', true);
            return Promise.resolve();
        } else {
            this._destroyLocalProcessedStream();
            this._localProcessor = null;
            this._audioProcessorEventObserver.emit('remove', false);
            return this._restartInputStreams();
        }
    }
    /**
     * Set the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. Any deviceId specified here will be ignored. Instead, device IDs should
     * be specified using {@link AudioHelper#setInputDevice}. The returned Promise resolves
     * when the media is successfully reacquired, or immediately if no input device is set.
     * @param audioConstraints - The MediaTrackConstraints to apply.
     */ setAudioConstraints(audioConstraints) {
        this._log.debug('.setAudioConstraints', audioConstraints);
        this._audioConstraints = Object.assign({}, audioConstraints);
        delete this._audioConstraints.deviceId;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     *
     * Calling `setInputDevice` sets the stream for current and future calls and
     * will not release it automatically.
     *
     * While this behavior is not an issue, it will result in the application
     * holding onto the input device, and the application may show a red
     * "recording" symbol in the browser tab.
     *
     * To remove the red "recording" symbol, the device must be released. To
     * release it, call `unsetInputDevice` after the call disconnects. Note that
     * after calling `unsetInputDevice` future calls will then use the default
     * input device.
     *
     * Consider application logic that keeps track of the user-selected device
     * and call `setInputDevice` before calling `device.connect()` for outgoing
     * calls and `call.accept()` for incoming calls. Furthermore, consider
     * calling `unsetInputDevice` once a call is disconnected. Below is an
     * example:
     *
     * ```ts
     * import { Device } from '@twilio/voice-sdk';
     * let inputDeviceId = ...;
     * const device = new Device(...);
     *
     * async function makeOutgoingCall() {
     *   await device.audio.setInputDevice(inputDeviceId);
     *   const call = await device.connect(...);
     *
     *   call.on('disconnect', async () => {
     *     inputDeviceId = ... // save the current input device id
     *     await device.audio.unsetInputDevice();
     *   });
     * }
     *
     * async function acceptIncomingCall(incomingCall) {
     *   await device.audio.setInputDevice(inputDeviceId);
     *   await incomingCall.accept();
     *
     *   incomingCall.on('disconnect', async () => {
     *     inputDeviceId = ... // save the current input device id
     *     await device.audio.unsetInputDevice();
     *   });
     * }
     * ```
     *
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     */ setInputDevice(deviceId) {
        this._log.debug('.setInputDevice', deviceId);
        return this._setInputDevice(deviceId, false);
    }
    /**
     * Unset the MediaTrackConstraints to be applied on every getUserMedia call for new input
     * device audio. The returned Promise resolves when the media is successfully reacquired,
     * or immediately if no input device is set.
     */ unsetAudioConstraints() {
        this._log.debug('.unsetAudioConstraints');
        this._audioConstraints = null;
        return this.inputDevice ? this._setInputDevice(this.inputDevice.deviceId, true) : Promise.resolve();
    }
    /**
     * Unset the input device, stopping the tracks. This should only be called when not in a connection, and
     *   will not allow removal of the input device during a live call.
     */ unsetInputDevice() {
        this._log.debug('.unsetInputDevice', this.inputDevice);
        if (!this.inputDevice) return Promise.resolve();
        this._destroyLocalProcessedStream();
        return this._onActiveInputChanged(null).then(()=>{
            this._replaceStream(null);
            this._inputDevice = null;
            this._maybeStopPollingVolume();
        });
    }
    /**
     * Destroys the local processed stream and updates references.
     */ _destroyLocalProcessedStream() {
        if (this._localProcessor && this._localProcessedStream) {
            this._log.info('destroying local processed stream');
            const localProcessedStream = this._localProcessedStream;
            this._localProcessedStream.getTracks().forEach((track)=>track.stop());
            this._localProcessedStream = null;
            this._localProcessor.destroyProcessedStream(localProcessedStream);
            this._audioProcessorEventObserver.emit('destroy', false);
        }
    }
    /**
     * Get the index of an un-labeled Device.
     * @param mediaDeviceInfo
     * @returns The index of the passed MediaDeviceInfo
     */ _getUnknownDeviceIndex(mediaDeviceInfo) {
        const id = mediaDeviceInfo.deviceId;
        const kind = mediaDeviceInfo.kind;
        let index = this._unknownDeviceIndexes[kind][id];
        if (!index) {
            index = Object.keys(this._unknownDeviceIndexes[kind]).length + 1;
            this._unknownDeviceIndexes[kind][id] = index;
        }
        return index;
    }
    /**
     * Initialize output device enumeration.
     */ _initializeEnumeration() {
        if (!this._mediaDevices || !this._enumerateDevices) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('Enumeration is not supported');
        if (this._mediaDevices.addEventListener) this._mediaDevices.addEventListener('devicechange', this._updateAvailableDevices);
        this._updateAvailableDevices().then(()=>{
            if (!this.isOutputSelectionSupported) return;
            Promise.all([
                this.speakerDevices.set('default'),
                this.ringtoneDevices.set('default')
            ]).catch((reason)=>{
                this._log.warn(`Warning: Unable to set audio output devices. ${reason}`);
            });
        });
    }
    /**
     * Route local stream to the processor if it exists.
     */ _maybeCreateLocalProcessedStream(stream) {
        if (this._localProcessor) {
            this._log.info('Creating local processed stream');
            return this._localProcessor.createProcessedStream(stream).then((processedStream)=>{
                this._localProcessedStream = processedStream;
                this._audioProcessorEventObserver.emit('create', false);
                return this._localProcessedStream;
            });
        }
        return Promise.resolve(stream);
    }
    /**
     * Set whether the sound is enabled or not
     * @param soundName
     * @param doEnable
     * @returns Whether the sound is enabled or not
     */ _maybeEnableSound(soundName, doEnable) {
        if (typeof doEnable !== 'undefined') this._enabledSounds[soundName] = doEnable;
        return this._enabledSounds[soundName];
    }
    /**
     * Stop the tracks on the current input stream before replacing it with the passed stream.
     * @param stream - The new stream
     */ _replaceStream(stream) {
        this._log.info('Replacing with new stream.');
        if (this._selectedInputDeviceStream) {
            this._log.info('Old stream detected. Stopping tracks.');
            this._stopSelectedInputDeviceStream();
        }
        this._selectedInputDeviceStream = stream;
    }
    /**
     * Restart the active input streams
     */ _restartInputStreams() {
        if (this.inputDevice && this._selectedInputDeviceStream) {
            this._log.info('Restarting selected input device');
            return this._setInputDevice(this.inputDevice.deviceId, true);
        }
        if (this._defaultInputDeviceStream) {
            const defaultDevice = this.availableInputDevices.get('default') || Array.from(this.availableInputDevices.values())[0];
            this._log.info('Restarting default input device, now becoming selected.');
            return this._setInputDevice(defaultDevice.deviceId, true);
        }
        return Promise.resolve();
    }
    /**
     * Replace the current input device with a new device by ID.
     * @param deviceId - An ID of a device to replace the existing
     *   input device with.
     * @param forceGetUserMedia - If true, getUserMedia will be called even if
     *   the specified device is already active.
     */ _setInputDevice(deviceId, forceGetUserMedia) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const setInputDevice = ()=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                    yield this._beforeSetInputDevice();
                    if (typeof deviceId !== 'string') return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)('Must specify the device to set'));
                    const device = this.availableInputDevices.get(deviceId);
                    if (!device) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)(`Device not found: ${deviceId}`));
                    this._log.info('Setting input device. ID: ' + deviceId);
                    if (this._inputDevice && this._inputDevice.deviceId === deviceId && this._selectedInputDeviceStream) {
                        if (!forceGetUserMedia) return Promise.resolve();
                        // If the currently active track is still in readyState `live`, gUM may return the same track
                        // rather than returning a fresh track.
                        this._log.info('Same track detected on setInputDevice, stopping old tracks.');
                        this._stopSelectedInputDeviceStream();
                    }
                    // Release the default device in case it was created previously
                    this._stopDefaultInputDeviceStream();
                    const constraints = {
                        audio: Object.assign({
                            deviceId: {
                                exact: deviceId
                            }
                        }, this.audioConstraints)
                    };
                    this._log.info('setInputDevice: getting new tracks.');
                    return this._getUserMedia(constraints).then((originalStream)=>{
                        this._destroyLocalProcessedStream();
                        return this._maybeCreateLocalProcessedStream(originalStream).then((newStream)=>{
                            this._log.info('setInputDevice: invoking _onActiveInputChanged.');
                            return this._onActiveInputChanged(newStream).then(()=>{
                                this._replaceStream(originalStream);
                                this._inputDevice = device;
                                this._maybeStartPollingVolume();
                            });
                        });
                    });
                });
            return this._inputDevicePromise = setInputDevice().finally(()=>{
                this._inputDevicePromise = null;
            });
        });
    }
    /**
     * Remove event listener for microphone permissions
     */ _stopMicrophonePermissionListener() {
        var _a;
        if ((_a = this._microphonePermissionStatus) === null || _a === void 0 ? void 0 : _a.removeEventListener) this._microphonePermissionStatus.removeEventListener('change', this._onMicrophonePermissionStatusChanged);
    }
    /**
     * Stop the selected audio stream
     */ _stopSelectedInputDeviceStream() {
        if (this._selectedInputDeviceStream) {
            this._log.info('Stopping selected device stream');
            this._selectedInputDeviceStream.getTracks().forEach((track)=>track.stop());
        }
    }
    /**
     * Update a set of devices.
     * @param updatedDevices - An updated list of available Devices
     * @param availableDevices - The previous list of available Devices
     * @param removeLostDevice - The method to call if a previously available Device is
     *   no longer available.
     */ _updateDevices(updatedDevices, availableDevices, removeLostDevice) {
        const updatedDeviceIds = updatedDevices.map((d)=>d.deviceId);
        const knownDeviceIds = Array.from(availableDevices.values()).map((d)=>d.deviceId);
        const lostActiveDevices = [];
        // Remove lost devices
        const lostDeviceIds = (0, $a96769417395afb9$export$acaf96a27438246b)(knownDeviceIds, updatedDeviceIds);
        lostDeviceIds.forEach((lostDeviceId)=>{
            const lostDevice = availableDevices.get(lostDeviceId);
            if (lostDevice) {
                availableDevices.delete(lostDeviceId);
                if (removeLostDevice(lostDevice)) lostActiveDevices.push(lostDevice);
            }
        });
        // Add any new devices, or devices with updated labels
        let deviceChanged = false;
        updatedDevices.forEach((newDevice)=>{
            const existingDevice = availableDevices.get(newDevice.deviceId);
            const newMediaDeviceInfo = this._wrapMediaDeviceInfo(newDevice);
            if (!existingDevice || existingDevice.label !== newMediaDeviceInfo.label) {
                availableDevices.set(newDevice.deviceId, newMediaDeviceInfo);
                deviceChanged = true;
            }
        });
        if (deviceChanged || lostDeviceIds.length) {
            // Force a new gUM in case the underlying tracks of the active stream have changed. One
            //   reason this might happen is when `default` is selected and set to a USB device,
            //   then that device is unplugged or plugged back in. We can't check for the 'ended'
            //   event or readyState because it is asynchronous and may take upwards of 5 seconds,
            //   in my testing. (rrowland)
            const defaultId = 'default';
            // this.inputDevice is not null if audio.setInputDevice() was explicitly called
            const isInputDeviceSet = this.inputDevice && this.inputDevice.deviceId === defaultId;
            // If this.inputDevice is null, and default stream is not null, it means
            // the user is using the default stream and did not explicitly call audio.setInputDevice()
            const isDefaultDeviceSet = this._defaultInputDeviceStream && this.availableInputDevices.get(defaultId);
            if (isInputDeviceSet || isDefaultDeviceSet) {
                this._log.warn(`Calling getUserMedia after device change to ensure that the \
          tracks of the active device (default) have not gone stale.`);
                // NOTE(csantos): Updating the stream in the same execution context as the devicechange event
                // causes the new gUM call to fail silently. Meaning, the gUM call may succeed,
                // but it won't actually update the stream. We need to update the stream in a different
                // execution context (setTimeout) to properly update the stream.
                setTimeout(()=>{
                    this._setInputDevice(defaultId, true);
                }, 0);
            }
            this._log.debug('#deviceChange', lostActiveDevices);
            this.emit('deviceChange', lostActiveDevices);
        }
    }
    /**
     * Disconnect the old input volume source, and create and connect a new one with the current
     * input stream.
     */ _updateVolumeSource() {
        if (!this.inputStream || !this._audioContext || !this._inputVolumeAnalyser) return;
        if (this._inputVolumeSource) this._inputVolumeSource.disconnect();
        try {
            this._inputVolumeSource = this._audioContext.createMediaStreamSource(this.inputStream);
            this._inputVolumeSource.connect(this._inputVolumeAnalyser);
        } catch (ex) {
            this._log.warn('Unable to update volume source', ex);
            delete this._inputVolumeSource;
        }
    }
    /**
     * Convert a MediaDeviceInfo to a IMediaDeviceInfoShim.
     * @param mediaDeviceInfo - The info to convert
     * @returns The converted shim
     */ _wrapMediaDeviceInfo(mediaDeviceInfo) {
        const options = {
            deviceId: mediaDeviceInfo.deviceId,
            groupId: mediaDeviceInfo.groupId,
            kind: mediaDeviceInfo.kind,
            label: mediaDeviceInfo.label
        };
        if (!options.label) {
            if (options.deviceId === 'default') options.label = 'Default';
            else {
                const index = this._getUnknownDeviceIndex(mediaDeviceInfo);
                options.label = `Unknown ${$0188738af1717958$var$kindAliases[options.kind]} Device ${index}`;
            }
        }
        return new (0, $9f73265e90d58dbf$export$2e2bcd8739ae039)(options);
    }
}
$0188738af1717958$var$AudioHelper || ($0188738af1717958$var$AudioHelper = {});
var $0188738af1717958$export$2e2bcd8739ae039 = $0188738af1717958$var$AudioHelper;




/**
 * AudioProcessorEventObserver observes {@link AudioProcessor}
 * related operations and re-emits them as generic events.
 * @internal
 */ class $67b4c632a6f4c3e5$export$a191d984ff946270 extends (0, $5440e9199a418654$exports.EventEmitter) {
    constructor(){
        super();
        this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('AudioProcessorEventObserver');
        this._log.info('Creating AudioProcessorEventObserver instance');
        this.on('enabled', (isRemote)=>this._reEmitEvent('enabled', isRemote));
        this.on('add', (isRemote)=>this._reEmitEvent('add', isRemote));
        this.on('remove', (isRemote)=>this._reEmitEvent('remove', isRemote));
        this.on('create', (isRemote)=>this._reEmitEvent('create-processed-stream', isRemote));
        this.on('destroy', (isRemote)=>this._reEmitEvent('destroy-processed-stream', isRemote));
    }
    destroy() {
        this.removeAllListeners();
    }
    _reEmitEvent(name, isRemote) {
        this._log.info(`${isRemote ? 'Remote' : 'Local'} AudioProcessor:${name}`);
        this.emit('event', {
            name: name,
            group: 'audio-processor',
            isRemote: isRemote
        });
    }
}





/**
 * A Map of DTMF Sound Names to their mock frequency pairs.
 */ const $94bc609c95f1b695$var$bandFrequencies = {
    dtmf0: [
        1360,
        960
    ],
    dtmf1: [
        1230,
        720
    ],
    dtmf2: [
        1360,
        720
    ],
    dtmf3: [
        1480,
        720
    ],
    dtmf4: [
        1230,
        790
    ],
    dtmf5: [
        1360,
        790
    ],
    dtmf6: [
        1480,
        790
    ],
    dtmf7: [
        1230,
        870
    ],
    dtmf8: [
        1360,
        870
    ],
    dtmf9: [
        1480,
        870
    ],
    dtmfh: [
        1480,
        960
    ],
    dtmfs: [
        1230,
        960
    ]
};
class $94bc609c95f1b695$export$2e2bcd8739ae039 {
    constructor(_context){
        this._context = _context;
        /**
         * Gain nodes, reducing the frequency.
         */ this._gainNodes = [];
        this._gainNodes = [
            this._context.createGain(),
            this._context.createGain()
        ];
        this._gainNodes.forEach((gainNode)=>{
            gainNode.connect(this._context.destination);
            gainNode.gain.value = 0.1;
            this._gainNodes.push(gainNode);
        });
    }
    cleanup() {
        this._gainNodes.forEach((gainNode)=>{
            gainNode.disconnect();
        });
    }
    /**
     * Play the dual frequency tone for the passed DTMF name.
     * @param sound
     */ play(sound) {
        const frequencies = $94bc609c95f1b695$var$bandFrequencies[sound];
        if (!frequencies) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Invalid DTMF sound name');
        const oscillators = [
            this._context.createOscillator(),
            this._context.createOscillator()
        ];
        oscillators.forEach((oscillator, i)=>{
            oscillator.type = 'sine';
            oscillator.frequency.value = frequencies[i];
            oscillator.connect(this._gainNodes[i]);
            oscillator.start();
            oscillator.stop(this._context.currentTime + 0.1);
            oscillator.addEventListener('ended', ()=>oscillator.disconnect());
        });
    }
}





// @ts-nocheck
function $8c8e55dcbd1a20b8$var$request(method, params, callback) {
    const body = JSON.stringify(params.body || {});
    const headers = new Headers();
    params.headers = params.headers || [];
    Object.entries(params.headers).forEach(([headerName, headerBody])=>headers.append(headerName, headerBody));
    fetch(params.url, {
        body: body,
        headers: headers,
        method: method
    }).then((response)=>response.text(), callback).then((responseText)=>callback(null, responseText), callback);
}
/**
 * Use XMLHttpRequest to get a network resource.
 * @param {String} method - HTTP Method
 * @param {Object} params - Request parameters
 * @param {String} params.url - URL of the resource
 * @param {Array}  params.headers - An array of headers to pass [{ headerName : headerBody }]
 * @param {Object} params.body - A JSON body to send to the resource
 * @returns {response}
 */ const $8c8e55dcbd1a20b8$export$2e2bcd8739ae039 = $8c8e55dcbd1a20b8$var$request;
/**
 * Sugar function for request('GET', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~get} callback - The callback that handles the response.
 */ $8c8e55dcbd1a20b8$export$2e2bcd8739ae039.get = function get(params, callback) {
    return new this('GET', params, callback);
};
/**
 * Sugar function for request('POST', params, callback);
 * @param {Object} params - Request parameters
 * @param {Request~post} callback - The callback that handles the response.
 */ $8c8e55dcbd1a20b8$export$2e2bcd8739ae039.post = function post(params, callback) {
    return new this('POST', params, callback);
};


// @ts-nocheck
/**
 * Builds Endpoint Analytics (EA) event payloads and sends them to
 *   the EA server.
 * @constructor
 * @param {String} productName - Name of the product publishing events.
 * @param {String} token - The JWT token to use to authenticate with
 *   the EA server.
 * @param {EventPublisher.Options} options
 * @property {Boolean} isEnabled - Whether or not this publisher is publishing
 *   to the server. Currently ignores the request altogether, in the future this
 *   may store them in case publishing is re-enabled later. Defaults to true.
 */ /**
 * @typedef {Object} EventPublisher.Options
 * @property {Object} [metadata=undefined] - A publisher_metadata object to send
 *   with each payload.
 * @property {String} [host='eventgw.twilio.com'] - The host address of the EA
 *   server to publish to.
 * @property {Object|Function} [defaultPayload] - A default payload to extend
 *   when creating and sending event payloads. Also takes a function that
 *   should return an object representing the default payload. This is
 *   useful for fields that should always be present when they are
 *   available, but are not always available.
 */ class $147f3090e577bd9e$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    constructor(productName, token, options){
        super();
        if (!(this instanceof $147f3090e577bd9e$export$2e2bcd8739ae039)) return new $147f3090e577bd9e$export$2e2bcd8739ae039(productName, token, options);
        // Apply default options
        options = Object.assign({
            defaultPayload () {
                return {};
            }
        }, options);
        let defaultPayload = options.defaultPayload;
        if (typeof defaultPayload !== 'function') defaultPayload = ()=>Object.assign({}, options.defaultPayload);
        let isEnabled = true;
        const metadata = Object.assign({
            app_name: undefined,
            app_version: undefined
        }, options.metadata);
        Object.defineProperties(this, {
            _defaultPayload: {
                value: defaultPayload
            },
            _host: {
                value: options.host,
                writable: true
            },
            _isEnabled: {
                get () {
                    return isEnabled;
                },
                set (_isEnabled) {
                    isEnabled = _isEnabled;
                }
            },
            _log: {
                value: new (0, $596211e588505f95$export$2e2bcd8739ae039)('EventPublisher')
            },
            _request: {
                value: options.request || (0, $8c8e55dcbd1a20b8$export$2e2bcd8739ae039),
                writable: true
            },
            _token: {
                value: token,
                writable: true
            },
            isEnabled: {
                enumerable: true,
                get () {
                    return isEnabled;
                }
            },
            metadata: {
                enumerable: true,
                get () {
                    return metadata;
                }
            },
            productName: {
                enumerable: true,
                value: productName
            },
            token: {
                enumerable: true,
                get () {
                    return this._token;
                }
            }
        });
    }
}
/**
 * Post to an EA server.
 * @private
 * @param {String} endpointName - Endpoint to post the event to
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @param {?Boolean} [force=false] - Whether or not to send this even if
 *    publishing is disabled.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype._post = function _post(endpointName, level, group, name, payload, connection, force) {
    if (!this.isEnabled && !force || !this._host) {
        this._log.debug('Publishing cancelled', JSON.stringify({
            isEnabled: this.isEnabled,
            force: force,
            host: this._host
        }));
        return Promise.resolve();
    }
    if (!connection || (!connection.parameters || !connection.parameters.CallSid) && !connection.outboundConnectionId) {
        if (!connection) this._log.debug('Publishing cancelled. Missing connection object');
        else this._log.debug('Publishing cancelled. Missing connection info', JSON.stringify({
            outboundConnectionId: connection.outboundConnectionId,
            parameters: connection.parameters
        }));
        return Promise.resolve();
    }
    const event = {
        group: group,
        level: level.toUpperCase(),
        name: name,
        payload: payload && payload.forEach ? payload.slice(0) : Object.assign(this._defaultPayload(connection), payload),
        payload_type: 'application/json',
        private: false,
        publisher: this.productName,
        timestamp: new Date().toISOString()
    };
    if (this.metadata) event.publisher_metadata = this.metadata;
    if (endpointName === 'EndpointEvents') this._log.debug('Publishing insights', JSON.stringify({
        endpointName: endpointName,
        event: event,
        force: force,
        host: this._host
    }));
    const requestParams = {
        body: event,
        headers: {
            'Content-Type': 'application/json',
            'X-Twilio-Token': this.token
        },
        url: `https://${this._host}/v4/${endpointName}`
    };
    return new Promise((resolve, reject)=>{
        this._request.post(requestParams, (err)=>{
            if (err) {
                this.emit('error', err);
                reject(err);
            } else resolve();
        });
    }).catch((e)=>{
        this._log.error(`Unable to post ${group} ${name} event to Insights. Received error: ${e}`);
    });
};
/**
 * Post an event to the EA server. Use this method when the level
 *  is dynamic. Otherwise, it's better practice to use the sugar
 *  methods named for the specific level.
 * @param {String} level - ['debug', 'info', 'warning', 'error']
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.post = function post(level, group, name, payload, connection, force) {
    return this._post('EndpointEvents', level, group, name, payload, connection, force);
};
/**
 * Post a debug-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.debug = function debug(group, name, payload, connection) {
    return this.post('debug', group, name, payload, connection);
};
/**
 * Post an info-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.info = function info(group, name, payload, connection) {
    return this.post('info', group, name, payload, connection);
};
/**
 * Post a warning-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.warn = function warn(group, name, payload, connection) {
    return this.post('warning', group, name, payload, connection);
};
/**
 * Post an error-level event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {?Object} [payload=null] - The payload to pass. This will be extended
 *    onto the default payload object, if one exists.
 * @param {?Connection} [connection=null] - The {@link Connection} which is posting this payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.error = function error(group, name, payload, connection) {
    return this.post('error', group, name, payload, connection);
};
/**
 * Post a metrics event to the EA server.
 * @param {String} group - The name of the group the event belongs to.
 * @param {String} name - The designated event name.
 * @param {Array<Object>} metrics - The metrics to post.
 * @param {?Object} [customFields] - Custom fields to append to each payload.
 * @returns {Promise} Fulfilled if the HTTP response is 20x.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.postMetrics = function postMetrics(group, name, metrics, customFields, connection) {
    return new Promise((resolve)=>{
        const samples = metrics.map($147f3090e577bd9e$var$formatMetric).map((sample)=>Object.assign(sample, customFields));
        resolve(this._post('EndpointMetrics', 'info', group, name, samples, connection));
    });
};
/**
 * Update the host address of the insights server to publish to.
 * @param {String} host - The new host address of the insights server.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.setHost = function setHost(host) {
    this._host = host;
};
/**
 * Update the token to use to authenticate requests.
 * @param {string} token
 * @returns {void}
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.setToken = function setToken(token) {
    this._token = token;
};
/**
 * Enable the publishing of events.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.enable = function enable() {
    this._isEnabled = true;
};
/**
 * Disable the publishing of events.
 */ $147f3090e577bd9e$export$2e2bcd8739ae039.prototype.disable = function disable() {
    this._isEnabled = false;
};
function $147f3090e577bd9e$var$formatMetric(sample) {
    return {
        audio_codec: sample.codecName,
        audio_level_in: sample.audioInputLevel,
        audio_level_out: sample.audioOutputLevel,
        bytes_received: sample.bytesReceived,
        bytes_sent: sample.bytesSent,
        call_volume_input: sample.inputVolume,
        call_volume_output: sample.outputVolume,
        jitter: sample.jitter,
        mos: sample.mos && Math.round(sample.mos * 100) / 100,
        packets_lost: sample.packetsLost,
        packets_lost_fraction: sample.packetsLostFraction && Math.round(sample.packetsLostFraction * 100) / 100,
        packets_received: sample.packetsReceived,
        rtt: sample.rtt,
        timestamp: new Date(sample.timestamp).toISOString(),
        total_bytes_received: sample.totals.bytesReceived,
        total_bytes_sent: sample.totals.bytesSent,
        total_packets_lost: sample.totals.packetsLost,
        total_packets_received: sample.totals.packetsReceived,
        total_packets_sent: sample.totals.packetsSent
    };
}










// @ts-nocheck
/**
 * This file was imported from another project. If making changes to this file, please don't
 * make them here. Make them on the linked repo below, then copy back:
 * https://code.hq.twilio.com/client/MockRTCStatsReport
 */ // The legacy max volume, which is the positive half of a signed short integer.
const $5bcdec8cf78b01e5$var$OLD_MAX_VOLUME = 32767;
const $5bcdec8cf78b01e5$var$NativeRTCStatsReport = typeof window !== 'undefined' ? window.RTCStatsReport : undefined;
/**
 * Create a MockRTCStatsReport wrapper around a Map of RTCStats objects. If RTCStatsReport is available
 *   natively, it will be inherited so that instanceof checks pass.
 * @constructor
 * @extends RTCStatsReport
 * @param {Map<string, RTCStats>} statsMap - A Map of RTCStats objects to wrap
 *   with a MockRTCStatsReport object.
 */ function $5bcdec8cf78b01e5$export$2e2bcd8739ae039(statsMap) {
    if (!(this instanceof $5bcdec8cf78b01e5$export$2e2bcd8739ae039)) return new $5bcdec8cf78b01e5$export$2e2bcd8739ae039(statsMap);
    const self = this;
    Object.defineProperties(this, {
        _map: {
            value: statsMap
        },
        size: {
            enumerable: true,
            get () {
                return self._map.size;
            }
        }
    });
    this[Symbol.iterator] = statsMap[Symbol.iterator];
}
// If RTCStatsReport is available natively, inherit it. Keep our constructor.
if ($5bcdec8cf78b01e5$var$NativeRTCStatsReport) {
    $5bcdec8cf78b01e5$export$2e2bcd8739ae039.prototype = Object.create($5bcdec8cf78b01e5$var$NativeRTCStatsReport.prototype);
    $5bcdec8cf78b01e5$export$2e2bcd8739ae039.prototype.constructor = $5bcdec8cf78b01e5$export$2e2bcd8739ae039;
}
// Map the Map-like read methods to the underlying Map
[
    'entries',
    'forEach',
    'get',
    'has',
    'keys',
    'values'
].forEach((key)=>{
    $5bcdec8cf78b01e5$export$2e2bcd8739ae039.prototype[key] = function(...args) {
        return this._map[key](...args);
    };
});
/**
 * Convert an array of RTCStats objects into a mock RTCStatsReport object.
 * @param {Array<RTCStats>}
 * @return {MockRTCStatsReport}
 */ $5bcdec8cf78b01e5$export$2e2bcd8739ae039.fromArray = function fromArray(array) {
    return new $5bcdec8cf78b01e5$export$2e2bcd8739ae039(array.reduce((map, rtcStats)=>{
        map.set(rtcStats.id, rtcStats);
        return map;
    }, new Map()));
};
/**
 * Convert a legacy RTCStatsResponse object into a mock RTCStatsReport object.
 * @param {RTCStatsResponse} statsResponse - An RTCStatsResponse object returned by the
 *   legacy getStats(callback) method in Chrome.
 * @return {MockRTCStatsReport} A mock RTCStatsReport object.
 */ $5bcdec8cf78b01e5$export$2e2bcd8739ae039.fromRTCStatsResponse = function fromRTCStatsResponse(statsResponse) {
    let activeCandidatePairId;
    const transportIds = new Map();
    const statsMap = statsResponse.result().reduce((map, report)=>{
        const id = report.id;
        switch(report.type){
            case 'googCertificate':
                map.set(id, $5bcdec8cf78b01e5$var$createRTCCertificateStats(report));
                break;
            case 'datachannel':
                map.set(id, $5bcdec8cf78b01e5$var$createRTCDataChannelStats(report));
                break;
            case 'googCandidatePair':
                if ($5bcdec8cf78b01e5$var$getBoolean(report, 'googActiveConnection')) activeCandidatePairId = id;
                map.set(id, $5bcdec8cf78b01e5$var$createRTCIceCandidatePairStats(report));
                break;
            case 'localcandidate':
                map.set(id, $5bcdec8cf78b01e5$var$createRTCIceCandidateStats(report, false));
                break;
            case 'remotecandidate':
                map.set(id, $5bcdec8cf78b01e5$var$createRTCIceCandidateStats(report, true));
                break;
            case 'ssrc':
                if ($5bcdec8cf78b01e5$var$isPresent(report, 'packetsReceived')) map.set(`rtp-${id}`, $5bcdec8cf78b01e5$var$createRTCInboundRTPStreamStats(report));
                else map.set(`rtp-${id}`, $5bcdec8cf78b01e5$var$createRTCOutboundRTPStreamStats(report));
                map.set(`track-${id}`, $5bcdec8cf78b01e5$var$createRTCMediaStreamTrackStats(report));
                map.set(`codec-${id}`, $5bcdec8cf78b01e5$var$createRTCCodecStats(report));
                break;
            case 'googComponent':
                const transportReport = $5bcdec8cf78b01e5$var$createRTCTransportStats(report);
                transportIds.set(transportReport.selectedCandidatePairId, id);
                map.set(id, $5bcdec8cf78b01e5$var$createRTCTransportStats(report));
                break;
        }
        return map;
    }, new Map());
    if (activeCandidatePairId) {
        const activeTransportId = transportIds.get(activeCandidatePairId);
        if (activeTransportId) statsMap.get(activeTransportId).dtlsState = 'connected';
    }
    return new $5bcdec8cf78b01e5$export$2e2bcd8739ae039(statsMap);
};
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCTransportStats}
 */ function $5bcdec8cf78b01e5$var$createRTCTransportStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        dtlsState: undefined,
        id: report.id,
        localCertificateId: report.stat('localCertificateId'),
        remoteCertificateId: report.stat('remoteCertificateId'),
        rtcpTransportStatsId: undefined,
        selectedCandidatePairId: report.stat('selectedCandidatePairId'),
        timestamp: Date.parse(report.timestamp),
        type: 'transport'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCCodecStats}
 */ function $5bcdec8cf78b01e5$var$createRTCCodecStats(report) {
    return {
        channels: undefined,
        clockRate: undefined,
        id: report.id,
        implementation: undefined,
        mimeType: `${report.stat('mediaType')}/${report.stat('googCodecName')}`,
        payloadType: undefined,
        sdpFmtpLine: undefined,
        timestamp: Date.parse(report.timestamp),
        type: 'codec'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCMediaStreamTrackStats}
 */ function $5bcdec8cf78b01e5$var$createRTCMediaStreamTrackStats(report) {
    return {
        audioLevel: $5bcdec8cf78b01e5$var$isPresent(report, 'audioOutputLevel') ? $5bcdec8cf78b01e5$var$getInt(report, 'audioOutputLevel') / $5bcdec8cf78b01e5$var$OLD_MAX_VOLUME : ($5bcdec8cf78b01e5$var$getInt(report, 'audioInputLevel') || 0) / $5bcdec8cf78b01e5$var$OLD_MAX_VOLUME,
        detached: undefined,
        echoReturnLoss: $5bcdec8cf78b01e5$var$getFloat(report, 'googEchoCancellationReturnLoss'),
        echoReturnLossEnhancement: $5bcdec8cf78b01e5$var$getFloat(report, 'googEchoCancellationReturnLossEnhancement'),
        ended: undefined,
        frameHeight: $5bcdec8cf78b01e5$var$isPresent(report, 'googFrameHeightReceived') ? $5bcdec8cf78b01e5$var$getInt(report, 'googFrameHeightReceived') : $5bcdec8cf78b01e5$var$getInt(report, 'googFrameHeightSent'),
        frameWidth: $5bcdec8cf78b01e5$var$isPresent(report, 'googFrameWidthReceived') ? $5bcdec8cf78b01e5$var$getInt(report, 'googFrameWidthReceived') : $5bcdec8cf78b01e5$var$getInt(report, 'googFrameWidthSent'),
        framesCorrupted: undefined,
        framesDecoded: $5bcdec8cf78b01e5$var$getInt(report, 'framesDecoded'),
        framesDropped: undefined,
        framesPerSecond: undefined,
        framesReceived: undefined,
        framesSent: $5bcdec8cf78b01e5$var$getInt(report, 'framesEncoded'),
        fullFramesLost: undefined,
        id: report.id,
        kind: report.stat('mediaType'),
        partialFramesLost: undefined,
        remoteSource: undefined,
        ssrcIds: undefined,
        timestamp: Date.parse(report.timestamp),
        trackIdentifier: report.stat('googTrackId'),
        type: 'track'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isInbound - Whether to create an inbound stats object, or outbound.
 * @returns {RTCRTPStreamStats}
 */ function $5bcdec8cf78b01e5$var$createRTCRTPStreamStats(report, isInbound) {
    return {
        associateStatsId: undefined,
        codecId: `codec-${report.id}`,
        firCount: isInbound ? $5bcdec8cf78b01e5$var$getInt(report, 'googFirsSent') : undefined,
        id: report.id,
        isRemote: undefined,
        mediaType: report.stat('mediaType'),
        nackCount: isInbound ? $5bcdec8cf78b01e5$var$getInt(report, 'googNacksSent') : $5bcdec8cf78b01e5$var$getInt(report, 'googNacksReceived'),
        pliCount: isInbound ? $5bcdec8cf78b01e5$var$getInt(report, 'googPlisSent') : $5bcdec8cf78b01e5$var$getInt(report, 'googPlisReceived'),
        qpSum: $5bcdec8cf78b01e5$var$getInt(report, 'qpSum'),
        sliCount: undefined,
        ssrc: report.stat('ssrc'),
        timestamp: Date.parse(report.timestamp),
        trackId: `track-${report.id}`,
        transportId: report.stat('transportId')
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCInboundRTPStreamStats}
 */ function $5bcdec8cf78b01e5$var$createRTCInboundRTPStreamStats(report) {
    const rtp = $5bcdec8cf78b01e5$var$createRTCRTPStreamStats(report, true);
    Object.assign(rtp, {
        burstDiscardCount: undefined,
        burstDiscardRate: undefined,
        burstLossCount: undefined,
        burstLossRate: undefined,
        burstPacketsDiscarded: undefined,
        burstPacketsLost: undefined,
        bytesReceived: $5bcdec8cf78b01e5$var$getInt(report, 'bytesReceived'),
        fractionLost: undefined,
        framesDecoded: $5bcdec8cf78b01e5$var$getInt(report, 'framesDecoded'),
        gapDiscardRate: undefined,
        gapLossRate: undefined,
        jitter: $5bcdec8cf78b01e5$var$convertMsToSeconds(report.stat('googJitterReceived')),
        packetsDiscarded: undefined,
        packetsLost: $5bcdec8cf78b01e5$var$getInt(report, 'packetsLost'),
        packetsReceived: $5bcdec8cf78b01e5$var$getInt(report, 'packetsReceived'),
        packetsRepaired: undefined,
        roundTripTime: $5bcdec8cf78b01e5$var$convertMsToSeconds(report.stat('googRtt')),
        type: 'inbound-rtp'
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCOutboundRTPStreamStats}
 */ function $5bcdec8cf78b01e5$var$createRTCOutboundRTPStreamStats(report) {
    const rtp = $5bcdec8cf78b01e5$var$createRTCRTPStreamStats(report, false);
    Object.assign(rtp, {
        bytesSent: $5bcdec8cf78b01e5$var$getInt(report, 'bytesSent'),
        framesEncoded: $5bcdec8cf78b01e5$var$getInt(report, 'framesEncoded'),
        packetsSent: $5bcdec8cf78b01e5$var$getInt(report, 'packetsSent'),
        remoteTimestamp: undefined,
        targetBitrate: undefined,
        type: 'outbound-rtp'
    });
    return rtp;
}
/**
 * @param {RTCLegacyStatsReport} report
 * @param {boolean} isRemote - Whether to create for a remote candidate, or local candidate.
 * @returns {RTCIceCandidateStats}
 */ function $5bcdec8cf78b01e5$var$createRTCIceCandidateStats(report, isRemote) {
    return {
        candidateType: $5bcdec8cf78b01e5$var$translateCandidateType(report.stat('candidateType')),
        deleted: undefined,
        id: report.id,
        ip: report.stat('ipAddress'),
        isRemote: isRemote,
        port: $5bcdec8cf78b01e5$var$getInt(report, 'portNumber'),
        priority: $5bcdec8cf78b01e5$var$getFloat(report, 'priority'),
        protocol: report.stat('transport'),
        relayProtocol: undefined,
        timestamp: Date.parse(report.timestamp),
        transportId: undefined,
        type: isRemote ? 'remote-candidate' : 'local-candidate',
        url: undefined
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCandidatePairStats}
 */ function $5bcdec8cf78b01e5$var$createRTCIceCandidatePairStats(report) {
    return {
        availableIncomingBitrate: undefined,
        availableOutgoingBitrate: undefined,
        bytesReceived: $5bcdec8cf78b01e5$var$getInt(report, 'bytesReceived'),
        bytesSent: $5bcdec8cf78b01e5$var$getInt(report, 'bytesSent'),
        consentRequestsSent: $5bcdec8cf78b01e5$var$getInt(report, 'consentRequestsSent'),
        currentRoundTripTime: $5bcdec8cf78b01e5$var$convertMsToSeconds(report.stat('googRtt')),
        id: report.id,
        lastPacketReceivedTimestamp: undefined,
        lastPacketSentTimestamp: undefined,
        localCandidateId: report.stat('localCandidateId'),
        nominated: undefined,
        priority: undefined,
        readable: undefined,
        remoteCandidateId: report.stat('remoteCandidateId'),
        requestsReceived: $5bcdec8cf78b01e5$var$getInt(report, 'requestsReceived'),
        requestsSent: $5bcdec8cf78b01e5$var$getInt(report, 'requestsSent'),
        responsesReceived: $5bcdec8cf78b01e5$var$getInt(report, 'responsesReceived'),
        responsesSent: $5bcdec8cf78b01e5$var$getInt(report, 'responsesSent'),
        retransmissionsReceived: undefined,
        retransmissionsSent: undefined,
        state: undefined,
        timestamp: Date.parse(report.timestamp),
        totalRoundTripTime: undefined,
        transportId: report.stat('googChannelId'),
        type: 'candidate-pair',
        writable: $5bcdec8cf78b01e5$var$getBoolean(report, 'googWritable')
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCIceCertificateStats}
 */ function $5bcdec8cf78b01e5$var$createRTCCertificateStats(report) {
    return {
        base64Certificate: report.stat('googDerBase64'),
        fingerprint: report.stat('googFingerprint'),
        fingerprintAlgorithm: report.stat('googFingerprintAlgorithm'),
        id: report.id,
        issuerCertificateId: report.stat('googIssuerId'),
        timestamp: Date.parse(report.timestamp),
        type: 'certificate'
    };
}
/**
 * @param {RTCLegacyStatsReport} report
 * @returns {RTCDataChannelStats}
 */ function $5bcdec8cf78b01e5$var$createRTCDataChannelStats(report) {
    return {
        bytesReceived: undefined,
        bytesSent: undefined,
        datachannelid: report.stat('datachannelid'),
        id: report.id,
        label: report.stat('label'),
        messagesReceived: undefined,
        messagesSent: undefined,
        protocol: report.stat('protocol'),
        state: report.stat('state'),
        timestamp: Date.parse(report.timestamp),
        transportId: report.stat('transportId'),
        type: 'data-channel'
    };
}
/**
 * @param {number} inMs - A time in milliseconds
 * @returns {number} The time in seconds
 */ function $5bcdec8cf78b01e5$var$convertMsToSeconds(inMs) {
    return isNaN(inMs) || inMs === '' ? undefined : parseInt(inMs, 10) / 1000;
}
/**
 * @param {string} type - A type in the legacy format
 * @returns {string} The type adjusted to new standards for known naming changes
 */ function $5bcdec8cf78b01e5$var$translateCandidateType(type) {
    switch(type){
        case 'peerreflexive':
            return 'prflx';
        case 'serverreflexive':
            return 'srflx';
        case 'host':
        case 'relay':
        default:
            return type;
    }
}
function $5bcdec8cf78b01e5$var$getInt(report, statName) {
    const stat = report.stat(statName);
    return $5bcdec8cf78b01e5$var$isPresent(report, statName) ? parseInt(stat, 10) : undefined;
}
function $5bcdec8cf78b01e5$var$getFloat(report, statName) {
    const stat = report.stat(statName);
    return $5bcdec8cf78b01e5$var$isPresent(report, statName) ? parseFloat(stat) : undefined;
}
function $5bcdec8cf78b01e5$var$getBoolean(report, statName) {
    const stat = report.stat(statName);
    return $5bcdec8cf78b01e5$var$isPresent(report, statName) ? stat === 'true' || stat === true : undefined;
}
function $5bcdec8cf78b01e5$var$isPresent(report, statName) {
    const stat = report.stat(statName);
    return typeof stat !== 'undefined' && stat !== '';
}


// @ts-nocheck
// tslint:disable no-empty
const $31ba44ba404e502a$var$ERROR_PEER_CONNECTION_NULL = 'PeerConnection is null';
const $31ba44ba404e502a$var$ERROR_WEB_RTC_UNSUPPORTED = 'WebRTC statistics are unsupported';
/**
 * Helper function to find a specific stat from a report.
 * Some environment provide the stats report as a map (regular browsers)
 * but some provide stats report as an array (citrix vdi)
 * @private
 */ function $31ba44ba404e502a$var$findStatById(report, id) {
    if (typeof report.get === 'function') return report.get(id);
    return report.find((s)=>s.id === id);
}
/**
 * Generate WebRTC statistics report for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCStatsReport>} WebRTC RTCStatsReport object
 */ function $31ba44ba404e502a$var$getRTCStatsReport(peerConnection) {
    if (!peerConnection) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)($31ba44ba404e502a$var$ERROR_PEER_CONNECTION_NULL));
    if (typeof peerConnection.getStats !== 'function') return Promise.reject(new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)($31ba44ba404e502a$var$ERROR_WEB_RTC_UNSUPPORTED));
    let promise;
    try {
        promise = peerConnection.getStats();
    } catch (e) {
        promise = new Promise((resolve)=>peerConnection.getStats(resolve)).then((0, $5bcdec8cf78b01e5$export$2e2bcd8739ae039).fromRTCStatsResponse);
    }
    return promise;
}
/**
 * @typedef {Object} StatsOptions
 * Used for testing to inject and extract methods.
 * @property {function} [createRTCSample] - Method for parsing an RTCStatsReport
 */ /**
 * Collects any WebRTC statistics for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @param {StatsOptions} options - List of custom options.
 * @return {Promise<RTCSample>} Universally-formatted version of RTC stats.
 */ function $31ba44ba404e502a$export$8f85ce3f3acd2643(peerConnection, options) {
    options = Object.assign({
        createRTCSample: $31ba44ba404e502a$var$createRTCSample
    }, options);
    return $31ba44ba404e502a$var$getRTCStatsReport(peerConnection).then(options.createRTCSample);
}
/**
 * Generate WebRTC stats report containing relevant information about ICE candidates for the given {@link PeerConnection}
 * @param {PeerConnection} peerConnection - Target connection.
 * @return {Promise<RTCIceCandidateStatsReport>} RTCIceCandidateStatsReport object
 */ function $31ba44ba404e502a$export$d5624de2482d0365(peerConnection) {
    return $31ba44ba404e502a$var$getRTCStatsReport(peerConnection).then((report)=>{
        // Find the relevant information needed to determine selected candidates later
        const { candidatePairs: candidatePairs, localCandidates: localCandidates, remoteCandidates: remoteCandidates, transport: transport } = Array.from(report.values()).reduce((rval, stat)=>{
            [
                'candidatePairs',
                'localCandidates',
                'remoteCandidates'
            ].forEach((prop)=>{
                if (!rval[prop]) rval[prop] = [];
            });
            switch(stat.type){
                case 'candidate-pair':
                    rval.candidatePairs.push(stat);
                    break;
                case 'local-candidate':
                    rval.localCandidates.push(stat);
                    break;
                case 'remote-candidate':
                    rval.remoteCandidates.push(stat);
                    break;
                case 'transport':
                    // This transport is the one being used if selectedCandidatePairId is populated
                    if (stat.selectedCandidatePairId) rval.transport = stat;
                    break;
            }
            return rval;
        }, {});
        // This is a report containing information about the selected candidates, such as IDs
        // This is coming from WebRTC stats directly and doesn't contain the actual ICE Candidates info
        const selectedCandidatePairReport = candidatePairs.find((pair)=>// Firefox
            pair.selected || // Spec-compliant way
            transport && pair.id === transport.selectedCandidatePairId);
        let selectedIceCandidatePairStats;
        if (selectedCandidatePairReport) selectedIceCandidatePairStats = {
            localCandidate: localCandidates.find((candidate)=>candidate.id === selectedCandidatePairReport.localCandidateId),
            remoteCandidate: remoteCandidates.find((candidate)=>candidate.id === selectedCandidatePairReport.remoteCandidateId)
        };
        // Build the return object
        return {
            iceCandidateStats: [
                ...localCandidates,
                ...remoteCandidates
            ],
            selectedIceCandidatePairStats: selectedIceCandidatePairStats
        };
    });
}
/**
 * @typedef {Object} RTCSample - A sample containing relevant WebRTC stats information.
 * @property {Number} [timestamp]
 * @property {String} [codecName] - MimeType name of the codec being used by the outbound audio stream
 * @property {Number} [rtt] - Round trip time
 * @property {Number} [jitter]
 * @property {Number} [packetsSent]
 * @property {Number} [packetsLost]
 * @property {Number} [packetsReceived]
 * @property {Number} [bytesReceived]
 * @property {Number} [bytesSent]
 * @property {Number} [localAddress]
 * @property {Number} [remoteAddress]
 */ function $31ba44ba404e502a$var$RTCSample() {
    // Chrome 141+ omits the outbound-rtp (and sometimes inbound-rtp) stats
    // entry while ICE has not yet connected. Pre-populating counter fields
    // with 0 preserves the pre-141 sample shape so downstream arithmetic in
    // StatsMonitor._createSample doesn't produce NaN.
    this.bytesReceived = 0;
    this.bytesSent = 0;
    this.jitter = 0;
    this.packetsLost = 0;
    this.packetsReceived = 0;
    this.packetsSent = 0;
}
/**
 * Create an RTCSample object from an RTCStatsReport
 * @private
 * @param {RTCStatsReport} statsReport
 * @returns {RTCSample}
 */ function $31ba44ba404e502a$var$createRTCSample(statsReport) {
    let activeTransportId = null;
    const sample = new $31ba44ba404e502a$var$RTCSample();
    let fallbackTimestamp;
    Array.from(statsReport.values()).forEach((stats)=>{
        // Skip isRemote tracks which will be phased out completely and break in FF66.
        if (stats.isRemote) return;
        // Firefox hack -- Older firefox doesn't have dashes in type names
        const type = stats.type.replace('-', '');
        fallbackTimestamp = fallbackTimestamp || stats.timestamp;
        // (rrowland) As I understand it, this is supposed to come in on remote-inbound-rtp but it's
        // currently coming in on remote-outbound-rtp, so I'm leaving this outside the switch until
        // the appropriate place to look is cleared up.
        if (stats.remoteId) {
            const remote = $31ba44ba404e502a$var$findStatById(statsReport, stats.remoteId);
            if (remote && remote.roundTripTime) sample.rtt = remote.roundTripTime * 1000;
        }
        switch(type){
            case 'inboundrtp':
                sample.timestamp = sample.timestamp || stats.timestamp;
                sample.jitter = stats.jitter * 1000;
                sample.packetsLost = stats.packetsLost;
                sample.packetsReceived = stats.packetsReceived;
                sample.bytesReceived = stats.bytesReceived;
                break;
            case 'outboundrtp':
                sample.timestamp = stats.timestamp;
                sample.packetsSent = stats.packetsSent;
                sample.bytesSent = stats.bytesSent;
                if (stats.codecId) {
                    const codec = $31ba44ba404e502a$var$findStatById(statsReport, stats.codecId);
                    sample.codecName = codec ? codec.mimeType && codec.mimeType.match(/(.*\/)?(.*)/)[2] : stats.codecId;
                }
                break;
            case 'transport':
                activeTransportId = stats.id;
                break;
        }
    });
    if (!sample.timestamp) sample.timestamp = fallbackTimestamp;
    const activeTransport = $31ba44ba404e502a$var$findStatById(statsReport, activeTransportId);
    if (!activeTransport) return sample;
    const selectedCandidatePair = $31ba44ba404e502a$var$findStatById(statsReport, activeTransport.selectedCandidatePairId);
    if (!selectedCandidatePair) return sample;
    const localCandidate = $31ba44ba404e502a$var$findStatById(statsReport, selectedCandidatePair.localCandidateId);
    const remoteCandidate = $31ba44ba404e502a$var$findStatById(statsReport, selectedCandidatePair.remoteCandidateId);
    if (!sample.rtt) sample.rtt = selectedCandidatePair && selectedCandidatePair.currentRoundTripTime * 1000;
    Object.assign(sample, {
        // ip is deprecated. use address first then ip if on older versions of browser
        localAddress: localCandidate && (localCandidate.address || localCandidate.ip),
        remoteAddress: remoteCandidate && (remoteCandidate.address || remoteCandidate.ip)
    });
    return sample;
}




/**
 * Runs some tests to identify issues, if any, prohibiting successful calling.
 */ class $b34234dbca721431$export$b5100322533453bb extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * Construct a {@link PreflightTest} instance.
     * @param token - A Twilio JWT token string.
     * @param options
     */ constructor(token, options){
        super();
        /**
         * Whether this test has already logged an insights-connection-warning.
         */ this._hasInsightsErrored = false;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('PreflightTest');
        /**
         * Network related timing measurements for this test
         */ this._networkTiming = {};
        /**
         * The options passed to {@link PreflightTest} constructor
         */ this._options = {
            codecPreferences: [
                (0, $73a9091c20261962$export$2e2bcd8739ae039).Codec.PCMU,
                (0, $73a9091c20261962$export$2e2bcd8739ae039).Codec.Opus
            ],
            edge: 'roaming',
            fakeMicInput: false,
            logLevel: 'error',
            signalingTimeoutMs: 10000
        };
        /**
         * Current status of this test
         */ this._status = $b34234dbca721431$export$b5100322533453bb.Status.Connecting;
        Object.assign(this._options, options);
        this._samples = [];
        this._warnings = [];
        this._startTime = Date.now();
        this._initDevice(token, Object.assign(Object.assign({}, this._options), {
            fileInputStream: this._options.fakeMicInput ? this._getStreamFromFile() : undefined
        }));
        // Device sets the loglevel so start logging after initializing the device.
        // Then selectively log options that users can modify.
        const userOptions = [
            'codecPreferences',
            'edge',
            'fakeMicInput',
            'logLevel',
            'signalingTimeoutMs'
        ];
        const userOptionOverrides = [
            'audioContext',
            'deviceFactory',
            'fileInputStream',
            'getRTCIceCandidateStatsReport',
            'iceServers',
            'rtcConfiguration'
        ];
        if (typeof options === 'object') {
            const toLog = Object.assign({}, options);
            Object.keys(toLog).forEach((key)=>{
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog[key];
                if (userOptionOverrides.includes(key)) toLog[key] = true;
            });
            this._log.debug('.constructor', JSON.stringify(toLog));
        }
    }
    /**
     * Stops the current test and raises a failed event.
     */ stop() {
        this._log.debug('.stop');
        const error = new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).CallCancelledError();
        if (this._device) {
            this._device.once((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).EventName.Unregistered, ()=>this._onFailed(error));
            this._device.destroy();
        } else this._onFailed(error);
    }
    /**
     * Emit a {PreflightTest.Warning}
     */ _emitWarning(name, description, rtcWarning) {
        const warning = {
            name: name,
            description: description
        };
        if (rtcWarning) warning.rtcWarning = rtcWarning;
        this._warnings.push(warning);
        this._log.debug(`#${$b34234dbca721431$export$b5100322533453bb.Events.Warning}`, JSON.stringify(warning));
        this.emit($b34234dbca721431$export$b5100322533453bb.Events.Warning, warning);
    }
    /**
     * Returns call quality base on the RTC Stats
     */ _getCallQuality(mos) {
        if (mos > 4.2) return $b34234dbca721431$export$b5100322533453bb.CallQuality.Excellent;
        else if (mos >= 4.1 && mos <= 4.2) return $b34234dbca721431$export$b5100322533453bb.CallQuality.Great;
        else if (mos >= 3.7 && mos <= 4) return $b34234dbca721431$export$b5100322533453bb.CallQuality.Good;
        else if (mos >= 3.1 && mos <= 3.6) return $b34234dbca721431$export$b5100322533453bb.CallQuality.Fair;
        else return $b34234dbca721431$export$b5100322533453bb.CallQuality.Degraded;
    }
    /**
     * Returns the report for this test.
     */ _getReport() {
        var _a, _b, _c;
        const stats = this._getRTCStats();
        const testTiming = {
            start: this._startTime
        };
        if (this._endTime) {
            testTiming.end = this._endTime;
            testTiming.duration = this._endTime - this._startTime;
        }
        const report = {
            callSid: this._callSid,
            edge: this._edge,
            iceCandidateStats: (_b = (_a = this._rtcIceCandidateStatsReport) === null || _a === void 0 ? void 0 : _a.iceCandidateStats) !== null && _b !== void 0 ? _b : [],
            networkTiming: this._networkTiming,
            samples: this._samples,
            selectedEdge: this._options.edge,
            stats: stats,
            testTiming: testTiming,
            totals: this._getRTCSampleTotals(),
            warnings: this._warnings
        };
        const selectedIceCandidatePairStats = (_c = this._rtcIceCandidateStatsReport) === null || _c === void 0 ? void 0 : _c.selectedIceCandidatePairStats;
        if (selectedIceCandidatePairStats) {
            report.selectedIceCandidatePairStats = selectedIceCandidatePairStats;
            report.isTurnRequired = selectedIceCandidatePairStats.localCandidate.candidateType === 'relay' || selectedIceCandidatePairStats.remoteCandidate.candidateType === 'relay';
        }
        if (stats) report.callQuality = this._getCallQuality(stats.mos.average);
        return report;
    }
    /**
     * Returns RTC stats totals for this test
     */ _getRTCSampleTotals() {
        if (!this._latestSample) return;
        return Object.assign({}, this._latestSample.totals);
    }
    /**
     * Returns RTC related stats captured during the test call
     */ _getRTCStats() {
        const firstMosSampleIdx = this._samples.findIndex((sample)=>typeof sample.mos === 'number' && sample.mos > 0);
        const samples = firstMosSampleIdx >= 0 ? this._samples.slice(firstMosSampleIdx) : [];
        if (!samples || !samples.length) return;
        return [
            'jitter',
            'mos',
            'rtt'
        ].reduce((statObj, stat)=>{
            const values = samples.map((s)=>s[stat]);
            return Object.assign(Object.assign({}, statObj), {
                [stat]: {
                    average: Number((values.reduce((total, value)=>total + value) / values.length).toPrecision(5)),
                    max: Math.max(...values),
                    min: Math.min(...values)
                }
            });
        }, {});
    }
    /**
     * Returns a MediaStream from a media file
     */ _getStreamFromFile() {
        const audioContext = this._options.audioContext;
        if (!audioContext) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('Cannot fake input audio stream: AudioContext is not supported by this browser.');
        const audioEl = new Audio((0, $1ec27394c1cce6bb$export$76d6f2318155ab63));
        audioEl.addEventListener('canplaythrough', ()=>audioEl.play());
        if (typeof audioEl.setAttribute === 'function') audioEl.setAttribute('crossorigin', 'anonymous');
        const src = audioContext.createMediaElementSource(audioEl);
        const dest = audioContext.createMediaStreamDestination();
        src.connect(dest);
        return dest.stream;
    }
    /**
     * Initialize the device
     */ _initDevice(token, options) {
        try {
            this._device = new (options.deviceFactory || (0, $2b01ca659bdc22ff$export$2e2bcd8739ae039))(token, {
                chunderw: options.chunderw,
                codecPreferences: options.codecPreferences,
                edge: options.edge,
                eventgw: options.eventgw,
                fileInputStream: options.fileInputStream,
                logLevel: options.logLevel,
                preflight: true
            });
            this._device.once((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).EventName.Registered, ()=>{
                this._onDeviceRegistered();
            });
            this._device.once((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).EventName.Error, (error)=>{
                this._onDeviceError(error);
            });
            this._device.register();
        } catch (error) {
            // We want to return before failing so the consumer can capture the event
            setTimeout(()=>{
                this._onFailed(error);
            });
            return;
        }
        this._signalingTimeoutTimer = setTimeout(()=>{
            this._onDeviceError(new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionError('WebSocket Connection Timeout'));
        }, options.signalingTimeoutMs);
    }
    /**
     * Called on {@link Device} error event
     * @param error
     */ _onDeviceError(error) {
        this._device.destroy();
        this._onFailed(error);
    }
    /**
     * Called on {@link Device} ready event
     */ _onDeviceRegistered() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            clearTimeout(this._echoTimer);
            clearTimeout(this._signalingTimeoutTimer);
            this._call = yield this._device.connect({
                rtcConfiguration: this._options.rtcConfiguration
            });
            this._networkTiming.signaling = {
                start: Date.now()
            };
            this._setupCallHandlers(this._call);
            this._edge = this._device.edge || undefined;
            if (this._options.fakeMicInput) {
                this._echoTimer = setTimeout(()=>this._device.disconnectAll(), (0, $1ec27394c1cce6bb$export$40ba67aa4f553679));
                const audio = this._device.audio;
                if (audio) {
                    audio.disconnect(false);
                    audio.outgoing(false);
                }
            }
            this._call.once('disconnect', ()=>{
                this._device.once((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).EventName.Unregistered, ()=>this._onUnregistered());
                this._device.destroy();
            });
            const publisher = this._call['_publisher'];
            publisher.on('error', ()=>{
                if (!this._hasInsightsErrored) this._emitWarning('insights-connection-error', 'Received an error when attempting to connect to Insights gateway');
                this._hasInsightsErrored = true;
            });
        });
    }
    /**
     * Called when there is a fatal error
     * @param error
     */ _onFailed(error) {
        clearTimeout(this._echoTimer);
        clearTimeout(this._signalingTimeoutTimer);
        this._releaseHandlers();
        this._endTime = Date.now();
        this._status = $b34234dbca721431$export$b5100322533453bb.Status.Failed;
        this._log.debug(`#${$b34234dbca721431$export$b5100322533453bb.Events.Failed}`, error);
        this.emit($b34234dbca721431$export$b5100322533453bb.Events.Failed, error);
    }
    /**
     * Called when the device goes offline.
     * This indicates that the test has been completed, but we won't know if it failed or not.
     * The onError event will be the indicator whether the test failed.
     */ _onUnregistered() {
        // We need to make sure we always execute preflight.on('completed') last
        // as client SDK sometimes emits 'offline' event before emitting fatal errors.
        setTimeout(()=>{
            if (this._status === $b34234dbca721431$export$b5100322533453bb.Status.Failed) return;
            clearTimeout(this._echoTimer);
            clearTimeout(this._signalingTimeoutTimer);
            this._releaseHandlers();
            this._endTime = Date.now();
            this._status = $b34234dbca721431$export$b5100322533453bb.Status.Completed;
            this._report = this._getReport();
            this._log.debug(`#${$b34234dbca721431$export$b5100322533453bb.Events.Completed}`, JSON.stringify(this._report));
            this.emit($b34234dbca721431$export$b5100322533453bb.Events.Completed, this._report);
        }, 10);
    }
    /**
     * Clean up all handlers for device and call
     */ _releaseHandlers() {
        [
            this._device,
            this._call
        ].forEach((emitter)=>{
            if (emitter) emitter.eventNames().forEach((name)=>emitter.removeAllListeners(name));
        });
    }
    /**
     * Setup the event handlers for the {@link Call} of the test call
     * @param call
     */ _setupCallHandlers(call) {
        if (this._options.fakeMicInput) // When volume events start emitting, it means all audio outputs have been created.
        // Let's mute them if we're using fake mic input.
        call.once('volume', ()=>{
            call['_mediaHandler'].outputs.forEach((output)=>output.audio.muted = true);
        });
        call.on('warning', (name, data)=>{
            this._emitWarning(name, 'Received an RTCWarning. See .rtcWarning for the RTCWarning', data);
        });
        call.once('accept', ()=>{
            this._callSid = call['_mediaHandler'].callSid;
            this._status = $b34234dbca721431$export$b5100322533453bb.Status.Connected;
            this._log.debug(`#${$b34234dbca721431$export$b5100322533453bb.Events.Connected}`);
            this.emit($b34234dbca721431$export$b5100322533453bb.Events.Connected);
        });
        call.on('sample', (sample)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                // RTC Stats are ready. We only need to get ICE candidate stats report once.
                if (!this._latestSample) this._rtcIceCandidateStatsReport = yield (this._options.getRTCIceCandidateStatsReport || (0, $31ba44ba404e502a$export$d5624de2482d0365))(call['_mediaHandler'].version.pc);
                this._latestSample = sample;
                this._samples.push(sample);
                this._log.debug(`#${$b34234dbca721431$export$b5100322533453bb.Events.Sample}`, JSON.stringify(sample));
                this.emit($b34234dbca721431$export$b5100322533453bb.Events.Sample, sample);
            }));
        // TODO: Update the following once the SDK supports emitting these events
        // Let's shim for now
        [
            {
                reportLabel: 'peerConnection',
                type: 'pcconnection'
            },
            {
                reportLabel: 'ice',
                type: 'iceconnection'
            },
            {
                reportLabel: 'dtls',
                type: 'dtlstransport'
            },
            {
                reportLabel: 'signaling',
                type: 'signaling'
            }
        ].forEach(({ type: type, reportLabel: reportLabel })=>{
            const handlerName = `on${type}statechange`;
            const originalHandler = call['_mediaHandler'][handlerName];
            call['_mediaHandler'][handlerName] = (state)=>{
                const timing = this._networkTiming[reportLabel] = this._networkTiming[reportLabel] || {
                    start: 0
                };
                if (state === 'connecting' || state === 'checking') timing.start = Date.now();
                else if ((state === 'connected' || state === 'stable') && !timing.duration) {
                    timing.end = Date.now();
                    timing.duration = timing.end - timing.start;
                }
                originalHandler(state);
            };
        });
    }
    /**
     * The callsid generated for the test call.
     */ get callSid() {
        return this._callSid;
    }
    /**
     * A timestamp in milliseconds of when the test ended.
     */ get endTime() {
        return this._endTime;
    }
    /**
     * The latest WebRTC sample collected.
     */ get latestSample() {
        return this._latestSample;
    }
    /**
     * The report for this test.
     */ get report() {
        return this._report;
    }
    /**
     * A timestamp in milliseconds of when the test started.
     */ get startTime() {
        return this._startTime;
    }
    /**
     * The status of the test.
     */ get status() {
        return this._status;
    }
}
/**
 * @mergeModuleWith PreflightTest
 */ (function(PreflightTest) {
    (function(CallQuality) {
        /**
         * If the average mos is over 4.2.
         */ CallQuality["Excellent"] = "excellent";
        /**
         * If the average mos is between 4.1 and 4.2 both inclusive.
         */ CallQuality["Great"] = "great";
        /**
         * If the average mos is between 3.7 and 4.0 both inclusive.
         */ CallQuality["Good"] = "good";
        /**
         * If the average mos is between 3.1 and 3.6 both inclusive.
         */ CallQuality["Fair"] = "fair";
        /**
         * If the average mos is 3.0 or below.
         */ CallQuality["Degraded"] = "degraded";
    })(PreflightTest.CallQuality || (PreflightTest.CallQuality = {}));
    (function(Events) {
        /**
         * See [[PreflightTest.completedEvent]]
         */ Events["Completed"] = "completed";
        /**
         * See [[PreflightTest.connectedEvent]]
         */ Events["Connected"] = "connected";
        /**
         * See [[PreflightTest.failedEvent]]
         */ Events["Failed"] = "failed";
        /**
         * See [[PreflightTest.sampleEvent]]
         */ Events["Sample"] = "sample";
        /**
         * See [[PreflightTest.warningEvent]]
         */ Events["Warning"] = "warning";
    })(PreflightTest.Events || (PreflightTest.Events = {}));
    (function(Status) {
        /**
         * Call to Twilio has initiated.
         */ Status["Connecting"] = "connecting";
        /**
         * Call to Twilio has been established.
         */ Status["Connected"] = "connected";
        /**
         * The connection to Twilio has been disconnected and the test call has completed.
         */ Status["Completed"] = "completed";
        /**
         * The test has stopped and failed.
         */ Status["Failed"] = "failed";
    })(PreflightTest.Status || (PreflightTest.Status = {}));
})($b34234dbca721431$export$b5100322533453bb || ($b34234dbca721431$export$b5100322533453bb = {}));










const $f01d9bfcb20bcf05$var$WebSocket = globalThis.WebSocket;
const $f01d9bfcb20bcf05$var$CONNECT_SUCCESS_TIMEOUT = 10000;
const $f01d9bfcb20bcf05$var$CONNECT_TIMEOUT = 5000;
const $f01d9bfcb20bcf05$var$HEARTBEAT_TIMEOUT = 15000;
const $f01d9bfcb20bcf05$var$MAX_PREFERRED_DURATION = 15000;
const $f01d9bfcb20bcf05$var$MAX_PRIMARY_DURATION = Infinity;
const $f01d9bfcb20bcf05$var$MAX_RETRY_AFTER_DURATION = 75000;
const $f01d9bfcb20bcf05$var$MAX_PREFERRED_DELAY = 1000;
const $f01d9bfcb20bcf05$var$MAX_PRIMARY_DELAY = 20000;
const $f01d9bfcb20bcf05$var$MAX_RETRY_AFTER_DELAY = 60000;
/**
 * All possible states of WSTransport.
 */ var $f01d9bfcb20bcf05$export$8974257e633775ac;
(function(WSTransportState) {
    /**
     * The WebSocket is not open but is trying to connect.
     */ WSTransportState["Connecting"] = "connecting";
    /**
     * The WebSocket is not open and is not trying to connect.
     */ WSTransportState["Closed"] = "closed";
    /**
     * The underlying WebSocket is open and active.
     */ WSTransportState["Open"] = "open";
})($f01d9bfcb20bcf05$export$8974257e633775ac || ($f01d9bfcb20bcf05$export$8974257e633775ac = {}));
/**
 * WebSocket Transport
 */ class $f01d9bfcb20bcf05$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * @constructor
     * @param uris - List of URI of the endpoints to connect to.
     * @param [options] - Constructor options.
     */ constructor(uris, options = {}){
        super();
        /**
         * The current state of the WSTransport.
         */ this.state = $f01d9bfcb20bcf05$export$8974257e633775ac.Closed;
        /**
         * Start timestamp values for backoffs.
         */ this._backoffStartTime = {
            preferred: null,
            primary: null
        };
        /**
         * The URI that the transport is connecting or connected to. The value of this
         * property is `null` if a connection attempt has not been made yet.
         */ this._connectedUri = null;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('WSTransport');
        /**
         * The retryAfter value from signaling error, in seconds.
         */ this._retryAfter = null;
        /**
         * Whether we should attempt to fallback if we receive an applicable error
         * when trying to connect to a signaling endpoint.
         */ this._shouldFallback = false;
        /**
         * The current uri index that the transport is connected to.
         */ this._uriIndex = 0;
        /**
         * Move the uri index to the next index
         * If the index is at the end, the index goes back to the first one.
         */ this._moveUriIndex = ()=>{
            this._uriIndex++;
            if (this._uriIndex >= this._uris.length) this._uriIndex = 0;
        };
        /**
         * Called in response to WebSocket#close event.
         */ this._onSocketClose = (event)=>{
            this._log.error(`Received websocket close event code: ${event.code}. Reason: ${event.reason}`);
            // 1006: Abnormal close. When the server is unreacheable
            // 1015: TLS Handshake error
            if (event.code === 1006 || event.code === 1015) {
                this.emit('error', {
                    code: 31005,
                    message: event.reason || "Websocket connection to Twilio's signaling servers were unexpectedly ended. If this is happening consistently, there may be an issue resolving the hostname provided. If a region or an edge is being specified in Device setup, ensure it is valid.",
                    twilioError: new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionError()
                });
                const wasConnected = // Only in Safari and certain Firefox versions, on network interruption, websocket drops right away with 1006
                // Let's check current state if it's open, meaning we should not fallback
                // because we're coming from a previously connected session
                this.state === $f01d9bfcb20bcf05$export$8974257e633775ac.Open || // But on other browsers, websocket doesn't drop
                // but our heartbeat catches it, setting the internal state to "Connecting".
                // With this, we should check the previous state instead.
                this._previousState === $f01d9bfcb20bcf05$export$8974257e633775ac.Open;
                // Only fallback if this is not the first error
                // and if we were not connected previously
                if (this._shouldFallback || !wasConnected) this._moveUriIndex();
                this._shouldFallback = true;
            }
            this._closeSocket();
        };
        /**
         * Called in response to WebSocket#error event.
         */ this._onSocketError = (err)=>{
            this._log.error(`WebSocket received error: ${err.message}`);
            this.emit('error', {
                code: 31000,
                message: err.message || 'WSTransport socket error',
                twilioError: new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionDisconnected()
            });
        };
        /**
         * Called in response to WebSocket#message event.
         */ this._onSocketMessage = (message)=>{
            // Clear heartbeat timeout on any incoming message, as they
            // all indicate an active connection.
            this._setHeartbeatTimeout();
            // Filter and respond to heartbeats
            if (this._socket && message.data === '\n') {
                this._socket.send('\n');
                this._log.debug('heartbeat');
                return;
            }
            if (message && typeof message.data === 'string') {
                this._log.debug(`Received: ${message.data}`);
                const { type: type, payload: payload = {} } = JSON.parse(message.data);
                if (type === 'error' && payload.error && payload.error.retryAfter) this._retryAfter = payload.error.retryAfter * 1000; // convert to milliseconds
            }
            this.emit('message', message);
        };
        /**
         * Called in response to WebSocket#open event.
         */ this._onSocketOpen = ()=>{
            this._log.info('WebSocket opened successfully.');
            this._timeOpened = Date.now();
            this._shouldFallback = false;
            this._setState($f01d9bfcb20bcf05$export$8974257e633775ac.Open);
            clearTimeout(this._connectTimeout);
            if (this._backoff) this._resetBackoffs();
            this._setHeartbeatTimeout();
            this.emit('open');
        };
        this._options = Object.assign(Object.assign({}, $f01d9bfcb20bcf05$export$2e2bcd8739ae039.defaultConstructorOptions), options);
        this._uris = uris;
        this._backoff = null;
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ close() {
        this._log.info('WSTransport.close() called...');
        this._close();
    }
    /**
     * Attempt to open a WebSocket connection.
     */ open() {
        this._log.info('WSTransport.open() called...');
        if (this._socket && (this._socket.readyState === $f01d9bfcb20bcf05$var$WebSocket.CONNECTING || this._socket.readyState === $f01d9bfcb20bcf05$var$WebSocket.OPEN)) {
            this._log.info('WebSocket already open.');
            return;
        }
        if (this._preferredUri) this._connect(this._preferredUri);
        else this._connect(this._uris[this._uriIndex]);
    }
    /**
     * Send a message through the WebSocket connection.
     * @param message - A message to send to the endpoint.
     * @returns Whether the message was sent.
     */ send(message) {
        this._log.debug(`Sending: ${message}`);
        // We can't send the message if the WebSocket isn't open
        if (!this._socket || this._socket.readyState !== $f01d9bfcb20bcf05$var$WebSocket.OPEN) {
            this._log.debug('Cannot send message. WebSocket is not open.');
            return false;
        }
        try {
            this._socket.send(message);
        } catch (e) {
            // Some unknown error occurred. Reset the socket to get a fresh session.
            this._log.error('Error while sending message:', e.message);
            this._closeSocket();
            return false;
        }
        return true;
    }
    /**
     * Update the preferred URI to connect to. Useful for Call signaling
     * reconnection, which requires connecting on the same edge. If `null` is
     * passed, the preferred URI is unset and the original `uris` array and
     * `uriIndex` is used to determine the signaling URI to connect to.
     * @param uri
     */ updatePreferredURI(uri) {
        this._preferredUri = uri;
    }
    /**
     * Update acceptable URIs to reconnect to. Resets the URI index to 0.
     */ updateURIs(uris) {
        if (typeof uris === 'string') uris = [
            uris
        ];
        this._uris = uris;
        this._uriIndex = 0;
    }
    /**
     * Close the WebSocket, and don't try to reconnect.
     */ _close() {
        this._setState($f01d9bfcb20bcf05$export$8974257e633775ac.Closed);
        this._closeSocket();
    }
    /**
     * Close the WebSocket and remove all event listeners.
     */ _closeSocket() {
        clearTimeout(this._connectTimeout);
        clearTimeout(this._heartbeatTimeout);
        this._log.info('Closing and cleaning up WebSocket...');
        if (!this._socket) {
            this._log.info('No WebSocket to clean up.');
            return;
        }
        this._socket.removeEventListener('close', this._onSocketClose);
        this._socket.removeEventListener('error', this._onSocketError);
        this._socket.removeEventListener('message', this._onSocketMessage);
        this._socket.removeEventListener('open', this._onSocketOpen);
        if (this._socket.readyState === $f01d9bfcb20bcf05$var$WebSocket.CONNECTING || this._socket.readyState === $f01d9bfcb20bcf05$var$WebSocket.OPEN) this._socket.close();
        // Reset backoff counter if connection was open for long enough to be considered successful
        if (this._backoff && this._timeOpened && Date.now() - this._timeOpened > $f01d9bfcb20bcf05$var$CONNECT_SUCCESS_TIMEOUT) this._resetBackoffs();
        if (this.state !== $f01d9bfcb20bcf05$export$8974257e633775ac.Closed) {
            if (!this._backoff) this._backoff = this._setupBackoffs();
            this._performBackoff();
        }
        delete this._socket;
        this.emit('close');
    }
    /**
     * Attempt to connect to the endpoint via WebSocket.
     * @param [uri] - URI string to connect to.
     * @param [retryCount] - Retry number, if this is a retry. Undefined if
     *   first attempt, 1+ if a retry.
     */ _connect(uri, retryCount) {
        this._log.info(typeof retryCount === 'number' ? `Attempting to reconnect (retry #${retryCount})...` : 'Attempting to connect...');
        this._closeSocket();
        this._setState($f01d9bfcb20bcf05$export$8974257e633775ac.Connecting);
        this._connectedUri = uri;
        try {
            this._socket = new this._options.WebSocket(this._connectedUri);
        } catch (e) {
            this._log.error('Could not connect to endpoint:', e.message);
            this._close();
            this.emit('error', {
                code: 31000,
                message: e.message || `Could not connect to ${this._connectedUri}`,
                twilioError: new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionDisconnected()
            });
            return;
        }
        this._socket.addEventListener('close', this._onSocketClose);
        this._socket.addEventListener('error', this._onSocketError);
        this._socket.addEventListener('message', this._onSocketMessage);
        this._socket.addEventListener('open', this._onSocketOpen);
        delete this._timeOpened;
        this._connectTimeout = setTimeout(()=>{
            this._log.info('WebSocket connection attempt timed out.');
            this._moveUriIndex();
            this._closeSocket();
        }, this._options.connectTimeoutMs);
    }
    /**
     * Perform a backoff. If a preferred URI is set (not null), then backoff
     * using the preferred mechanism. Otherwise, use the primary mechanism.
     */ _performBackoff() {
        if (!this._backoff) {
            this._log.info('No backoff instance to perform backoff.');
            return;
        }
        if (this._preferredUri) {
            this._log.info('Preferred URI set; backing off.');
            this._backoff.preferred.backoff();
        } else {
            this._log.info('Preferred URI not set; backing off.');
            this._backoff.primary.backoff();
        }
    }
    /**
     * Reset both primary and preferred backoff mechanisms.
     */ _resetBackoffs() {
        if (!this._backoff) {
            this._log.info('No backoff instance to reset.');
            return;
        }
        this._backoff.preferred.removeAllListeners('backoff');
        this._backoff.preferred.removeAllListeners('ready');
        this._backoff.primary.removeAllListeners('backoff');
        this._backoff.primary.removeAllListeners('ready');
        this._backoff = null;
        this._retryAfter = null;
        this._backoffStartTime.preferred = null;
        this._backoffStartTime.primary = null;
    }
    /**
     * Set a timeout to reconnect after HEARTBEAT_TIMEOUT milliseconds
     *   have passed without receiving a message over the WebSocket.
     */ _setHeartbeatTimeout() {
        clearTimeout(this._heartbeatTimeout);
        this._heartbeatTimeout = setTimeout(()=>{
            this._log.info(`No messages received in ${$f01d9bfcb20bcf05$var$HEARTBEAT_TIMEOUT / 1000} seconds. Reconnecting...`);
            this._shouldFallback = true;
            this._closeSocket();
        }, $f01d9bfcb20bcf05$var$HEARTBEAT_TIMEOUT);
    }
    /**
     * Set the current and previous state
     */ _setState(state) {
        this._previousState = this.state;
        this.state = state;
    }
    /**
     * Set up the primary and preferred backoff mechanisms.
     */ _setupBackoffs() {
        const preferredRetryAfter = this._retryAfter !== null && this._preferredUri ? this._retryAfter : null;
        if (preferredRetryAfter) this._log.info(`Setting initial preferred backoff value to retryAfter: ${preferredRetryAfter}ms`);
        const maxPreferredDurationMs = preferredRetryAfter ? this._options.maxRetryAfterDurationMs : this._options.maxPreferredDurationMs;
        const preferredBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: preferredRetryAfter ? this._options.maxRetryAfterDelayMs : this._options.maxPreferredDelayMs,
            min: preferredRetryAfter || 100,
            useInitialValue: Boolean(preferredRetryAfter)
        };
        this._log.info('Initializing preferred transport backoff using config: ', preferredBackoffConfig);
        const preferredBackoff = new (0, $e2f41017236580ee$export$2e2bcd8739ae039)(preferredBackoffConfig);
        preferredBackoff.on('backoff', (attempt, delay)=>{
            if (this.state === $f01d9bfcb20bcf05$export$8974257e633775ac.Closed) {
                this._log.info('Preferred backoff initiated but transport state is closed; not attempting a connection.');
                return;
            }
            this._log.info(`Will attempt to reconnect Websocket to preferred URI in ${delay}ms`);
            if (attempt === 0) {
                this._backoffStartTime.preferred = Date.now();
                this._log.info(`Preferred backoff start; ${this._backoffStartTime.preferred}`);
            }
        });
        preferredBackoff.on('ready', (attempt, _delay)=>{
            if (this.state === $f01d9bfcb20bcf05$export$8974257e633775ac.Closed) {
                this._log.info('Preferred backoff ready but transport state is closed; not attempting a connection.');
                return;
            }
            if (this._backoffStartTime.preferred === null) {
                this._log.info('Preferred backoff start time invalid; not attempting a connection.');
                return;
            }
            if (!this._backoff) {
                this._log.info('Preferred backoff instance invalid; not attempting a connection.');
                return;
            }
            if (Date.now() - this._backoffStartTime.preferred > maxPreferredDurationMs) {
                this._log.info('Max preferred backoff attempt time exceeded; falling back to primary backoff.');
                this._preferredUri = null;
                this._backoff.primary.backoff();
                return;
            }
            if (typeof this._preferredUri !== 'string') {
                this._log.info('Preferred URI cleared; falling back to primary backoff.');
                this._preferredUri = null;
                this._backoff.primary.backoff();
                return;
            }
            this._connect(this._preferredUri, attempt + 1);
        });
        const primaryBackoffConfig = {
            factor: 2.0,
            jitter: 0.40,
            max: this._options.maxPrimaryDelayMs,
            // We only want a random initial delay if there are any fallback edges
            // Initial delay between 1s and 5s both inclusive
            min: this._uris && this._uris.length > 1 ? Math.floor(Math.random() * 4001) + 1000 : 100
        };
        this._log.info('Initializing primary transport backoff using config: ', primaryBackoffConfig);
        const primaryBackoff = new (0, $e2f41017236580ee$export$2e2bcd8739ae039)(primaryBackoffConfig);
        primaryBackoff.on('backoff', (attempt, delay)=>{
            if (this.state === $f01d9bfcb20bcf05$export$8974257e633775ac.Closed) {
                this._log.info('Primary backoff initiated but transport state is closed; not attempting a connection.');
                return;
            }
            this._log.info(`Will attempt to reconnect WebSocket in ${delay}ms`);
            if (attempt === 0) {
                this._backoffStartTime.primary = Date.now();
                this._log.info(`Primary backoff start; ${this._backoffStartTime.primary}`);
            }
        });
        primaryBackoff.on('ready', (attempt, _delay)=>{
            if (this.state === $f01d9bfcb20bcf05$export$8974257e633775ac.Closed) {
                this._log.info('Primary backoff ready but transport state is closed; not attempting a connection.');
                return;
            }
            if (this._backoffStartTime.primary === null) {
                this._log.info('Primary backoff start time invalid; not attempting a connection.');
                return;
            }
            if (Date.now() - this._backoffStartTime.primary > this._options.maxPrimaryDurationMs) {
                this._log.info('Max primary backoff attempt time exceeded; not attempting a connection.');
                return;
            }
            this._connect(this._uris[this._uriIndex], attempt + 1);
        });
        return {
            preferred: preferredBackoff,
            primary: primaryBackoff
        };
    }
    /**
     * The uri the transport is currently connected to
     */ get uri() {
        return this._connectedUri;
    }
}
$f01d9bfcb20bcf05$export$2e2bcd8739ae039.defaultConstructorOptions = {
    WebSocket: $f01d9bfcb20bcf05$var$WebSocket,
    connectTimeoutMs: $f01d9bfcb20bcf05$var$CONNECT_TIMEOUT,
    maxPreferredDelayMs: $f01d9bfcb20bcf05$var$MAX_PREFERRED_DELAY,
    maxPreferredDurationMs: $f01d9bfcb20bcf05$var$MAX_PREFERRED_DURATION,
    maxPrimaryDelayMs: $f01d9bfcb20bcf05$var$MAX_PRIMARY_DELAY,
    maxPrimaryDurationMs: $f01d9bfcb20bcf05$var$MAX_PRIMARY_DURATION,
    maxRetryAfterDelayMs: $f01d9bfcb20bcf05$var$MAX_RETRY_AFTER_DELAY,
    maxRetryAfterDurationMs: $f01d9bfcb20bcf05$var$MAX_RETRY_AFTER_DURATION
};


// @ts-nocheck
const $82ba186413fb5a4d$var$PSTREAM_VERSION = '1.6';
// In seconds
const $82ba186413fb5a4d$var$MAX_RECONNECT_TIMEOUT_ALLOWED = 30;
/**
 * Constructor for PStream objects.
 *
 * @exports PStream as Twilio.PStream
 * @memberOf Twilio
 * @borrows EventEmitter#addListener as #addListener
 * @borrows EventEmitter#removeListener as #removeListener
 * @borrows EventEmitter#emit as #emit
 * @borrows EventEmitter#hasListener as #hasListener
 * @constructor
 * @param {string} token The Twilio capabilities JWT
 * @param {string[]} uris An array of PStream endpoint URIs
 * @param {object} [options]
 * @config {boolean} [options.backoffMaxMs=20000] Enable debugging
 */ class $82ba186413fb5a4d$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    constructor(token, uris, options){
        super();
        if (!(this instanceof $82ba186413fb5a4d$export$2e2bcd8739ae039)) return new $82ba186413fb5a4d$export$2e2bcd8739ae039(token, uris, options);
        const defaults = {
            TransportFactory: (0, $f01d9bfcb20bcf05$export$2e2bcd8739ae039)
        };
        options = options || {};
        for(const prop in defaults){
            if (prop in options) continue;
            options[prop] = defaults[prop];
        }
        this.options = options;
        this.token = token || '';
        this.status = 'disconnected';
        this.gateway = null;
        this.region = null;
        this._messageQueue = [];
        this._preferredUri = null;
        this._uris = uris;
        this._handleTransportClose = this._handleTransportClose.bind(this);
        this._handleTransportError = this._handleTransportError.bind(this);
        this._handleTransportMessage = this._handleTransportMessage.bind(this);
        this._handleTransportOpen = this._handleTransportOpen.bind(this);
        this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('PStream');
        // NOTE(mroberts): EventEmitter requires that we catch all errors.
        this.on('error', ()=>{
            this._log.warn('Unexpected error handled in pstream');
        });
        /*
         *events used by device
         *'invite',
         *'ready',
         *'error',
         *'offline',
         *
         *'cancel',
         *'presence',
         *'roster',
         *'answer',
         *'candidate',
         *'hangup'
         */ const self = this;
        this.addListener('ready', ()=>{
            self.status = 'ready';
        });
        this.addListener('offline', ()=>{
            self.status = 'offline';
        });
        this.addListener('close', ()=>{
            self._log.info('Received "close" from server. Destroying PStream...');
            self._destroy();
        });
        this.transport = new this.options.TransportFactory(this._uris, {
            backoffMaxMs: this.options.backoffMaxMs,
            maxPreferredDurationMs: this.options.maxPreferredDurationMs
        });
        Object.defineProperties(this, {
            uri: {
                enumerable: true,
                get () {
                    return this.transport.uri;
                }
            }
        });
        this.transport.on('close', this._handleTransportClose);
        this.transport.on('error', this._handleTransportError);
        this.transport.on('message', this._handleTransportMessage);
        this.transport.on('open', this._handleTransportOpen);
        this.transport.open();
        return this;
    }
}
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._handleTransportClose = function() {
    this.emit('transportClose');
    if (this.status !== 'disconnected') {
        if (this.status !== 'offline') this.emit('offline', this);
        this.status = 'disconnected';
    }
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._handleTransportError = function(error) {
    if (!error) {
        this.emit('error', {
            error: {
                code: 31000,
                message: 'Websocket closed without a provided reason',
                twilioError: new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionDisconnected()
            }
        });
        return;
    }
    // We receive some errors without call metadata (just the error). We need to convert these
    // to be contained within the 'error' field so that these errors match the expected format.
    this.emit('error', typeof error.code !== 'undefined' ? {
        error: error
    } : error);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._handleTransportMessage = function(msg) {
    if (!msg || !msg.data || typeof msg.data !== 'string') return;
    const { type: type, payload: payload = {} } = JSON.parse(msg.data);
    this.gateway = payload.gateway || this.gateway;
    this.region = payload.region || this.region;
    if (type === 'error' && payload.error) payload.error.twilioError = new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionError();
    this.emit(type, payload);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._handleTransportOpen = function() {
    this.status = 'connected';
    this.setToken(this.token);
    this.emit('transportOpen');
    const messages = this._messageQueue.splice(0, this._messageQueue.length);
    messages.forEach((message)=>this._publish(...message));
};
/**
 * @return {string}
 */ $82ba186413fb5a4d$export$2e2bcd8739ae039.toString = ()=>'[Twilio.PStream class]';
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.toString = ()=>'[Twilio.PStream instance]';
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.setToken = function(token) {
    this._log.info('Setting token and publishing listen');
    this.token = token;
    let reconnectTimeout = 0;
    const t = this.options.maxPreferredDurationMs;
    this._log.info(`maxPreferredDurationMs:${t}`);
    if (typeof t === 'number' && t >= 0) reconnectTimeout = Math.min(Math.ceil(t / 1000), $82ba186413fb5a4d$var$MAX_RECONNECT_TIMEOUT_ALLOWED);
    this._log.info(`reconnectTimeout:${reconnectTimeout}`);
    const payload = {
        browserinfo: $82ba186413fb5a4d$var$getBrowserInfo(),
        reconnectTimeout: reconnectTimeout,
        token: token
    };
    this._publish('listen', payload);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.sendMessage = function(callsid, content, contenttype = 'application/json', messagetype, voiceeventsid) {
    const payload = {
        callsid: callsid,
        content: content,
        contenttype: contenttype,
        messagetype: messagetype,
        voiceeventsid: voiceeventsid
    };
    this._publish('message', payload, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.register = function(mediaCapabilities) {
    const regPayload = {
        media: mediaCapabilities
    };
    // A queued register is replayed alongside `listen`, before the server
    // validates the token, and earns a 31204. Re-register on `connected` covers it.
    this._publish('register', regPayload, false);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.invite = function(sdp, callsid, params) {
    const payload = {
        callsid: callsid,
        sdp: sdp,
        twilio: params ? {
            params: params
        } : {}
    };
    this._publish('invite', payload, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.reconnect = function(sdp, callsid, reconnect) {
    const payload = {
        callsid: callsid,
        reconnect: reconnect,
        sdp: sdp,
        twilio: {}
    };
    this._publish('invite', payload, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.answer = function(sdp, callsid) {
    this._publish('answer', {
        sdp: sdp,
        callsid: callsid
    }, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.dtmf = function(callsid, digits) {
    this._publish('dtmf', {
        callsid: callsid,
        dtmf: digits
    }, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.hangup = function(callsid, message) {
    const payload = message ? {
        callsid: callsid,
        message: message
    } : {
        callsid: callsid
    };
    this._publish('hangup', payload, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.reject = function(callsid) {
    this._publish('reject', {
        callsid: callsid
    }, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.reinvite = function(sdp, callsid) {
    this._publish('reinvite', {
        sdp: sdp,
        callsid: callsid
    }, false);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._destroy = function() {
    this.transport.removeListener('close', this._handleTransportClose);
    this.transport.removeListener('error', this._handleTransportError);
    this.transport.removeListener('message', this._handleTransportMessage);
    this.transport.removeListener('open', this._handleTransportOpen);
    this.transport.close();
    this.emit('offline', this);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.destroy = function() {
    this._log.info('PStream.destroy() called...');
    this._destroy();
    return this;
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.updatePreferredURI = function(uri) {
    this._preferredUri = uri;
    this.transport.updatePreferredURI(uri);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.updateURIs = function(uris) {
    this._uris = uris;
    this.transport.updateURIs(this._uris);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype.publish = function(type, payload) {
    return this._publish(type, payload, true);
};
$82ba186413fb5a4d$export$2e2bcd8739ae039.prototype._publish = function(type, payload, shouldRetry) {
    const msg = JSON.stringify({
        payload: payload,
        type: type,
        version: $82ba186413fb5a4d$var$PSTREAM_VERSION
    });
    const isSent = !!this.transport.send(msg);
    if (!isSent) {
        this.emit('error', {
            error: {
                code: 31009,
                message: 'No transport available to send or receive messages',
                twilioError: new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).TransportError()
            }
        });
        if (shouldRetry) this._messageQueue.push([
            type,
            payload,
            true
        ]);
    }
};
function $82ba186413fb5a4d$var$getBrowserInfo() {
    const nav = typeof navigator !== 'undefined' ? navigator : {};
    const info = {
        browser: {
            platform: nav.platform || 'unknown',
            userAgent: nav.userAgent || 'unknown'
        },
        p: 'browser',
        plugin: 'rtc',
        v: (0, $1ec27394c1cce6bb$export$f1af843f4d252578)
    };
    return info;
}



/**
 * Valid edges.
 */ var $54f3bf0deee265ef$export$b9d9805c9b77a56d;
(function(Edge) {
    /**
     * Public edges
     */ Edge["Sydney"] = "sydney";
    Edge["SaoPaulo"] = "sao-paulo";
    Edge["Dublin"] = "dublin";
    Edge["Frankfurt"] = "frankfurt";
    Edge["Tokyo"] = "tokyo";
    Edge["Singapore"] = "singapore";
    Edge["Ashburn"] = "ashburn";
    Edge["Umatilla"] = "umatilla";
    Edge["Roaming"] = "roaming";
    /**
     * Interconnect edges
     */ Edge["AshburnIx"] = "ashburn-ix";
    Edge["SanJoseIx"] = "san-jose-ix";
    Edge["LondonIx"] = "london-ix";
    Edge["FrankfurtIx"] = "frankfurt-ix";
    Edge["SingaporeIx"] = "singapore-ix";
    Edge["SydneyIx"] = "sydney-ix";
    Edge["TokyoIx"] = "tokyo-ix";
})($54f3bf0deee265ef$export$b9d9805c9b77a56d || ($54f3bf0deee265ef$export$b9d9805c9b77a56d = {}));
/**
 * Valid current regions.
 *
 * @deprecated
 *
 * CLIENT-6831
 * This is no longer used or updated for checking validity of regions in the
 * SDK. We now allow any string to be passed for region. Invalid regions won't
 * be able to connect, and won't throw an exception.
 *
 * CLIENT-7519
 * This is used again to temporarily convert edge values to regions as part of
 * Phase 1 Regional. This is still considered deprecated.
 *
 * @private
 */ var $54f3bf0deee265ef$export$b1f97c3099fc6872;
(function(Region) {
    Region["Au1"] = "au1";
    Region["Au1Ix"] = "au1-ix";
    Region["Br1"] = "br1";
    Region["De1"] = "de1";
    Region["De1Ix"] = "de1-ix";
    Region["Gll"] = "gll";
    Region["Ie1"] = "ie1";
    Region["Ie1Ix"] = "ie1-ix";
    Region["Ie1Tnx"] = "ie1-tnx";
    Region["Jp1"] = "jp1";
    Region["Jp1Ix"] = "jp1-ix";
    Region["Sg1"] = "sg1";
    Region["Sg1Ix"] = "sg1-ix";
    Region["Sg1Tnx"] = "sg1-tnx";
    Region["Us1"] = "us1";
    Region["Us1Ix"] = "us1-ix";
    Region["Us1Tnx"] = "us1-tnx";
    Region["Us2"] = "us2";
    Region["Us2Ix"] = "us2-ix";
    Region["Us2Tnx"] = "us2-tnx";
})($54f3bf0deee265ef$export$b1f97c3099fc6872 || ($54f3bf0deee265ef$export$b1f97c3099fc6872 = {}));
/**
 * Region shortcodes. Maps the full region name from AWS to the Twilio shortcode.
 * @private
 */ const $54f3bf0deee265ef$export$1c34652d1f74f077 = {
    ASIAPAC_SINGAPORE: $54f3bf0deee265ef$export$b1f97c3099fc6872.Sg1,
    ASIAPAC_SYDNEY: $54f3bf0deee265ef$export$b1f97c3099fc6872.Au1,
    ASIAPAC_TOKYO: $54f3bf0deee265ef$export$b1f97c3099fc6872.Jp1,
    EU_FRANKFURT: $54f3bf0deee265ef$export$b1f97c3099fc6872.De1,
    EU_IRELAND: $54f3bf0deee265ef$export$b1f97c3099fc6872.Ie1,
    SOUTH_AMERICA_SAO_PAULO: $54f3bf0deee265ef$export$b1f97c3099fc6872.Br1,
    US_EAST_VIRGINIA: $54f3bf0deee265ef$export$b1f97c3099fc6872.Us1,
    US_WEST_OREGON: $54f3bf0deee265ef$export$b1f97c3099fc6872.Us2
};
/**
 * Region to edge mapping, as part of Phase 1 Regional (CLIENT-7519).
 * Temporary.
 * @private
 */ const $54f3bf0deee265ef$export$281ec2267fe88fc = {
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Au1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Sydney,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Br1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.SaoPaulo,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Ie1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Dublin,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.De1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Frankfurt,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Jp1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Tokyo,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Sg1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Singapore,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us1]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Ashburn,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us2]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Umatilla,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Gll]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.Roaming,
    /**
     * Interconnect edges
     */ [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.AshburnIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us2Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.SanJoseIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Ie1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.LondonIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.De1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.FrankfurtIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Sg1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.SingaporeIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Au1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.SydneyIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Jp1Ix]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.TokyoIx,
    /**
     * Tnx regions
     */ [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us1Tnx]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.AshburnIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Us2Tnx]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.AshburnIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Ie1Tnx]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.LondonIx,
    [$54f3bf0deee265ef$export$b1f97c3099fc6872.Sg1Tnx]: $54f3bf0deee265ef$export$b9d9805c9b77a56d.SingaporeIx
};
/**
 * The default edge to connect to and create a chunder uri from, if the edge
 * parameter is not specified during setup in `Device`.
 * @constant
 */ const $54f3bf0deee265ef$export$48722fb1b6b701b1 = $54f3bf0deee265ef$export$b9d9805c9b77a56d.Roaming;
/**
 * The default event gateway URI to publish to.
 * @constant
 * @private
 */ const $54f3bf0deee265ef$var$defaultEventGatewayURI = 'eventgw.twilio.com';
/**
 * String template for an edge chunder URI
 * @param edge - The edge.
 */ function $54f3bf0deee265ef$var$createChunderEdgeURI(edge) {
    return `voice-js.${edge}.twilio.com`;
}
/**
 * String template for a region insights URI
 * @param region - The region.
 */ function $54f3bf0deee265ef$export$abdefe87cb23127f(region) {
    return region ? `eventgw.${region}.twilio.com` : $54f3bf0deee265ef$var$defaultEventGatewayURI;
}
/**
 * Create a signaling endpoint URL to connect a websocket to from a chunder URI.
 * @param uri the chunder URI to create a signaling endpoint URL for
 */ function $54f3bf0deee265ef$export$754f7fe25ccfb57e(uri) {
    return `wss://${uri}/signal`;
}
/**
 * Get the URI associated with the passed edge.
 * @private
 * @param edge - A string or an array of edge values
 * @returns An array of chunder URIs
 */ function $54f3bf0deee265ef$export$fd9b936a752f2ba4(edge) {
    if (!!edge && typeof edge !== 'string' && !Array.isArray(edge)) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('If `edge` is provided, it must be of type `string` or an array of strings.');
    let uris;
    if (edge) {
        const edgeParams = Array.isArray(edge) ? edge : [
            edge
        ];
        uris = edgeParams.map((param)=>$54f3bf0deee265ef$var$createChunderEdgeURI(param));
    } else uris = [
        $54f3bf0deee265ef$var$createChunderEdgeURI($54f3bf0deee265ef$export$48722fb1b6b701b1)
    ];
    return uris;
}
/**
 * Get the region shortcode by its full AWS region string.
 *
 * @private
 * @param region - The region's full AWS string.
 */ function $54f3bf0deee265ef$export$4fb94e0d09cbcb7e(region) {
    return $54f3bf0deee265ef$export$1c34652d1f74f077[region] || null;
}








// @ts-nocheck
const $adb118a246ff8f2c$var$ptToFixedBitrateAudioCodecName = {
    0: 'PCMU',
    8: 'PCMA'
};
const $adb118a246ff8f2c$var$defaultOpusId = 111;
const $adb118a246ff8f2c$var$BITRATE_MAX = 510000;
const $adb118a246ff8f2c$var$BITRATE_MIN = 6000;
function $adb118a246ff8f2c$export$f93ca60aaaaaacb8(sdp) {
    const [, codecId, codecName] = /a=rtpmap:(\d+) (\S+)/m.exec(sdp) || [
        null,
        '',
        ''
    ];
    const regex = new RegExp(`a=fmtp:${codecId} (\\S+)`, 'm');
    const [, codecParams] = regex.exec(sdp) || [
        null,
        ''
    ];
    return {
        codecName: codecName,
        codecParams: codecParams
    };
}
function $adb118a246ff8f2c$export$ab6e8073598686ee(sdp) {
    // This only works on Chrome. We don't want any side effects on other browsers
    // https://bugs.chromium.org/p/chromium/issues/detail?id=1024096
    // https://issues.corp.twilio.com/browse/CLIENT-6911
    if (!(0, $a96769417395afb9$export$6446a186d09e379e)(window, window.navigator)) return sdp;
    return sdp.split('\n').filter((line)=>line.indexOf('a=ice-lite') === -1).join('\n');
}
function $adb118a246ff8f2c$export$698aa48f6454281f(sdp, maxAverageBitrate) {
    if (typeof maxAverageBitrate !== 'number' || maxAverageBitrate < $adb118a246ff8f2c$var$BITRATE_MIN || maxAverageBitrate > $adb118a246ff8f2c$var$BITRATE_MAX) return sdp;
    const matches = /a=rtpmap:(\d+) opus/m.exec(sdp);
    const opusId = matches && matches.length ? matches[1] : $adb118a246ff8f2c$var$defaultOpusId;
    const regex = new RegExp(`a=fmtp:${opusId}`);
    const lines = sdp.split('\n').map((line)=>regex.test(line) ? line + `;maxaveragebitrate=${maxAverageBitrate}` : line);
    return lines.join('\n');
}
/**
 * Return a new SDP string with the re-ordered codec preferences.
 * @param {string} sdp
 * @param {Array<AudioCodec>} preferredCodecs - If empty, the existing order
 *   of audio codecs is preserved
 * @returns {string} Updated SDP string
 */ function $adb118a246ff8f2c$export$487dea9b2f9e05bf(sdp, preferredCodecs) {
    const mediaSections = $adb118a246ff8f2c$var$getMediaSections(sdp);
    const session = sdp.split('\r\nm=')[0];
    return [
        session
    ].concat(mediaSections.map((section)=>{
        // Codec preferences should not be applied to m=application sections.
        if (!/^m=(audio|video)/.test(section)) return section;
        const kind = section.match(/^m=(audio|video)/)[1];
        const codecMap = $adb118a246ff8f2c$var$createCodecMapForMediaSection(section);
        const payloadTypes = $adb118a246ff8f2c$var$getReorderedPayloadTypes(codecMap, preferredCodecs);
        const newSection = $adb118a246ff8f2c$var$setPayloadTypesInMediaSection(payloadTypes, section);
        const pcmaPayloadTypes = codecMap.get('pcma') || [];
        const pcmuPayloadTypes = codecMap.get('pcmu') || [];
        const fixedBitratePayloadTypes = kind === 'audio' ? new Set(pcmaPayloadTypes.concat(pcmuPayloadTypes)) : new Set();
        return fixedBitratePayloadTypes.has(payloadTypes[0]) ? newSection.replace(/\r\nb=(AS|TIAS):([0-9]+)/g, '') : newSection;
    })).join('\r\n');
}
/**
 * Get the m= sections of a particular kind and direction from an sdp.
 * @param {string} sdp - SDP string
 * @param {string} [kind] - Pattern for matching kind
 * @param {string} [direction] - Pattern for matching direction
 * @returns {Array<string>} mediaSections
 */ function $adb118a246ff8f2c$var$getMediaSections(sdp, kind, direction) {
    return sdp.replace(/\r\n\r\n$/, '\r\n').split('\r\nm=').slice(1).map((mediaSection)=>`m=${mediaSection}`).filter((mediaSection)=>{
        const kindPattern = new RegExp(`m=${'.*'}`, 'gm');
        const directionPattern = new RegExp(`a=${'.*'}`, 'gm');
        return kindPattern.test(mediaSection) && directionPattern.test(mediaSection);
    });
}
/**
 * Create a Codec Map for the given m= section.
 * @param {string} section - The given m= section
 * @returns {Map<Codec, Array<PT>>}
 */ function $adb118a246ff8f2c$var$createCodecMapForMediaSection(section) {
    return Array.from($adb118a246ff8f2c$var$createPtToCodecName(section)).reduce((codecMap, pair)=>{
        const pt = pair[0];
        const codecName = pair[1];
        const pts = codecMap.get(codecName) || [];
        return codecMap.set(codecName, pts.concat(pt));
    }, new Map());
}
/**
 * Create the reordered Codec Payload Types based on the preferred Codec Names.
 * @param {Map<Codec, Array<PT>>} codecMap - Codec Map
 * @param {Array<Codec>} preferredCodecs - Preferred Codec Names
 * @returns {Array<PT>} Reordered Payload Types
 */ function $adb118a246ff8f2c$var$getReorderedPayloadTypes(codecMap, preferredCodecs) {
    preferredCodecs = preferredCodecs.map((codecName)=>codecName.toLowerCase());
    const preferredPayloadTypes = (0, $a96769417395afb9$export$5b8affa63fc6df16)(preferredCodecs, (codecName)=>codecMap.get(codecName) || []);
    const remainingCodecs = (0, $a96769417395afb9$export$acaf96a27438246b)(Array.from(codecMap.keys()), preferredCodecs);
    const remainingPayloadTypes = (0, $a96769417395afb9$export$5b8affa63fc6df16)(remainingCodecs, (codecName)=>codecMap.get(codecName));
    return preferredPayloadTypes.concat(remainingPayloadTypes);
}
/**
 * Set the given Codec Payload Types in the first line of the given m= section.
 * @param {Array<PT>} payloadTypes - Payload Types
 * @param {string} section - Given m= section
 * @returns {string} - Updated m= section
 */ function $adb118a246ff8f2c$var$setPayloadTypesInMediaSection(payloadTypes, section) {
    const lines = section.split('\r\n');
    let mLine = lines[0];
    const otherLines = lines.slice(1);
    mLine = mLine.replace(/([0-9]+\s?)+$/, payloadTypes.join(' '));
    return [
        mLine
    ].concat(otherLines).join('\r\n');
}
/**
 * Create a Map from PTs to codec names for the given m= section.
 * @param {string} mediaSection - The given m= section.
 * @returns {Map<PT, Codec>} ptToCodecName
 */ function $adb118a246ff8f2c$var$createPtToCodecName(mediaSection) {
    return $adb118a246ff8f2c$var$getPayloadTypesInMediaSection(mediaSection).reduce((ptToCodecName, pt)=>{
        const rtpmapPattern = new RegExp(`a=rtpmap:${pt} ([^/]+)`);
        const matches = mediaSection.match(rtpmapPattern);
        const codecName = matches ? matches[1].toLowerCase() : $adb118a246ff8f2c$var$ptToFixedBitrateAudioCodecName[pt] ? $adb118a246ff8f2c$var$ptToFixedBitrateAudioCodecName[pt].toLowerCase() : '';
        return ptToCodecName.set(pt, codecName);
    }, new Map());
}
/**
 * Get the Codec Payload Types present in the first line of the given m= section
 * @param {string} section - The m= section
 * @returns {Array<PT>} Payload Types
 */ function $adb118a246ff8f2c$var$getPayloadTypesInMediaSection(section) {
    const mLine = section.split('\r\n')[0];
    // In "m=<kind> <port> <proto> <payload_type_1> <payload_type_2> ... <payload_type_n>",
    // the regex matches <port> and the PayloadTypes.
    const matches = mLine.match(/([0-9]+)/g);
    // This should not happen, but in case there are no PayloadTypes in
    // the m= line, return an empty array.
    if (!matches) return [];
    // Since only the PayloadTypes are needed, we discard the <port>.
    return matches.slice(1).map((match)=>parseInt(match, 10));
}


// @ts-nocheck
// tslint:disable only-arrow-functions
/* global webkitRTCPeerConnection, mozRTCPeerConnection, mozRTCSessionDescription, mozRTCIceCandidate */ function $b7ceaa3e24b7b198$export$2e2bcd8739ae039(options) {
    this.log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('RTCPC');
    if (typeof window === 'undefined') {
        this.log.info('No RTCPeerConnection implementation available. The window object was not found.');
        return;
    }
    if (options && options.RTCPeerConnection) this.RTCPeerConnection = options.RTCPeerConnection;
    else if (typeof window.RTCPeerConnection === 'function') this.RTCPeerConnection = window.RTCPeerConnection;
    else if (typeof window.webkitRTCPeerConnection === 'function') this.RTCPeerConnection = webkitRTCPeerConnection;
    else if (typeof window.mozRTCPeerConnection === 'function') {
        this.RTCPeerConnection = mozRTCPeerConnection;
        window.RTCSessionDescription = mozRTCSessionDescription;
        window.RTCIceCandidate = mozRTCIceCandidate;
    } else this.log.info('No RTCPeerConnection implementation available');
}
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.create = function(rtcConfiguration) {
    this.pc = new this.RTCPeerConnection(rtcConfiguration);
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.createModernConstraints = (c)=>{
    // createOffer differs between Chrome 23 and Chrome 24+.
    // See https://groups.google.com/forum/?fromgroups=#!topic/discuss-webrtc/JBDZtrMumyU
    // Unfortunately I haven't figured out a way to detect which format
    // is required ahead of time, so we'll first try the old way, and
    // if we get an exception, then we'll try the new way.
    if (typeof c === 'undefined') return null;
    // NOTE(mroberts): As of Chrome 38, Chrome still appears to expect
    // constraints under the 'mandatory' key, and with the first letter of each
    // constraint capitalized. Firefox, on the other hand, has deprecated the
    // 'mandatory' key and does not expect the first letter of each constraint
    // capitalized.
    const nc = Object.assign({}, c);
    if (typeof webkitRTCPeerConnection !== 'undefined' && !(0, $a96769417395afb9$export$e1183ffde9eeca17)()) {
        nc.mandatory = {};
        if (typeof c.audio !== 'undefined') nc.mandatory.OfferToReceiveAudio = c.audio;
        if (typeof c.video !== 'undefined') nc.mandatory.OfferToReceiveVideo = c.video;
    } else {
        if (typeof c.audio !== 'undefined') nc.offerToReceiveAudio = c.audio;
        if (typeof c.video !== 'undefined') nc.offerToReceiveVideo = c.video;
    }
    delete nc.audio;
    delete nc.video;
    return nc;
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.createOffer = function(maxAverageBitrate, constraints, onSuccess, onError) {
    constraints = this.createModernConstraints(constraints);
    return $b7ceaa3e24b7b198$var$promisifyCreate(this.pc.createOffer, this.pc)(constraints).then((offer)=>{
        if (!this.pc) return Promise.resolve();
        const sdp = (0, $adb118a246ff8f2c$export$698aa48f6454281f)(offer.sdp, maxAverageBitrate);
        return $b7ceaa3e24b7b198$var$promisifySet(this.pc.setLocalDescription, this.pc)(new RTCSessionDescription({
            sdp: sdp,
            type: 'offer'
        }));
    }).then(onSuccess, onError);
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.createAnswer = function(maxAverageBitrate, constraints, onSuccess, onError) {
    constraints = this.createModernConstraints(constraints);
    return $b7ceaa3e24b7b198$var$promisifyCreate(this.pc.createAnswer, this.pc)(constraints).then((answer)=>{
        if (!this.pc) return Promise.resolve();
        const sdp = (0, $adb118a246ff8f2c$export$698aa48f6454281f)(answer.sdp, maxAverageBitrate);
        return $b7ceaa3e24b7b198$var$promisifySet(this.pc.setLocalDescription, this.pc)(new RTCSessionDescription({
            sdp: sdp,
            type: 'answer'
        }));
    }).then(onSuccess, onError);
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.processSDP = function(maxAverageBitrate, codecPreferences, sdp, constraints, onSuccess, onError) {
    sdp = (0, $adb118a246ff8f2c$export$487dea9b2f9e05bf)(sdp, codecPreferences);
    const desc = new RTCSessionDescription({
        sdp: sdp,
        type: 'offer'
    });
    return $b7ceaa3e24b7b198$var$promisifySet(this.pc.setRemoteDescription, this.pc)(desc).then(()=>{
        this.createAnswer(maxAverageBitrate, constraints, onSuccess, onError);
    });
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.getSDP = function() {
    return this.pc.localDescription.sdp;
};
$b7ceaa3e24b7b198$export$2e2bcd8739ae039.prototype.processAnswer = function(codecPreferences, sdp, onSuccess, onError) {
    if (!this.pc) return Promise.resolve();
    sdp = (0, $adb118a246ff8f2c$export$487dea9b2f9e05bf)(sdp, codecPreferences);
    return $b7ceaa3e24b7b198$var$promisifySet(this.pc.setRemoteDescription, this.pc)(new RTCSessionDescription({
        sdp: sdp,
        type: 'answer'
    })).then(onSuccess, onError);
};
/* NOTE(mroberts): Firefox 18 through 21 include a `mozRTCPeerConnection`
   object, but attempting to instantiate it will throw the error

       Error: PeerConnection not enabled (did you set the pref?)

   unless the `media.peerconnection.enabled` pref is enabled. So we need to test
   if we can actually instantiate `mozRTCPeerConnection`; however, if the user
   *has* enabled `media.peerconnection.enabled`, we need to perform the same
   test that we use to detect Firefox 24 and above, namely:

       typeof (new mozRTCPeerConnection()).getLocalStreams === 'function'

    NOTE(rrowland): We no longer support Legacy Edge as of Sep 1, 2020.
*/ $b7ceaa3e24b7b198$export$2e2bcd8739ae039.test = ()=>{
    if (typeof navigator === 'object') {
        const getUserMedia = navigator.mediaDevices && navigator.mediaDevices.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia;
        if ((0, $a96769417395afb9$export$e1183ffde9eeca17)(navigator)) return false;
        if (getUserMedia && typeof window.RTCPeerConnection === 'function') return true;
        else if (getUserMedia && typeof window.webkitRTCPeerConnection === 'function') return true;
        else if (getUserMedia && typeof window.mozRTCPeerConnection === 'function') {
            try {
                const test = new window.mozRTCPeerConnection();
                if (typeof test.getLocalStreams !== 'function') return false;
            } catch (e) {
                return false;
            }
            return true;
        } else if (typeof RTCIceGatherer !== 'undefined') return true;
    }
    return false;
};
function $b7ceaa3e24b7b198$var$promisify(fn, ctx, areCallbacksFirst, checkRval) {
    return function() {
        const args = Array.prototype.slice.call(arguments);
        return new Promise((resolve)=>{
            const returnValue = fn.apply(ctx, args);
            if (!checkRval) {
                resolve(returnValue);
                return;
            }
            if (typeof returnValue === 'object' && typeof returnValue.then === 'function') resolve(returnValue);
            else throw new Error();
        }).catch(()=>new Promise((resolve, reject)=>{
                fn.apply(ctx, areCallbacksFirst ? [
                    resolve,
                    reject
                ].concat(args) : args.concat([
                    resolve,
                    reject
                ]));
            }));
    };
}
function $b7ceaa3e24b7b198$var$promisifyCreate(fn, ctx) {
    return $b7ceaa3e24b7b198$var$promisify(fn, ctx, true, true);
}
function $b7ceaa3e24b7b198$var$promisifySet(fn, ctx) {
    return $b7ceaa3e24b7b198$var$promisify(fn, ctx, false, false);
}




// @ts-nocheck
const $96a759d7ffb58b23$var$ICE_GATHERING_TIMEOUT = 15000;
const $96a759d7ffb58b23$var$ICE_GATHERING_FAIL_NONE = 'none';
const $96a759d7ffb58b23$var$ICE_GATHERING_FAIL_TIMEOUT = 'timeout';
const $96a759d7ffb58b23$var$INITIAL_ICE_CONNECTION_STATE = 'new';
const $96a759d7ffb58b23$var$VOLUME_INTERVAL_MS = 50;
/**
 * @typedef {Object} PeerConnection
 * @param audioHelper
 * @param pstream
 * @param options
 * @return {PeerConnection}
 * @constructor
 */ function $96a759d7ffb58b23$export$2e2bcd8739ae039(audioHelper, pstream, options) {
    if (!audioHelper || !pstream) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Audiohelper, and pstream are required arguments');
    if (!(this instanceof $96a759d7ffb58b23$export$2e2bcd8739ae039)) return new $96a759d7ffb58b23$export$2e2bcd8739ae039(audioHelper, pstream, options);
    this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('PeerConnection');
    function noop() {
        this._log.warn('Unexpected noop call in peerconnection');
    }
    this.onaudio = noop;
    this.onopen = noop;
    this.onerror = noop;
    this.onclose = noop;
    this.ondisconnected = noop;
    this.onfailed = noop;
    this.onconnected = noop;
    this.onreconnected = noop;
    this.onsignalingstatechange = noop;
    this.ondtlstransportstatechange = noop;
    this.onicegatheringfailure = noop;
    this.onicegatheringstatechange = noop;
    this.oniceconnectionstatechange = noop;
    this.onpcconnectionstatechange = noop;
    this.onicecandidate = noop;
    this.onselectedcandidatepairchange = noop;
    this.onvolume = noop;
    this.version = null;
    this.pstream = pstream;
    this.stream = null;
    this.sinkIds = new Set([
        'default'
    ]);
    this.outputs = new Map();
    this.status = 'connecting';
    this.callSid = null;
    this.isMuted = false;
    const AudioContext = typeof window !== 'undefined' && (window.AudioContext || window.webkitAudioContext);
    this._isSinkSupported = !!AudioContext && typeof HTMLAudioElement !== 'undefined' && HTMLAudioElement.prototype.setSinkId;
    // NOTE(mmalavalli): Since each Connection creates its own AudioContext,
    // after 6 instances an exception is thrown. Refer https://www.w3.org/2011/audio/track/issues/3.
    // In order to get around it, we are re-using the Device's AudioContext.
    this._audioContext = AudioContext && audioHelper._audioContext;
    this._audioHelper = audioHelper;
    this._audioProcessorEventObserver = audioHelper._getAudioProcessorEventObserver();
    this._hasIceCandidates = false;
    this._hasIceGatheringFailures = false;
    this._iceGatheringTimeoutId = null;
    this._masterAudio = null;
    this._masterAudioDeviceId = null;
    this._mediaStreamSource = null;
    this._dtmfSender = null;
    this._dtmfSenderUnsupported = false;
    this._callEvents = [];
    this._nextTimeToPublish = Date.now();
    this._onAnswerOrRinging = noop;
    this._onHangup = noop;
    this._remoteStream = null;
    this._shouldManageStream = true;
    this._iceState = $96a759d7ffb58b23$var$INITIAL_ICE_CONNECTION_STATE;
    this.options = options = options || {};
    this.navigator = options.navigator || (typeof navigator !== 'undefined' ? navigator : null);
    this.util = options.util || $a96769417395afb9$exports;
    this.codecPreferences = options.codecPreferences;
    this._onAudioProcessorAdded = (isRemote)=>{
        this._handleAudioProcessorEvent(isRemote, true);
    };
    this._onAudioProcessorRemoved = (isRemote)=>{
        this._handleAudioProcessorEvent(isRemote, false);
    };
    this._audioProcessorEventObserver.on('add', this._onAudioProcessorAdded);
    this._audioProcessorEventObserver.on('remove', this._onAudioProcessorRemoved);
    return this;
}
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.uri = function() {
    return this._uri;
};
/**
 * Open the underlying RTCPeerConnection with a MediaStream obtained by
 *   passed constraints. The resulting MediaStream is created internally
 *   and will therefore be managed and destroyed internally.
 * @param {MediaStreamConstraints} constraints
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.openDefaultDeviceWithConstraints = function(constraints) {
    return this._audioHelper._openDefaultDeviceWithConstraints(constraints).then(this._setInputTracksFromStream.bind(this, false));
};
/**
 * Replace the existing input audio tracks with the audio tracks from the
 *   passed input audio stream. We re-use the existing stream because
 *   the AnalyzerNode is bound to the stream.
 * @param {MediaStream} stream
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.setInputTracksFromStream = function(stream) {
    const self = this;
    return this._setInputTracksFromStream(true, stream).then(()=>{
        self._shouldManageStream = false;
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._createAnalyser = (audioContext, options)=>{
    options = Object.assign({
        fftSize: 32,
        smoothingTimeConstant: 0.3
    }, options);
    const analyser = audioContext.createAnalyser();
    // tslint:disable-next-line
    for(const field in options)analyser[field] = options[field];
    return analyser;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setVolumeHandler = function(handler) {
    this.onvolume = handler;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._startPollingVolume = function() {
    if (!this._audioContext || !this.stream || !this._remoteStream) return;
    const audioContext = this._audioContext;
    const inputAnalyser = this._inputAnalyser = this._createAnalyser(audioContext);
    const inputBufferLength = inputAnalyser.frequencyBinCount;
    const inputDataArray = new Uint8Array(inputBufferLength);
    this._inputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    const outputAnalyser = this._outputAnalyser = this._createAnalyser(audioContext);
    const outputBufferLength = outputAnalyser.frequencyBinCount;
    const outputDataArray = new Uint8Array(outputBufferLength);
    this._outputAnalyser2 = this._createAnalyser(audioContext, {
        maxDecibels: 0,
        minDecibels: -127,
        smoothingTimeConstant: 0
    });
    this._updateInputStreamSource(this.stream);
    this._updateOutputStreamSource(this._remoteStream);
    const self = this;
    setTimeout(function emitVolume() {
        if (!self._audioContext) return;
        else if (self.status === 'closed') {
            self._inputAnalyser.disconnect();
            self._outputAnalyser.disconnect();
            self._inputAnalyser2.disconnect();
            self._outputAnalyser2.disconnect();
            return;
        }
        self._inputAnalyser.getByteFrequencyData(inputDataArray);
        const inputVolume = self.util.average(inputDataArray);
        self._inputAnalyser2.getByteFrequencyData(inputDataArray);
        const inputVolume2 = self.util.average(inputDataArray);
        self._outputAnalyser.getByteFrequencyData(outputDataArray);
        const outputVolume = self.util.average(outputDataArray);
        self._outputAnalyser2.getByteFrequencyData(outputDataArray);
        const outputVolume2 = self.util.average(outputDataArray);
        self.onvolume(inputVolume / 255, outputVolume / 255, inputVolume2, outputVolume2);
        setTimeout(emitVolume, $96a759d7ffb58b23$var$VOLUME_INTERVAL_MS);
    }, $96a759d7ffb58b23$var$VOLUME_INTERVAL_MS);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._stopStream = function _stopStream() {
    // We shouldn't stop the tracks if they were not created inside
    //   this PeerConnection.
    if (!this._shouldManageStream) return;
    this._audioHelper._stopDefaultInputDeviceStream();
};
/**
 * Update the stream source with the new input audio stream.
 * @param {MediaStream} stream
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._updateInputStreamSource = function(stream) {
    if (this._inputStreamSource) this._inputStreamSource.disconnect();
    try {
        this._inputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._inputStreamSource.connect(this._inputAnalyser);
        this._inputStreamSource.connect(this._inputAnalyser2);
    } catch (ex) {
        this._log.warn('Unable to update input MediaStreamSource', ex);
        this._inputStreamSource = null;
    }
};
/**
 * Update the stream source with the new ouput audio stream.
 * @param {MediaStream} stream
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._updateOutputStreamSource = function(stream) {
    if (this._outputStreamSource) this._outputStreamSource.disconnect();
    try {
        this._outputStreamSource = this._audioContext.createMediaStreamSource(stream);
        this._outputStreamSource.connect(this._outputAnalyser);
        this._outputStreamSource.connect(this._outputAnalyser2);
    } catch (ex) {
        this._log.warn('Unable to update output MediaStreamSource', ex);
        this._outputStreamSource = null;
    }
};
/**
 * Replace the tracks of the current stream with new tracks. We do this rather than replacing the
 *   whole stream because AnalyzerNodes are bound to a stream.
 * @param {Boolean} shouldClone - Whether the stream should be cloned if it is the first
 *   stream, or set directly. As a rule of thumb, streams that are passed in externally may have
 *   their lifecycle managed externally, and should be cloned so that we do not tear it or its tracks
 *   down when the call ends. Streams that we create internally (inside PeerConnection) should be set
 *   directly so that when the call ends it is disposed of.
 * @param {MediaStream} newStream - The new stream to copy the tracks over from.
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setInputTracksFromStream = function(shouldClone, newStream) {
    if (!newStream) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)('Can not set input stream to null while in a call'));
    if (!newStream.getAudioTracks().length) return Promise.reject(new (0, $d122425987f9ca02$export$9c711d4a95378233)('Supplied input stream has no audio tracks'));
    const localStream = this.stream;
    const getStreamPromise = ()=>{
        // Apply mute settings to new input track
        this.mute(this.isMuted);
        return Promise.resolve(this.stream);
    };
    if (!localStream) // We can't use MediaStream.clone() here because it stopped copying over tracks
    //   as of Chrome 61. https://bugs.chromium.org/p/chromium/issues/detail?id=770908
    this.stream = shouldClone ? $96a759d7ffb58b23$var$cloneStream(newStream, this.options.MediaStream) : newStream;
    else {
        // If the call was started with gUM, and we are now replacing that track with an
        // external stream's tracks, we should stop the old managed track.
        if (this._shouldManageStream) this._stopStream();
        if (!this._sender) this._sender = this.version.pc.getSenders()[0];
        return this._sender.replaceTrack(newStream.getAudioTracks()[0]).then(()=>{
            this._updateInputStreamSource(newStream);
            this.stream = shouldClone ? $96a759d7ffb58b23$var$cloneStream(newStream, this.options.MediaStream) : newStream;
            return getStreamPromise();
        });
    }
    return getStreamPromise();
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._onInputDevicesChanged = function() {
    if (!this.stream) return;
    // If all of our active tracks are ended, then our active input was lost
    const activeInputWasLost = this.stream.getAudioTracks().every((track)=>track.readyState === 'ended');
    // We only want to act if we manage the stream in PeerConnection (It was created
    // here, rather than passed in.)
    if (activeInputWasLost && this._shouldManageStream) this.openDefaultDeviceWithConstraints({
        audio: true
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._onIceGatheringFailure = function(type) {
    this._hasIceGatheringFailures = true;
    this.onicegatheringfailure(type);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._onMediaConnectionStateChange = function(newState) {
    const previousState = this._iceState;
    if (previousState === newState || newState !== 'connected' && newState !== 'disconnected' && newState !== 'failed') return;
    this._iceState = newState;
    let message;
    switch(newState){
        case 'connected':
            if (previousState === 'disconnected' || previousState === 'failed') {
                message = 'ICE liveliness check succeeded. Connection with Twilio restored';
                this._log.info(message);
                this.onreconnected(message);
            } else {
                message = 'Media connection established.';
                this._log.info(message);
                this.onconnected(message);
            }
            this._stopIceGatheringTimeout();
            this._hasIceGatheringFailures = false;
            break;
        case 'disconnected':
            message = 'ICE liveliness check failed. May be having trouble connecting to Twilio';
            this._log.warn(message);
            this.ondisconnected(message);
            break;
        case 'failed':
            message = 'Connection with Twilio was interrupted.';
            this._log.warn(message);
            this.onfailed(message);
            break;
    }
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setSinkIds = function(sinkIds) {
    if (!this._isSinkSupported) return Promise.reject(new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('Audio output selection is not supported by this browser'));
    this.sinkIds = new Set(sinkIds.forEach ? sinkIds : [
        sinkIds
    ]);
    return this.version ? this._updateAudioOutputs() : Promise.resolve();
};
/**
 * Start timeout for ICE Gathering
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._startIceGatheringTimeout = function startIceGatheringTimeout() {
    this._stopIceGatheringTimeout();
    this._iceGatheringTimeoutId = setTimeout(()=>{
        this._onIceGatheringFailure($96a759d7ffb58b23$var$ICE_GATHERING_FAIL_TIMEOUT);
    }, $96a759d7ffb58b23$var$ICE_GATHERING_TIMEOUT);
};
/**
 * Stop timeout for ICE Gathering
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._stopIceGatheringTimeout = function stopIceGatheringTimeout() {
    clearInterval(this._iceGatheringTimeoutId);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._updateAudioOutputs = function updateAudioOutputs() {
    const addedOutputIds = Array.from(this.sinkIds).filter(function(id) {
        return !this.outputs.has(id);
    }, this);
    const removedOutputIds = Array.from(this.outputs.keys()).filter(function(id) {
        return !this.sinkIds.has(id);
    }, this);
    const self = this;
    const createOutputPromises = addedOutputIds.map(this._createAudioOutput, this);
    return Promise.all(createOutputPromises).then(()=>Promise.all(removedOutputIds.map(self._removeAudioOutput, self)));
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._createAudio = function createAudio(arr) {
    const audio = new Audio(arr);
    this.onaudio(audio);
    return audio;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._createAudioOutput = function createAudioOutput(id) {
    let dest = null;
    if (this._mediaStreamSource) {
        dest = this._audioContext.createMediaStreamDestination();
        this._mediaStreamSource.connect(dest);
    }
    const audio = this._createAudio();
    $96a759d7ffb58b23$var$setAudioSource(audio, dest && dest.stream ? dest.stream : this.pcStream, this._audioHelper).catch(()=>this._log.error('Error attaching stream to element (_createAudioOutput).'));
    const self = this;
    return audio.setSinkId(id).then(()=>audio.play()).then(()=>{
        self.outputs.set(id, {
            audio: audio,
            dest: dest
        });
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._removeAudioOutputs = function removeAudioOutputs() {
    if (this._masterAudio && typeof this._masterAudioDeviceId !== 'undefined') {
        this._disableOutput(this, this._masterAudioDeviceId);
        this.outputs.delete(this._masterAudioDeviceId);
        this._masterAudioDeviceId = null;
        // Release the audio resources before deleting the audio
        if (!this._masterAudio.paused) this._masterAudio.pause();
        if (typeof this._masterAudio.srcObject !== 'undefined') this._masterAudio.srcObject = null;
        else this._masterAudio.src = '';
        this._masterAudio = null;
    }
    return Array.from(this.outputs.keys()).map(this._removeAudioOutput, this);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._disableOutput = function disableOutput(pc, id) {
    const output = pc.outputs.get(id);
    if (!output) return;
    if (output.audio) {
        output.audio.pause();
        output.audio.src = '';
    }
    if (output.dest) output.dest.disconnect();
};
/**
 * Disable a non-master output, and update the master output to assume its state. This
 *   is called when the device ID assigned to the master output has been removed from
 *   active devices. We can not simply remove the master audio output, so we must
 *   instead reassign it.
 * @private
 * @param {PeerConnection} pc
 * @param {string} masterId - The current device ID assigned to the master audio element.
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._reassignMasterOutput = function reassignMasterOutput(pc, masterId) {
    const masterOutput = pc.outputs.get(masterId);
    pc.outputs.delete(masterId);
    const self = this;
    const activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    const idToReplace = typeof activeDeviceId === 'string' ? activeDeviceId : 'default';
    return masterOutput.audio.setSinkId(idToReplace).then(()=>{
        self._disableOutput(pc, idToReplace);
        pc.outputs.set(idToReplace, masterOutput);
        pc._masterAudioDeviceId = idToReplace;
    }).catch(function rollback() {
        pc.outputs.set(masterId, masterOutput);
        self._log.info('Could not reassign master output. Attempted to roll back.');
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._removeAudioOutput = function removeAudioOutput(id) {
    if (this._masterAudioDeviceId === id) return this._reassignMasterOutput(this, id);
    this._disableOutput(this, id);
    this.outputs.delete(id);
    return Promise.resolve();
};
/**
 * Use an AudioContext to potentially split our audio output stream to multiple
 *   audio devices. This is only available to browsers with AudioContext and
 *   HTMLAudioElement.setSinkId() available. We save the source stream in
 *   _masterAudio, and use it for one of the active audio devices. We keep
 *   track of its ID because we must replace it if we lose its initial device.
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._onAddTrack = function onAddTrack(pc, stream) {
    const audio = pc._masterAudio = this._createAudio();
    $96a759d7ffb58b23$var$setAudioSource(audio, stream, this._audioHelper).then(()=>audio.play()).catch(()=>pc._log.error('Error attaching stream to element (_onAddTrack).'));
    // Assign the initial master audio element to a random active output device
    const activeDeviceId = Array.from(pc.outputs.keys())[0];
    // The audio device key could also be '' on Chrome if no media device permissions are allowed
    const deviceId = typeof activeDeviceId === 'string' ? activeDeviceId : 'default';
    pc._masterAudioDeviceId = deviceId;
    pc.outputs.set(deviceId, {
        audio: audio
    });
    try {
        pc._mediaStreamSource = pc._audioContext.createMediaStreamSource(stream);
    } catch (ex) {
        this._log.warn('Unable to create a MediaStreamSource from onAddTrack', ex);
        this._mediaStreamSource = null;
    }
    pc.pcStream = stream;
    pc._updateAudioOutputs();
};
/**
 * Use a single audio element to play the audio output stream. This does not
 *   support multiple output devices, and is a fallback for when AudioContext
 *   and/or HTMLAudioElement.setSinkId() is not available to the client.
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._fallbackOnAddTrack = function fallbackOnAddTrack(pc, stream) {
    const audio = document && document.createElement('audio');
    $96a759d7ffb58b23$var$setAudioSource(audio, stream, this._audioHelper).then(()=>audio.play()).catch(()=>pc._log.error('Error attaching stream to element (_fallbackOnAddTrack).'));
    pc.outputs.set('default', {
        audio: audio
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setEncodingParameters = function(enableDscp) {
    if (!enableDscp || !this._sender || typeof this._sender.getParameters !== 'function' || typeof this._sender.setParameters !== 'function') return;
    const params = this._sender.getParameters();
    if (!params.priority && !(params.encodings && params.encodings.length)) return;
    // This is how MDN's RTPSenderParameters defines priority
    params.priority = 'high';
    // And this is how it's currently implemented in Chrome M72+
    if (params.encodings && params.encodings.length) params.encodings.forEach((encoding)=>{
        encoding.priority = 'high';
        encoding.networkPriority = 'high';
    });
    this._sender.setParameters(params);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setupPeerConnection = function(rtcConfiguration) {
    const self = this;
    const version = new (this.options.rtcpcFactory || (0, $b7ceaa3e24b7b198$export$2e2bcd8739ae039))({
        RTCPeerConnection: this.options.RTCPeerConnection
    });
    version.create(rtcConfiguration);
    $96a759d7ffb58b23$var$addStream(version.pc, this.stream);
    const supportedCodecs = RTCRtpReceiver.getCapabilities('audio').codecs;
    this._log.debug('sorting codecs', supportedCodecs, this.codecPreferences);
    const sortedCodecs = (0, $a96769417395afb9$export$7805aadce86aebbf)(supportedCodecs, this.codecPreferences);
    const [transceiver] = version.pc.getTransceivers();
    this._log.debug('setting sorted codecs', sortedCodecs);
    transceiver.setCodecPreferences(sortedCodecs);
    const eventName = 'ontrack' in version.pc ? 'ontrack' : 'onaddstream';
    version.pc[eventName] = (event)=>{
        const stream = self._remoteStream = event.stream || event.streams[0];
        if (typeof version.pc.getSenders === 'function') this._sender = version.pc.getSenders()[0];
        if (self._isSinkSupported) self._onAddTrack(self, stream);
        else self._fallbackOnAddTrack(self, stream);
        self._startPollingVolume();
    };
    return version;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._maybeSetIceAggressiveNomination = function(sdp) {
    return this.options.forceAggressiveIceNomination ? (0, $adb118a246ff8f2c$export$ab6e8073598686ee)(sdp) : sdp;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setupChannel = function() {
    const pc = this.version.pc;
    // Chrome 25 supports onopen
    this.version.pc.onopen = ()=>{
        this.status = 'open';
        this.onopen();
    };
    // Chrome 26 doesn't support onopen so must detect state change
    this.version.pc.onstatechange = ()=>{
        if (this.version.pc && this.version.pc.readyState === 'stable') {
            this.status = 'open';
            this.onopen();
        }
    };
    // Chrome 27 changed onstatechange to onsignalingstatechange
    this.version.pc.onsignalingstatechange = ()=>{
        const state = pc.signalingState;
        this._log.info(`signalingState is "${state}"`);
        if (this.version.pc && this.version.pc.signalingState === 'stable') {
            this.status = 'open';
            this.onopen();
        }
        this.onsignalingstatechange(pc.signalingState);
    };
    // Chrome 72+
    pc.onconnectionstatechange = (event)=>{
        let state = pc.connectionState;
        if (!state && event && event.target) {
            // VDI environment
            const targetPc = event.target;
            state = targetPc.connectionState || targetPc.connectionState_;
            this._log.info(`pc.connectionState not detected. Using target PC. State=${state}`);
        }
        if (!state) this._log.warn(`onconnectionstatechange detected but state is "${state}"`);
        else this._log.info(`pc.connectionState is "${state}"`);
        this.onpcconnectionstatechange(state);
        this._onMediaConnectionStateChange(state);
    };
    pc.onicecandidate = (event)=>{
        const { candidate: candidate } = event;
        if (candidate) {
            this._hasIceCandidates = true;
            this.onicecandidate(candidate);
            this._setupRTCIceTransportListener();
        }
        this._log.info(`ICE Candidate: ${JSON.stringify(candidate)}`);
    };
    pc.onicegatheringstatechange = ()=>{
        const state = pc.iceGatheringState;
        if (state === 'gathering') this._startIceGatheringTimeout();
        else if (state === 'complete') {
            this._stopIceGatheringTimeout();
            // Fail if no candidates found
            if (!this._hasIceCandidates) this._onIceGatheringFailure($96a759d7ffb58b23$var$ICE_GATHERING_FAIL_NONE);
            // There was a failure mid-gathering phase. We want to start our timer and issue
            // an ice restart if we don't get connected after our timeout
            if (this._hasIceCandidates && this._hasIceGatheringFailures) this._startIceGatheringTimeout();
        }
        this._log.info(`pc.iceGatheringState is "${pc.iceGatheringState}"`);
        this.onicegatheringstatechange(state);
    };
    pc.oniceconnectionstatechange = ()=>{
        this._log.info(`pc.iceConnectionState is "${pc.iceConnectionState}"`);
        this.oniceconnectionstatechange(pc.iceConnectionState);
        this._onMediaConnectionStateChange(pc.iceConnectionState);
    };
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._initializeMediaStream = function(rtcConfiguration) {
    // if mediastream already open then do nothing
    if (this.status === 'open') return false;
    if (this.pstream.status === 'disconnected') {
        this.onerror({
            info: {
                code: 31000,
                message: 'Cannot establish connection. Client is disconnected',
                twilioError: new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionDisconnected()
            }
        });
        this.close();
        return false;
    }
    this.version = this._setupPeerConnection(rtcConfiguration);
    this._setupChannel();
    return true;
};
/**
 * Remove reconnection-related listeners
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._removeReconnectionListeners = function() {
    if (this.pstream) {
        this.pstream.removeListener('answer', this._onAnswerOrRinging);
        this.pstream.removeListener('hangup', this._onHangup);
    }
};
/**
 * Setup a listener for RTCDtlsTransport to capture state changes events
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setupRTCDtlsTransportListener = function() {
    const dtlsTransport = this.getRTCDtlsTransport();
    if (!dtlsTransport || dtlsTransport.onstatechange) return;
    const handler = ()=>{
        this._log.info(`dtlsTransportState is "${dtlsTransport.state}"`);
        this.ondtlstransportstatechange(dtlsTransport.state);
    };
    // Publish initial state
    handler();
    dtlsTransport.onstatechange = handler;
};
/**
 * Setup a listener for RTCIceTransport to capture selected candidate pair changes
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._setupRTCIceTransportListener = function() {
    const iceTransport = this._getRTCIceTransport();
    if (!iceTransport || iceTransport.onselectedcandidatepairchange) return;
    iceTransport.onselectedcandidatepairchange = ()=>this.onselectedcandidatepairchange(iceTransport.getSelectedCandidatePair());
};
/**
 * Restarts ICE for the current connection
 * ICE Restart failures are ignored. Retries are managed in Connection
 * @private
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.iceRestart = function() {
    this._log.info('Attempting to restart ICE...');
    this._hasIceCandidates = false;
    this.version.createOffer(this.options.maxAverageBitrate, {
        iceRestart: true
    }).then(()=>{
        this._removeReconnectionListeners();
        this._onAnswerOrRinging = (payload)=>{
            this._removeReconnectionListeners();
            if (!payload.sdp || this.version.pc.signalingState !== 'have-local-offer') {
                const message = 'Invalid state or param during ICE Restart:' + `hasSdp:${!!payload.sdp}, signalingState:${this.version.pc.signalingState}`;
                this._log.warn(message);
                return;
            }
            const sdp = this._maybeSetIceAggressiveNomination(payload.sdp);
            this._answerSdp = sdp;
            if (this.status !== 'closed') this.version.processAnswer(this.codecPreferences, sdp, null, (err)=>{
                const message = err && err.message ? err.message : err;
                this._log.error(`Failed to process answer during ICE Restart. Error: ${message}`);
            });
        };
        this._onHangup = ()=>{
            this._log.info('Received hangup during ICE Restart');
            this._removeReconnectionListeners();
        };
        this.pstream.on('answer', this._onAnswerOrRinging);
        this.pstream.on('hangup', this._onHangup);
        this.pstream.reinvite(this.version.getSDP(), this.callSid);
    }).catch((err)=>{
        const message = err && err.message ? err.message : err;
        this._log.error(`Failed to createOffer during ICE Restart. Error: ${message}`);
        // CreateOffer failures doesn't transition ice state to failed
        // We need trigger it so it can be picked up by retries
        this.onfailed(message);
    });
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.makeOutgoingCall = function(params, signalingReconnectToken, callsid, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    const self = this;
    this.callSid = callsid;
    function onAnswerSuccess() {
        if (self.options) self._setEncodingParameters(self.options.dscp);
        onMediaStarted(self.version.pc);
    }
    function onAnswerError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error processing answer: ${errMsg}`,
                twilioError: new (0, $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899).ClientRemoteDescFailed()
            }
        });
    }
    this._onAnswerOrRinging = (payload)=>{
        if (!payload.sdp) return;
        const sdp = this._maybeSetIceAggressiveNomination(payload.sdp);
        self._answerSdp = sdp;
        if (self.status !== 'closed') self.version.processAnswer(this.codecPreferences, sdp, onAnswerSuccess, onAnswerError);
        self.pstream.removeListener('answer', self._onAnswerOrRinging);
        self.pstream.removeListener('ringing', self._onAnswerOrRinging);
    };
    this.pstream.on('answer', this._onAnswerOrRinging);
    this.pstream.on('ringing', this._onAnswerOrRinging);
    function onOfferSuccess() {
        if (self.status !== 'closed') {
            if (signalingReconnectToken) self.pstream.reconnect(self.version.getSDP(), self.callSid, signalingReconnectToken);
            else self.pstream.invite(self.version.getSDP(), self.callSid, params);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onOfferError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error creating the offer: ${errMsg}`,
                twilioError: new (0, $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899).ClientLocalDescFailed()
            }
        });
    }
    this.version.createOffer(this.options.maxAverageBitrate, {
        audio: true
    }, onOfferSuccess, onOfferError);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.answerIncomingCall = function(callSid, sdp, rtcConfiguration, onMediaStarted) {
    if (!this._initializeMediaStream(rtcConfiguration)) return;
    sdp = this._maybeSetIceAggressiveNomination(sdp);
    this._answerSdp = sdp.replace(/^a=setup:actpass$/gm, 'a=setup:passive');
    this.callSid = callSid;
    const self = this;
    function onAnswerSuccess() {
        if (self.status !== 'closed') {
            self.pstream.answer(self.version.getSDP(), callSid);
            if (self.options) self._setEncodingParameters(self.options.dscp);
            onMediaStarted(self.version.pc);
            self._setupRTCDtlsTransportListener();
        }
    }
    function onAnswerError(err) {
        const errMsg = err.message || err;
        self.onerror({
            info: {
                code: 31000,
                message: `Error creating the answer: ${errMsg}`,
                twilioError: new (0, $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899).ClientRemoteDescFailed()
            }
        });
    }
    this.version.processSDP(this.options.maxAverageBitrate, this.codecPreferences, sdp, {
        audio: true
    }, onAnswerSuccess, onAnswerError);
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.close = function() {
    if (this.version && this.version.pc) {
        if (this.version.pc.signalingState !== 'closed') this.version.pc.close();
        this.version.pc = null;
    }
    if (this.stream) {
        this.mute(false);
        this._stopStream();
    }
    this.stream = null;
    this._removeReconnectionListeners();
    this._stopIceGatheringTimeout();
    this._audioHelper._destroyRemoteProcessedStream();
    this._audioProcessorEventObserver.removeListener('add', this._onAudioProcessorAdded);
    this._audioProcessorEventObserver.removeListener('remove', this._onAudioProcessorRemoved);
    Promise.all(this._removeAudioOutputs()).catch(()=>{
    // We don't need to alert about failures here.
    });
    if (this._mediaStreamSource) this._mediaStreamSource.disconnect();
    if (this._inputAnalyser) this._inputAnalyser.disconnect();
    if (this._outputAnalyser) this._outputAnalyser.disconnect();
    if (this._inputAnalyser2) this._inputAnalyser2.disconnect();
    if (this._outputAnalyser2) this._outputAnalyser2.disconnect();
    this.status = 'closed';
    this.onclose();
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.reject = function(callSid) {
    this.callSid = callSid;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.ignore = function(callSid) {
    this.callSid = callSid;
};
/**
 * Mute or unmute input audio. If the stream is not yet present, the setting
 *   is saved and applied to future streams/tracks.
 * @params {boolean} shouldMute - Whether the input audio should
 *   be muted or unmuted.
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.mute = function(shouldMute) {
    this.isMuted = shouldMute;
    if (!this.stream) return;
    if (this._sender && this._sender.track) this._sender.track.enabled = !shouldMute;
    else {
        const audioTracks = typeof this.stream.getAudioTracks === 'function' ? this.stream.getAudioTracks() : this.stream.audioTracks;
        audioTracks.forEach((track)=>{
            track.enabled = !shouldMute;
        });
    }
};
/**
 * Get or create an RTCDTMFSender for the first local audio MediaStreamTrack
 * we can get from the RTCPeerConnection. Return null if unsupported.
 * @instance
 * @returns ?RTCDTMFSender
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.getOrCreateDTMFSender = function getOrCreateDTMFSender() {
    if (this._dtmfSender || this._dtmfSenderUnsupported) return this._dtmfSender || null;
    const self = this;
    const pc = this.version.pc;
    if (!pc) {
        this._log.warn('No RTCPeerConnection available to call createDTMFSender on');
        return null;
    }
    if (typeof pc.getSenders === 'function' && (typeof RTCDTMFSender === 'function' || typeof RTCDtmfSender === 'function')) {
        const chosenSender = pc.getSenders().find((sender)=>sender.dtmf);
        if (chosenSender) {
            this._log.info('Using RTCRtpSender#dtmf');
            this._dtmfSender = chosenSender.dtmf;
            return this._dtmfSender;
        }
    }
    if (typeof pc.createDTMFSender === 'function' && typeof pc.getLocalStreams === 'function') {
        const track = pc.getLocalStreams().map((stream)=>{
            const tracks = self._getAudioTracks(stream);
            return tracks && tracks[0];
        })[0];
        if (!track) {
            this._log.warn('No local audio MediaStreamTrack available on the RTCPeerConnection to pass to createDTMFSender');
            return null;
        }
        this._log.info('Creating RTCDTMFSender');
        this._dtmfSender = pc.createDTMFSender(track);
        return this._dtmfSender;
    }
    this._log.info('RTCPeerConnection does not support RTCDTMFSender');
    this._dtmfSenderUnsupported = true;
    return null;
};
/**
 * Get the RTCDtlTransport object from the PeerConnection
 * @returns RTCDtlTransport
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype.getRTCDtlsTransport = function getRTCDtlsTransport() {
    const sender = this.version && this.version.pc && typeof this.version.pc.getSenders === 'function' && this.version.pc.getSenders()[0];
    return sender && sender.transport || null;
};
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._canStopMediaStreamTrack = ()=>typeof MediaStreamTrack.prototype.stop === 'function';
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._getAudioTracks = (stream)=>typeof stream.getAudioTracks === 'function' ? stream.getAudioTracks() : stream.audioTracks;
/**
 * Get the RTCIceTransport object from the PeerConnection
 * @returns RTCIceTransport
 */ $96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._getRTCIceTransport = function _getRTCIceTransport() {
    const dtlsTransport = this.getRTCDtlsTransport();
    return dtlsTransport && dtlsTransport.iceTransport || null;
};
// Is PeerConnection.protocol used outside of our SDK? We should remove this if not.
$96a759d7ffb58b23$export$2e2bcd8739ae039.protocol = (()=>(0, $b7ceaa3e24b7b198$export$2e2bcd8739ae039).test() ? new (0, $b7ceaa3e24b7b198$export$2e2bcd8739ae039)() : null)();
$96a759d7ffb58b23$export$2e2bcd8739ae039.prototype._handleAudioProcessorEvent = function(isRemote, isAddProcessor) {
    if (!isRemote || !this._remoteStream) return;
    let audio = null;
    if (this._masterAudio) {
        this._log.info('Setting audio source for master audio.');
        audio = this._masterAudio;
    } else {
        this._log.info('No master audio. Setting audio source for default audio output.');
        audio = this.outputs.get('default').audio;
    }
    $96a759d7ffb58b23$var$setAudioSource(audio, this._remoteStream, this._audioHelper).then(()=>{
        const successLog = isAddProcessor ? 'Successfully updated audio source with processed stream' : 'Successfully reverted audio source to original stream';
        this._log.info(successLog);
        // If the audio was paused, resume playback
        if (audio.paused) {
            this._log.info('Resuming audio playback');
            audio.play();
        }
    }).catch(()=>{
        const errorLog = isAddProcessor ? 'Failed to update audio source' : 'Failed to revert audio source';
        this._log.error(errorLog);
    });
};
function $96a759d7ffb58b23$var$addStream(pc, stream) {
    if (typeof pc.addTrack === 'function') stream.getAudioTracks().forEach((track)=>{
        // The second parameters, stream, should not be necessary per the latest editor's
        //   draft, but FF requires it. https://bugzilla.mozilla.org/show_bug.cgi?id=1231414
        pc.addTrack(track, stream);
    });
    else pc.addStream(stream);
}
function $96a759d7ffb58b23$var$cloneStream(oldStream, _MediaStream) {
    let newStream;
    if (_MediaStream) newStream = new _MediaStream();
    else if (typeof MediaStream !== 'undefined') newStream = new MediaStream();
    else newStream = new webkitMediaStream();
    oldStream.getAudioTracks().forEach(newStream.addTrack, newStream);
    return newStream;
}
/**
 * Sets the source of an HTMLAudioElement to the specified MediaStream and
 * applies a remote audio processor if available
 * @param {HTMLAudioElement} audio
 * @param {MediaStream} stream
 * @returns {Promise} Fulfilled if the audio source was set successfully
 */ function $96a759d7ffb58b23$var$setAudioSource(audio, stream, audioHelper) {
    return audioHelper._maybeCreateRemoteProcessedStream(stream).then((maybeProcessedStream)=>{
        if (typeof audio.srcObject !== 'undefined') audio.srcObject = maybeProcessedStream;
        else if (typeof audio.mozSrcObject !== 'undefined') audio.mozSrcObject = maybeProcessedStream;
        else if (typeof audio.src !== 'undefined') {
            const _window = audio.options.window || window;
            audio.src = (_window.URL || _window.webkitURL).createObjectURL(maybeProcessedStream);
        } else return Promise.reject();
        return Promise.resolve();
    });
}
$96a759d7ffb58b23$export$2e2bcd8739ae039.enabled = (0, $b7ceaa3e24b7b198$export$2e2bcd8739ae039).test();



// @ts-nocheck
function $e0810e84d8a85661$export$25eaa035e2e3a214() {
    return (0, $b7ceaa3e24b7b198$export$2e2bcd8739ae039).test();
}
function $e0810e84d8a85661$export$14d4781f230e8254() {
    return typeof RTCIceGatherer !== 'undefined' ? 'ORTC' : 'WebRTC';
}




// @ts-nocheck
function $6ab936f6d5629f89$export$2e2bcd8739ae039(constraints, options) {
    options = options || {};
    options.util = options.util || $a96769417395afb9$exports;
    options.navigator = options.navigator || (typeof navigator !== 'undefined' ? navigator : null);
    return new Promise((resolve, reject)=>{
        if (!options.navigator) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('getUserMedia is not supported');
        switch('function'){
            case typeof (options.navigator.mediaDevices && options.navigator.mediaDevices.getUserMedia):
                return resolve(options.navigator.mediaDevices.getUserMedia(constraints));
            case typeof options.navigator.webkitGetUserMedia:
                return options.navigator.webkitGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.mozGetUserMedia:
                return options.navigator.mozGetUserMedia(constraints, resolve, reject);
            case typeof options.navigator.getUserMedia:
                return options.navigator.getUserMedia(constraints, resolve, reject);
            default:
                throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('getUserMedia is not supported');
        }
    }).catch((e)=>{
        throw options.util.isFirefox() && e.name === 'NotReadableError' ? new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)("Firefox does not currently support opening multiple audio input trackssimultaneously, even across different tabs.\nRelated Bugzilla thread: https://bugzilla.mozilla.org/show_bug.cgi?id=1299324") : e;
    });
}



/**
 * Generates a 128-bit long random string that is formatted as a 32 long string
 * of characters where each character is from the set:
 * [0,1,2,3,4,5,6,7,8,9,a,b,c,d,e,f].
 */ function $e37f0f8b9fdc4b95$var$generateRandomizedString() {
    if (typeof window !== 'object') throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('This platform is not supported.');
    const { crypto: crypto } = window;
    if (typeof crypto !== 'object') throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('The `crypto` module is not available on this platform.');
    if (typeof crypto.getRandomValues !== 'function') throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)("The function `crypto.getRandomValues` is not available on this platform.");
    if (typeof window.Uint8Array !== 'function') throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)('The `Uint8Array` module is not available on this platform.');
    return crypto.getRandomValues(new window.Uint8Array(16)).reduce((r, n)=>`${r}${n.toString(16).padStart(2, '0')}`, '');
}
function $e37f0f8b9fdc4b95$export$230de48818ef3534() {
    return `KX${$e37f0f8b9fdc4b95$var$generateRandomizedString()}`;
}



/**
 * Deferred Promise
 */ class $48a05aad8c2e030c$export$2e2bcd8739ae039 {
    /**
     * @constructor
     */ constructor(){
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
    /**
     * @returns The {@link Deferred} Promise
     */ get promise() {
        return this._promise;
    }
    /**
     * Rejects this promise
     */ reject(reason) {
        this._reject(reason);
    }
    /**
     * Resolves this promise
     */ resolve(value) {
        this._resolve(value);
    }
}


/**
 * Queue async operations and executes them synchronously.
 */ class $0cc82cbf027894aa$export$c24e73273208a9bb {
    constructor(){
        /**
         * The list of async operations in this queue
         */ this._operations = [];
    }
    /**
     * Adds the async operation to the queue
     * @param callback An async callback that returns a promise
     * @returns A promise that will get resolved or rejected after executing the callback
     */ enqueue(callback) {
        const hasPending = !!this._operations.length;
        const deferred = new (0, $48a05aad8c2e030c$export$2e2bcd8739ae039)();
        this._operations.push({
            deferred: deferred,
            callback: callback
        });
        if (!hasPending) this._processQueue();
        return deferred.promise;
    }
    /**
     * Start processing the queue. This executes the first item and removes it after.
     * Then do the same for next items until the queue is emptied.
     */ _processQueue() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            while(this._operations.length){
                // Grab first item, don't remove from array yet until it's resolved/rejected
                const { deferred: deferred, callback: callback } = this._operations[0];
                // We want to capture the result/error first so we can remove the item from the queue later
                let result;
                let error;
                // Sometimes result and error are empty. So let's use a separate flag to determine if the promise has resolved
                let hasResolved;
                try {
                    result = yield callback();
                    hasResolved = true;
                } catch (e) {
                    error = e;
                }
                // Remove the item
                this._operations.shift();
                if (hasResolved) deferred.resolve(result);
                else deferred.reject(error);
            }
        });
    }
}



// @ts-nocheck
class $708482e2deaeb88f$export$2e2bcd8739ae039 {
    get reject() {
        return this._reject;
    }
    get resolve() {
        return this._resolve;
    }
    constructor(){
        this.promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
        });
    }
}



// @ts-nocheck
class $6d865d4b29653961$export$2e2bcd8739ae039 {
    constructor(){
        this._eventEmitter = new (0, $5440e9199a418654$exports.EventEmitter)();
    }
    addEventListener(name, handler) {
        return this._eventEmitter.addListener(name, handler);
    }
    dispatchEvent(name, ...args) {
        return this._eventEmitter.emit(name, ...args);
    }
    removeEventListener(name, handler) {
        return this._eventEmitter.removeListener(name, handler);
    }
}


/**
 * An {@link AudioPlayer} is an HTMLAudioElement-like object that uses AudioContext
 *   to circumvent browser limitations.
 * @private
 */ class $e84865ef015b2fc2$export$2e2bcd8739ae039 extends (0, $6d865d4b29653961$export$2e2bcd8739ae039) {
    get destination() {
        return this._destination;
    }
    get loop() {
        return this._loop;
    }
    set loop(shouldLoop) {
        const self = this;
        function pauseAfterPlaythrough() {
            self._audioNode.removeEventListener('ended', pauseAfterPlaythrough);
            self.pause();
        }
        // If a sound is already looping, it should continue playing
        //   the current playthrough and then stop.
        if (!shouldLoop && this.loop && !this.paused) this._audioNode.addEventListener('ended', pauseAfterPlaythrough);
        this._loop = shouldLoop;
    }
    /**
     * Whether the audio element is muted.
     */ get muted() {
        return this._gainNode.gain.value === 0;
    }
    set muted(shouldBeMuted) {
        this._gainNode.gain.value = shouldBeMuted ? 0 : 1;
    }
    /**
     * Whether the sound is paused. this._audioNode only exists when sound is playing;
     *   otherwise AudioPlayer is considered paused.
     */ get paused() {
        return this._audioNode === null;
    }
    get src() {
        return this._src;
    }
    set src(src) {
        this._load(src);
    }
    /**
     * The srcObject of the HTMLMediaElement
     */ get srcObject() {
        return this._audioElement.srcObject;
    }
    set srcObject(srcObject) {
        this._audioElement.srcObject = srcObject;
    }
    get sinkId() {
        return this._sinkId;
    }
    /**
     * @private
     */ constructor(audioContext, srcOrOptions = {}, options = {}){
        super();
        /**
         * The AudioBufferSourceNode of the actively loaded sound. Null if a sound
         *   has not been loaded yet. This is re-used for each time the sound is
         *   played.
         */ this._audioNode = null;
        /**
         * Whether or not the audio element should loop. If disabled during playback,
         *   playing continues until the sound ends and then stops looping.
         */ this._loop = false;
        /**
         * An Array of deferred-like objects for each pending `play` Promise. When
         *   .pause() is called or .src is set, all pending play Promises are
         *   immediately rejected.
         */ this._pendingPlayDeferreds = [];
        /**
         * The current sinkId of the device audio is being played through.
         */ this._sinkId = 'default';
        /**
         * The source URL of the sound to play. When set, the currently playing sound will stop.
         */ this._src = '';
        if (typeof srcOrOptions !== 'string') options = srcOrOptions;
        this._audioContext = audioContext;
        this._audioElement = new (options.AudioFactory || Audio)();
        this._bufferPromise = this._createPlayDeferred().promise;
        this._destination = this._audioContext.destination;
        this._gainNode = this._audioContext.createGain();
        this._gainNode.connect(this._destination);
        this._XMLHttpRequest = options.XMLHttpRequestFactory || XMLHttpRequest;
        this.addEventListener('canplaythrough', ()=>{
            this._resolvePlayDeferreds();
        });
        if (typeof srcOrOptions === 'string') this.src = srcOrOptions;
    }
    /**
     * Stop any ongoing playback and reload the source file.
     */ load() {
        this._load(this._src);
    }
    /**
     * Pause the audio coming from this AudioPlayer. This will reject any pending
     *   play Promises.
     */ pause() {
        if (this.paused) return;
        this._audioElement.pause();
        this._audioNode.stop();
        this._audioNode.disconnect(this._gainNode);
        this._audioNode = null;
        this._rejectPlayDeferreds(new Error('The play() request was interrupted by a call to pause().'));
    }
    /**
     * Play the sound. If the buffer hasn't loaded yet, wait for the buffer to load. If
     *   the source URL is not set yet, this Promise will remain pending until a source
     *   URL is set.
     */ play() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (!this.paused) {
                yield this._bufferPromise;
                if (!this.paused) return;
                throw new Error('The play() request was interrupted by a call to pause().');
            }
            this._audioNode = this._audioContext.createBufferSource();
            this._audioNode.loop = this.loop;
            this._audioNode.addEventListener('ended', ()=>{
                if (this._audioNode && this._audioNode.loop) return;
                this.dispatchEvent('ended');
            });
            const buffer = yield this._bufferPromise;
            if (this.paused) throw new Error('The play() request was interrupted by a call to pause().');
            this._audioNode.buffer = buffer;
            this._audioNode.connect(this._gainNode);
            this._audioNode.start();
            if (this._audioElement.srcObject) return this._audioElement.play();
        });
    }
    /**
     * Change which device the sound should play through.
     * @param sinkId - The sink of the device to play sound through.
     */ setSinkId(sinkId) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            if (typeof this._audioElement.setSinkId !== 'function') throw new Error('This browser does not support setSinkId.');
            if (sinkId === this.sinkId) return;
            if (sinkId === 'default') {
                if (!this.paused) this._gainNode.disconnect(this._destination);
                this._audioElement.srcObject = null;
                this._destination = this._audioContext.destination;
                this._gainNode.connect(this._destination);
                this._sinkId = sinkId;
                return;
            }
            yield this._audioElement.setSinkId(sinkId);
            if (this._audioElement.srcObject) return;
            this._gainNode.disconnect(this._audioContext.destination);
            this._destination = this._audioContext.createMediaStreamDestination();
            this._audioElement.srcObject = this._destination.stream;
            this._sinkId = sinkId;
            this._gainNode.connect(this._destination);
        });
    }
    /**
     * Create a Deferred for a Promise that will be resolved when .src is set or rejected
     *   when .pause is called.
     */ _createPlayDeferred() {
        const deferred = new (0, $708482e2deaeb88f$export$2e2bcd8739ae039)();
        this._pendingPlayDeferreds.push(deferred);
        return deferred;
    }
    /**
     * Stop current playback and load a sound file.
     * @param src - The source URL of the file to load
     */ _load(src) {
        if (this._src && this._src !== src) this.pause();
        this._src = src;
        this._bufferPromise = new Promise((resolve, reject)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                if (!src) return this._createPlayDeferred().promise;
                const buffer = yield $e84865ef015b2fc2$var$bufferSound(this._audioContext, this._XMLHttpRequest, src);
                this.dispatchEvent('canplaythrough');
                resolve(buffer);
            }));
    }
    /**
     * Reject all deferreds for the Play promise.
     * @param reason
     */ _rejectPlayDeferreds(reason) {
        const deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(({ reject: reject })=>reject(reason));
    }
    /**
     * Resolve all deferreds for the Play promise.
     * @param result
     */ _resolvePlayDeferreds(result) {
        const deferreds = this._pendingPlayDeferreds;
        deferreds.splice(0, deferreds.length).forEach(({ resolve: resolve })=>resolve(result));
    }
}
/**
 * Use XMLHttpRequest to load the AudioBuffer of a remote audio asset.
 * @private
 * @param context - The AudioContext to use to decode the audio data
 * @param RequestFactory - The XMLHttpRequest factory to build
 * @param src - The URL of the audio asset to load.
 * @returns A Promise containing the decoded AudioBuffer.
 */ // tslint:disable-next-line:variable-name
function $e84865ef015b2fc2$var$bufferSound(context, RequestFactory, src) {
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
        const request = new RequestFactory();
        request.open('GET', src, true);
        request.responseType = 'arraybuffer';
        const event = yield new Promise((resolve)=>{
            request.addEventListener('load', resolve);
            request.send();
        });
        // Safari uses a callback here instead of a Promise.
        try {
            return context.decodeAudioData(event.target.response);
        } catch (e) {
            return new Promise((resolve)=>{
                context.decodeAudioData(event.target.response, resolve);
            });
        }
    });
}



// @ts-nocheck
/**
 * @class
 * @param {string} name - Name of the sound
 * @param {string} url - URL of the sound
 * @param {Sound#ConstructorOptions} options
 * @property {boolean} isPlaying - Whether the Sound is currently playing audio.
 * @property {string} name - Name of the sound
 * @property {string} url - URL of the sound
 * @property {AudioContext} audioContext - The AudioContext to use if available for AudioPlayer.
 */ /**
 * @typedef {Object} Sound#ConstructorOptions
 * @property {number} [maxDuration=0] - The maximum length of time to play the sound
 *   before stopping it.
 * @property {Boolean} [shouldLoop=false] - Whether the sound should be looped.
 */ function $2b962bbbc417e15e$export$2e2bcd8739ae039(name, url, options) {
    if (!(this instanceof $2b962bbbc417e15e$export$2e2bcd8739ae039)) return new $2b962bbbc417e15e$export$2e2bcd8739ae039(name, url, options);
    if (!name || !url) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('name and url are required arguments');
    options = Object.assign({
        AudioFactory: typeof Audio !== 'undefined' ? Audio : null,
        maxDuration: 0,
        shouldLoop: false
    }, options);
    options.AudioPlayer = options.audioContext ? (0, $e84865ef015b2fc2$export$2e2bcd8739ae039).bind((0, $e84865ef015b2fc2$export$2e2bcd8739ae039), options.audioContext) : options.AudioFactory;
    Object.defineProperties(this, {
        _Audio: {
            value: options.AudioPlayer
        },
        _activeEls: {
            value: new Map()
        },
        _isSinkSupported: {
            value: options.AudioFactory !== null && typeof options.AudioFactory.prototype.setSinkId === 'function'
        },
        _maxDuration: {
            value: options.maxDuration
        },
        _maxDurationTimeout: {
            value: null,
            writable: true
        },
        _operations: {
            value: new (0, $0cc82cbf027894aa$export$c24e73273208a9bb)()
        },
        _playPromise: {
            value: null,
            writable: true
        },
        _shouldLoop: {
            value: options.shouldLoop
        },
        _sinkIds: {
            value: [
                'default'
            ]
        },
        isPlaying: {
            enumerable: true,
            get () {
                return !!this._playPromise;
            }
        },
        name: {
            enumerable: true,
            value: name
        },
        url: {
            enumerable: true,
            value: url
        }
    });
    if (this._Audio) // Play it (muted and should not loop) as soon as possible so that it does not get incorrectly caught by Chrome's
    // "gesture requirement for media playback" feature.
    // https://plus.google.com/+FrancoisBeaufort/posts/6PiJQqJzGqX
    this._play(true, false);
}
function $2b962bbbc417e15e$var$destroyAudioElement(audioElement) {
    if (audioElement) {
        audioElement.pause();
        audioElement.src = '';
        audioElement.srcObject = null;
        audioElement.load();
    }
}
/**
 * Plays the audio element that was initialized using the speficied sinkId
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype._playAudioElement = function _playAudioElement(sinkId, isMuted, shouldLoop) {
    const audioElement = this._activeEls.get(sinkId);
    if (!audioElement) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)(`sinkId: "${sinkId}" doesn't have an audio element`);
    audioElement.muted = !!isMuted;
    audioElement.loop = !!shouldLoop;
    return audioElement.play().then(()=>audioElement).catch((reason)=>{
        $2b962bbbc417e15e$var$destroyAudioElement(audioElement);
        this._activeEls.delete(sinkId);
        throw reason;
    });
};
/**
 * Start playing the sound. Will stop the currently playing sound first.
 * If it exists, the audio element that was initialized for the sinkId will be used
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype._play = function _play(forceIsMuted, forceShouldLoop) {
    if (this.isPlaying) this._stop();
    if (this._maxDuration > 0) this._maxDurationTimeout = setTimeout(this._stop.bind(this), this._maxDuration);
    forceShouldLoop = typeof forceShouldLoop === 'boolean' ? forceShouldLoop : this._shouldLoop;
    const self = this;
    const playPromise = this._playPromise = Promise.all(this._sinkIds.map(function createAudioElement(sinkId) {
        if (!self._Audio) return Promise.resolve();
        let audioElement = self._activeEls.get(sinkId);
        if (audioElement) return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
        audioElement = new self._Audio(self.url);
        // Make sure the browser always retrieves the resource using CORS.
        // By default when using media tags, origin header is not sent to server
        // which causes the server to not return CORS headers. When this caches
        // on the CDN or browser, it causes issues to future requests that needs CORS,
        // which is true when using AudioContext. Please note that we won't have to do this
        // once we migrate to CloudFront.
        if (typeof audioElement.setAttribute === 'function') audioElement.setAttribute('crossorigin', 'anonymous');
        /**
         * (rrowland) Bug in Chrome 53 & 54 prevents us from calling Audio.setSinkId without
         *   crashing the tab. https://bugs.chromium.org/p/chromium/issues/detail?id=655342
         */ return new Promise((resolve)=>{
            audioElement.addEventListener('canplaythrough', resolve);
        }).then(()=>{
            return (self._isSinkSupported ? audioElement.setSinkId(sinkId) : Promise.resolve()).then(function setSinkIdSuccess() {
                self._activeEls.set(sinkId, audioElement);
                // Stop has been called, bail out
                if (!self._playPromise) return Promise.resolve();
                return self._playAudioElement(sinkId, forceIsMuted, forceShouldLoop);
            });
        });
    }));
    return playPromise;
};
/**
 * Stop playing the sound.
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype._stop = function _stop() {
    this._activeEls.forEach((audioEl, sinkId)=>{
        if (this._sinkIds.includes(sinkId)) {
            audioEl.pause();
            audioEl.currentTime = 0;
        } else {
            // Destroy the ones that are not used anymore
            $2b962bbbc417e15e$var$destroyAudioElement(audioEl);
            this._activeEls.delete(sinkId);
        }
    });
    clearTimeout(this._maxDurationTimeout);
    this._playPromise = null;
    this._maxDurationTimeout = null;
};
/**
 * Update the sinkIds of the audio output devices this sound should play through.
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype.setSinkIds = function setSinkIds(ids) {
    if (!this._isSinkSupported) return;
    ids = ids.forEach ? ids : [
        ids
    ];
    [].splice.apply(this._sinkIds, [
        0,
        this._sinkIds.length
    ].concat(ids));
};
/**
 * Add a stop operation to the queue
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype.stop = function stop() {
    this._operations.enqueue(()=>{
        this._stop();
        return Promise.resolve();
    });
};
/**
 * Add a play operation to the queue
 */ $2b962bbbc417e15e$export$2e2bcd8739ae039.prototype.play = function play() {
    return this._operations.enqueue(()=>this._play());
};




const $2b01ca659bdc22ff$var$REGISTRATION_INTERVAL = 30000;
const $2b01ca659bdc22ff$var$RINGTONE_PLAY_TIMEOUT = 2000;
const $2b01ca659bdc22ff$var$PUBLISHER_PRODUCT_NAME = 'twilio-js-sdk';
const $2b01ca659bdc22ff$var$INVALID_TOKEN_MESSAGE = 'Parameter "token" must be of type "string".';
/**
 * Twilio Device. Allows registration for incoming calls, and placing outgoing calls.
 */ class $2b01ca659bdc22ff$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * The AudioContext to be used by {@link Device} instances.
     * @private
     */ static get audioContext() {
        return $2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext;
    }
    /**
     * Which sound file extension is supported.
     * @private
     */ static get extension() {
        // NOTE(mroberts): Node workaround.
        const a = typeof document !== 'undefined' ? document.createElement('audio') : {
            canPlayType: false
        };
        let canPlayMp3;
        try {
            canPlayMp3 = a.canPlayType && !!a.canPlayType('audio/mpeg').replace(/no/, '');
        } catch (e) {
            canPlayMp3 = false;
        }
        let canPlayVorbis;
        try {
            canPlayVorbis = a.canPlayType && !!a.canPlayType('audio/ogg;codecs=\'vorbis\'').replace(/no/, '');
        } catch (e) {
            canPlayVorbis = false;
        }
        return canPlayVorbis && !canPlayMp3 ? 'ogg' : 'mp3';
    }
    /**
     * Whether or not this SDK is supported by the current browser.
     */ static get isSupported() {
        return (0, $e0810e84d8a85661$export$25eaa035e2e3a214)();
    }
    /**
     * Package name of the SDK.
     */ static get packageName() {
        return 0, $1ec27394c1cce6bb$export$b8b9d90f9e5bd72b;
    }
    /**
     * Run some tests to identify issues, if any, prohibiting successful calling.
     * @param token - A Twilio JWT token string
     * @param options
     */ static runPreflight(token, options) {
        return new (0, $b34234dbca721431$export$b5100322533453bb)(token, Object.assign({
            audioContext: $2b01ca659bdc22ff$export$2e2bcd8739ae039._getOrCreateAudioContext()
        }, options));
    }
    /**
     * String representation of {@link Device} class.
     * @private
     */ static toString() {
        return '[Twilio.Device class]';
    }
    /**
     * Current SDK version.
     */ static get version() {
        return 0, $1ec27394c1cce6bb$export$f1af843f4d252578;
    }
    /**
     * Initializes the AudioContext instance shared across the Voice SDK,
     * or returns the existing instance if one has already been initialized.
     */ static _getOrCreateAudioContext() {
        if (!$2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext) {
            if (typeof AudioContext !== 'undefined') $2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext = new AudioContext();
            else if (typeof webkitAudioContext !== 'undefined') $2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext = new webkitAudioContext();
        }
        return $2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext;
    }
    /**
     * Construct a {@link Device} instance. The {@link Device} can be registered
     * to make and listen for calls using {@link Device.register}.
     * @param options
     */ constructor(token, options = {}){
        super();
        /**
         * The currently active {@link Call}, if there is one.
         */ this._activeCall = null;
        /**
         * The AudioHelper instance associated with this {@link Device}.
         */ this._audio = null;
        /**
         * The AudioProcessorEventObserver instance to use
         */ this._audioProcessorEventObserver = null;
        /**
         * An audio input MediaStream to pass to new {@link Call} instances.
         */ this._callInputStream = null;
        /**
         * An array of {@link Call}s. Though only one can be active, multiple may exist when there
         * are multiple incoming, unanswered {@link Call}s.
         */ this._calls = [];
        /**
         * An array of {@link Device} IDs to be used to play sounds through, to be passed to
         * new {@link Call} instances.
         */ this._callSinkIds = [
            'default'
        ];
        /**
         * The list of chunder URIs that will be passed to PStream
         */ this._chunderURIs = [];
        /**
         * Default options used by {@link Device}.
         */ this._defaultOptions = {
            allowIncomingWhileBusy: false,
            closeProtection: false,
            codecPreferences: [
                (0, $73a9091c20261962$export$2e2bcd8739ae039).Codec.PCMU,
                (0, $73a9091c20261962$export$2e2bcd8739ae039).Codec.Opus
            ],
            dscp: true,
            enableImprovedSignalingErrorPrecision: false,
            forceAggressiveIceNomination: false,
            logLevel: $fe91437b241bf996$exports.levels.ERROR,
            maxCallSignalingTimeoutMs: 0,
            preflight: false,
            sounds: {},
            tokenRefreshMs: 10000,
            voiceEventSidGenerator: (0, $e37f0f8b9fdc4b95$export$230de48818ef3534)
        };
        /**
         * The name of the edge the {@link Device} is connected to.
         */ this._edge = null;
        /**
         * The name of the home region the {@link Device} is connected to.
         */ this._home = null;
        /**
         * The identity associated with this Device.
         */ this._identity = null;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('Device');
        /**
         * The internal promise created when calling {@link Device.makeCall}.
         */ this._makeCallPromise = null;
        /**
         * The options passed to {@link Device} constructor or {@link Device.updateOptions}.
         */ this._options = {};
        /**
         * The preferred URI to (re)-connect signaling to.
         */ this._preferredURI = null;
        /**
         * An Insights Event Publisher.
         */ this._publisher = null;
        /**
         * The region the {@link Device} is connected to.
         */ this._region = null;
        /**
         * A timeout ID for a setTimeout schedule to re-register the {@link Device}.
         */ this._regTimer = null;
        /**
         * Boolean representing whether or not the {@link Device} was registered when
         * receiving a signaling `offline`. Determines if the {@link Device} attempts
         * a `re-register` once signaling is re-established when receiving a
         * `connected` event from the stream.
         */ this._shouldReRegister = false;
        /**
         * A Map of Sounds to play.
         */ this._soundcache = new Map();
        /**
         * The current status of the {@link Device}.
         */ this._state = $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered;
        /**
         * A map from {@link Device.State} to {@link Device.EventName}.
         */ this._stateEventMapping = {
            [$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed]: $2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Destroyed,
            [$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered]: $2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Unregistered,
            [$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registering]: $2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Registering,
            [$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registered]: $2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Registered
        };
        /**
         * The Signaling stream.
         */ this._stream = null;
        /**
         * A promise that will resolve when the Signaling stream is ready.
         */ this._streamConnectedPromise = null;
        /**
         * A timeout to track when the current AccessToken will expire.
         */ this._tokenWillExpireTimeout = null;
        /**
         * Create the default Insights payload
         * @param call
         */ this._createDefaultPayload = (call)=>{
            const payload = {
                aggressive_nomination: this._options.forceAggressiveIceNomination,
                browser_extension: this._isBrowserExtension,
                dscp: !!this._options.dscp,
                ice_restart_enabled: true,
                platform: (0, $e0810e84d8a85661$export$14d4781f230e8254)(),
                sdk_version: (0, $1ec27394c1cce6bb$export$f1af843f4d252578)
            };
            function setIfDefined(propertyName, value) {
                if (value) payload[propertyName] = value;
            }
            if (call) {
                const callSid = call.parameters.CallSid;
                setIfDefined('call_sid', /^TJ/.test(callSid) ? undefined : callSid);
                setIfDefined('temp_call_sid', call.outboundConnectionId);
                setIfDefined('audio_codec', call.codec);
                payload.direction = call.direction;
            }
            setIfDefined('gateway', this._stream && this._stream.gateway);
            setIfDefined('region', this._stream && this._stream.region);
            return payload;
        };
        /**
         * Called when a 'close' event is received from the signaling stream.
         */ this._onSignalingClose = ()=>{
            this._stream = null;
            this._streamConnectedPromise = null;
        };
        /**
         * Called when a 'connected' event is received from the signaling stream.
         */ this._onSignalingConnected = (payload)=>{
            var _a;
            const region = (0, $54f3bf0deee265ef$export$4fb94e0d09cbcb7e)(payload.region);
            this._edge = payload.edge || (0, $54f3bf0deee265ef$export$281ec2267fe88fc)[region] || payload.region;
            this._region = region || payload.region;
            this._home = payload.home;
            (_a = this._publisher) === null || _a === void 0 || _a.setHost((0, $54f3bf0deee265ef$export$abdefe87cb23127f)(payload.home));
            if (payload.token) {
                this._identity = payload.token.identity;
                if (typeof payload.token.ttl === 'number' && typeof this._options.tokenRefreshMs === 'number') {
                    const ttlMs = payload.token.ttl * 1000;
                    const timeoutMs = Math.max(0, ttlMs - this._options.tokenRefreshMs);
                    this._tokenWillExpireTimeout = setTimeout(()=>{
                        this._log.debug('#tokenWillExpire');
                        this.emit('tokenWillExpire', this);
                        if (this._tokenWillExpireTimeout) {
                            clearTimeout(this._tokenWillExpireTimeout);
                            this._tokenWillExpireTimeout = null;
                        }
                    }, timeoutMs);
                }
            }
            const preferredURIs = this._getChunderws() || (0, $54f3bf0deee265ef$export$fd9b936a752f2ba4)(this._edge);
            if (preferredURIs.length > 0) {
                const [preferredURI] = preferredURIs;
                this._preferredURI = (0, $54f3bf0deee265ef$export$754f7fe25ccfb57e)(preferredURI);
            } else this._log.warn('Could not parse a preferred URI from the stream#connected event.');
            // The signaling stream emits a `connected` event after reconnection, if the
            // device was registered before this, then register again.
            if (this._shouldReRegister) this.register().catch((error)=>{
                this._log.warn('Failed to re-register after signaling reconnect', error);
            });
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ this._onSignalingError = (payload)=>{
            if (typeof payload !== 'object') {
                this._log.warn('Invalid signaling error payload', payload);
                return;
            }
            const { error: originalError, callsid: callsid, voiceeventsid: voiceeventsid } = payload;
            // voiceeventsid is for call message events which are handled in the call object
            // missing originalError shouldn't be possible but check here to fail properly
            if (typeof originalError !== 'object' || !!voiceeventsid) {
                this._log.warn('Ignoring signaling error payload', {
                    originalError: originalError,
                    voiceeventsid: voiceeventsid
                });
                return;
            }
            const call = typeof callsid === 'string' && this._findCall(callsid) || undefined;
            const { code: code, message: customMessage } = originalError;
            let { twilioError: twilioError } = originalError;
            if (typeof code === 'number') {
                if (code === 31201) twilioError = new (0, $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7).AuthenticationFailed(originalError);
                else if (code === 31204) twilioError = new (0, $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7).AccessTokenInvalid(originalError);
                else if (code === 31205) {
                    // Stop trying to register presence after token expires
                    this._stopRegistrationTimer();
                    twilioError = new (0, $4bc3a86d2ffe35f2$export$f19d74ebe8df0ac7).AccessTokenExpired(originalError);
                } else {
                    const errorConstructor = (0, $d122425987f9ca02$export$5a8950f600406bb3)(!!this._options.enableImprovedSignalingErrorPrecision, code);
                    if (typeof errorConstructor !== 'undefined') twilioError = new errorConstructor(originalError);
                }
            }
            if (!twilioError) {
                this._log.error('Unknown signaling error: ', originalError);
                twilioError = new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).UnknownError(customMessage, originalError);
            }
            this._log.error('Received error: ', twilioError);
            this._log.debug('#error', originalError);
            this.emit($2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Error, twilioError, call);
        };
        /**
         * Called when an 'invite' event is received from the signaling stream.
         */ this._onSignalingInvite = (payload)=>(0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
                var _a;
                const wasBusy = !!this._activeCall;
                if (wasBusy && !this._options.allowIncomingWhileBusy) {
                    this._log.info('Device busy; ignoring incoming invite');
                    return;
                }
                if (!payload.callsid || !payload.sdp) {
                    this._log.debug('#error', payload);
                    this.emit($2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Error, new (0, $4bc3a86d2ffe35f2$export$41fe58768873a487).BadRequest('Malformed invite from gateway'));
                    return;
                }
                const callParameters = payload.parameters || {};
                callParameters.CallSid = callParameters.CallSid || payload.callsid;
                const customParameters = Object.assign({}, (0, $a96769417395afb9$export$f974f2dd97548511)(callParameters.Params));
                this._makeCallPromise = this._makeCall(customParameters, {
                    callParameters: callParameters,
                    enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                    offerSdp: payload.sdp,
                    reconnectToken: payload.reconnect,
                    voiceEventSidGenerator: this._options.voiceEventSidGenerator
                });
                let call;
                try {
                    call = yield this._makeCallPromise;
                } finally{
                    this._makeCallPromise = null;
                }
                this._calls.push(call);
                call.once('accept', ()=>{
                    this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).stop();
                    this._publishNetworkChange();
                });
                const play = ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.incoming()) && !wasBusy ? ()=>this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).play() : ()=>Promise.resolve();
                this._showIncomingCall(call, play);
            });
        /**
         * Called when an 'offline' event is received from the signaling stream.
         */ this._onSignalingOffline = ()=>{
            this._log.info('Stream is offline');
            this._edge = null;
            this._region = null;
            // A tick landing before the server validates the token earns a 31204.
            this._stopRegistrationTimer();
            this._shouldReRegister = this.state !== $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered;
            this._setState($2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered);
        };
        /**
         * Called when a 'ready' event is received from the signaling stream.
         */ this._onSignalingReady = ()=>{
            this._log.info('Stream is ready');
            this._setState($2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registered);
        };
        /**
         * Publish a NetworkInformation#change event to Insights if there's an active {@link Call}.
         */ this._publishNetworkChange = ()=>{
            if (!this._activeCall) return;
            if (this._networkInformation) this._publisher.info('network-information', 'network-change', {
                connection_type: this._networkInformation.type,
                downlink: this._networkInformation.downlink,
                downlinkMax: this._networkInformation.downlinkMax,
                effective_type: this._networkInformation.effectiveType,
                rtt: this._networkInformation.rtt
            }, this._activeCall);
        };
        /**
         * Update the input stream being used for calls so that any current call and all future calls
         * will use the new input stream.
         * @param inputStream
         */ this._updateInputStream = (inputStream)=>{
            const call = this._activeCall;
            if (call && !inputStream) return Promise.reject(new (0, $d122425987f9ca02$export$b251fc1661a3152d)('Cannot unset input device while a call is in progress.'));
            this._callInputStream = inputStream;
            return call ? call._setInputTracksFromStream(inputStream) : Promise.resolve();
        };
        /**
         * Update the device IDs of output devices being used to play sounds through.
         * @param type - Whether to update ringtone or speaker sounds
         * @param sinkIds - An array of device IDs
         */ this._updateSinkIds = (type, sinkIds)=>{
            const promise = type === 'ringtone' ? this._updateRingtoneSinkIds(sinkIds) : this._updateSpeakerSinkIds(sinkIds);
            return promise.then(()=>{
                this._publisher.info('audio', `${type}-devices-set`, {
                    audio_device_ids: sinkIds
                }, this._activeCall);
            }, (error)=>{
                this._publisher.error('audio', `${type}-devices-set-failed`, {
                    audio_device_ids: sinkIds,
                    message: error.message
                }, this._activeCall);
                throw error;
            });
        };
        // Setup loglevel asap to avoid missed logs
        this._setupLoglevel(options.logLevel);
        this._logOptions('constructor', options);
        this.updateToken(token);
        if ((0, $a96769417395afb9$export$e1183ffde9eeca17)()) throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)("Microsoft Edge Legacy (https://support.microsoft.com/en-us/help/4533505/what-is-microsoft-edge-legacy) is deprecated and will not be able to connect to Twilio to make or receive calls after September 1st, 2020. Please see this documentation for a list of supported browsers https://www.twilio.com/docs/voice/client/javascript#supported-browsers");
        if (!$2b01ca659bdc22ff$export$2e2bcd8739ae039.isSupported && options.ignoreBrowserSupport) {
            if (window && window.location && window.location.protocol === 'http:') throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)(`twilio.js wasn't able to find WebRTC browser support. \
          This is most likely because this page is served over http rather than https, \
          which does not support WebRTC in many browsers. Please load this page over https and \
          try again.`);
            throw new (0, $d122425987f9ca02$export$8aaa78fc27e196e7)(`twilio.js 1.3+ SDKs require WebRTC browser support. \
        For more information, see <https://www.twilio.com/docs/api/client/twilio-js>. \
        If you have any questions about this announcement, please contact \
        Twilio Support at <help@twilio.com>.`);
        }
        const root = globalThis;
        const browser = root.msBrowser || root.browser || root.chrome;
        this._isBrowserExtension = !!browser && !!browser.runtime && !!browser.runtime.id || !!root.safari && !!root.safari.extension;
        if (this._isBrowserExtension) this._log.info('Running as browser extension.');
        if (navigator) {
            const n = navigator;
            this._networkInformation = n.connection || n.mozConnection || n.webkitConnection;
        }
        if (this._networkInformation && typeof this._networkInformation.addEventListener === 'function') this._networkInformation.addEventListener('change', this._publishNetworkChange);
        $2b01ca659bdc22ff$export$2e2bcd8739ae039._getOrCreateAudioContext();
        if ($2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext) {
            if (!$2b01ca659bdc22ff$export$2e2bcd8739ae039._dialtonePlayer) $2b01ca659bdc22ff$export$2e2bcd8739ae039._dialtonePlayer = new (0, $94bc609c95f1b695$export$2e2bcd8739ae039)($2b01ca659bdc22ff$export$2e2bcd8739ae039._audioContext);
        }
        this._boundConfirmClose = this._confirmClose.bind(this);
        this._boundOnPageHide = this._onPageHide.bind(this);
        this._boundOnPageShow = this._onPageShow.bind(this);
        if (typeof window !== 'undefined' && window.addEventListener) {
            window.addEventListener('pagehide', this._boundOnPageHide);
            window.addEventListener('pageshow', this._boundOnPageShow);
        }
        this.updateOptions(options);
    }
    /**
     * Return the {@link AudioHelper} used by this {@link Device}.
     */ get audio() {
        return this._audio;
    }
    /**
     * Make an outgoing Call.
     * @param options
     */ connect() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(options = {}) {
            this._log.debug('.connect', JSON.stringify(options));
            this._throwIfDestroyed();
            if (this._activeCall || this._makeCallPromise) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)('A Call is already active');
            let customParameters;
            let parameters;
            let signalingReconnectToken;
            if (options.connectToken) {
                try {
                    const connectTokenParts = JSON.parse(decodeURIComponent(atob(options.connectToken)));
                    customParameters = connectTokenParts.customParameters;
                    parameters = connectTokenParts.parameters;
                    signalingReconnectToken = connectTokenParts.signalingReconnectToken;
                } catch (_a) {
                    throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Cannot parse connectToken');
                }
                if (!parameters || !parameters.CallSid || !signalingReconnectToken) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Invalid connectToken');
            }
            let isReconnect = false;
            let twimlParams = {};
            const callOptions = {
                enableImprovedSignalingErrorPrecision: !!this._options.enableImprovedSignalingErrorPrecision,
                rtcConfiguration: options.rtcConfiguration,
                voiceEventSidGenerator: this._options.voiceEventSidGenerator
            };
            if (signalingReconnectToken && parameters) {
                isReconnect = true;
                callOptions.callParameters = parameters;
                callOptions.reconnectCallSid = parameters.CallSid;
                callOptions.reconnectToken = signalingReconnectToken;
                twimlParams = customParameters || twimlParams;
            } else twimlParams = options.params || twimlParams;
            let activeCall;
            this._makeCallPromise = this._makeCall(twimlParams, callOptions, isReconnect);
            try {
                activeCall = this._activeCall = yield this._makeCallPromise;
            } finally{
                this._makeCallPromise = null;
            }
            // Make sure any incoming calls are ignored
            this._calls.splice(0).forEach((call)=>call.ignore());
            // Stop the incoming sound if it's playing
            this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).stop();
            activeCall.accept({
                rtcConstraints: options.rtcConstraints
            });
            this._publishNetworkChange();
            return activeCall;
        });
    }
    /**
     * Return the calls that this {@link Device} is maintaining.
     */ get calls() {
        return this._calls;
    }
    /**
     * Destroy the {@link Device}, freeing references to be garbage collected.
     */ destroy() {
        var _a;
        this._log.debug('.destroy');
        this._log.debug('Rejecting any incoming calls');
        const calls = this._calls.slice(0);
        calls.forEach((call)=>call.reject());
        this.disconnectAll();
        this._stopRegistrationTimer();
        this._destroyStream();
        this._destroyAudioHelper();
        (_a = this._audioProcessorEventObserver) === null || _a === void 0 || _a.destroy();
        this._destroyPublisher();
        if (this._networkInformation && typeof this._networkInformation.removeEventListener === 'function') this._networkInformation.removeEventListener('change', this._publishNetworkChange);
        if (typeof window !== 'undefined' && window.removeEventListener) {
            window.removeEventListener('beforeunload', this._boundConfirmClose);
            window.removeEventListener('pagehide', this._boundOnPageHide);
            window.removeEventListener('pageshow', this._boundOnPageShow);
        }
        this._setState($2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed);
        (0, $5440e9199a418654$exports.EventEmitter).prototype.removeAllListeners.call(this);
    }
    /**
     * Disconnect all {@link Call}s.
     */ disconnectAll() {
        this._log.debug('.disconnectAll');
        const calls = this._calls.splice(0);
        calls.forEach((call)=>call.disconnect());
        if (this._activeCall) this._activeCall.disconnect();
    }
    /**
     * Returns the {@link Edge} value the {@link Device} is currently connected
     * to. The value will be `null` when the {@link Device} is offline.
     */ get edge() {
        return this._edge;
    }
    /**
     * Returns the home value the {@link Device} is currently connected
     * to. The value will be `null` when the {@link Device} is offline.
     */ get home() {
        return this._home;
    }
    /**
     * Returns the identity associated with the {@link Device} for incoming calls. Only
     * populated when registered.
     */ get identity() {
        return this._identity;
    }
    /**
     * Whether the Device is currently on an active Call.
     */ get isBusy() {
        return !!this._activeCall;
    }
    /**
     * Register the `Device` to the Twilio backend, allowing it to receive calls.
     */ register() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            this._log.debug('.register');
            if (this.state !== $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)(`Attempt to register when device is in state "${this.state}". ` + `Must be "${$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered}".`);
            this._shouldReRegister = false;
            this._setState($2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registering);
            yield this._streamConnectedPromise || this._setupStream();
            yield this._sendPresence(true);
            yield (0, $a96769417395afb9$export$ac8784c501f5df0a)(this, $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registered, $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered);
        });
    }
    /**
     * Get the state of this {@link Device} instance
     */ get state() {
        return this._state;
    }
    /**
     * Get the token used by this {@link Device}.
     */ get token() {
        return this._token;
    }
    /**
     * String representation of {@link Device} instance.
     * @private
     */ toString() {
        return '[Twilio.Device instance]';
    }
    /**
     * Unregister the `Device` to the Twilio backend, disallowing it to receive
     * calls.
     */ unregister() {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            this._log.debug('.unregister');
            if (this.state !== $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registered) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)(`Attempt to unregister when device is in state "${this.state}". ` + `Must be "${$2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Registered}".`);
            this._shouldReRegister = false;
            const stream = yield this._streamConnectedPromise;
            const streamOfflinePromise = new Promise((resolve)=>{
                stream.on('offline', resolve);
            });
            yield this._sendPresence(false);
            yield streamOfflinePromise;
        });
    }
    /**
     * Set the options used within the {@link Device}.
     * @param options
     */ updateOptions(options = {}) {
        this._logOptions('updateOptions', options);
        if (this.state === $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)(`Attempt to "updateOptions" when device is in state "${this.state}".`);
        this._options = Object.assign(Object.assign(Object.assign({}, this._defaultOptions), this._options), options);
        const originalChunderURIs = new Set(this._chunderURIs);
        const newChunderURIs = this._chunderURIs = (this._getChunderws() || (0, $54f3bf0deee265ef$export$fd9b936a752f2ba4)(this._options.edge)).map((0, $54f3bf0deee265ef$export$754f7fe25ccfb57e));
        let hasChunderURIsChanged = originalChunderURIs.size !== newChunderURIs.length;
        if (!hasChunderURIsChanged) {
            for (const uri of newChunderURIs)if (!originalChunderURIs.has(uri)) {
                hasChunderURIsChanged = true;
                break;
            }
        }
        if (this.isBusy && hasChunderURIsChanged) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)('Cannot change Edge while on an active Call');
        this._setupLoglevel(this._options.logLevel);
        for (const name of Object.keys($2b01ca659bdc22ff$export$2e2bcd8739ae039._defaultSounds)){
            const soundDef = $2b01ca659bdc22ff$export$2e2bcd8739ae039._defaultSounds[name];
            const defaultUrl = `${(0, $1ec27394c1cce6bb$export$d5db989063a1308b)}/${soundDef.filename}.${$2b01ca659bdc22ff$export$2e2bcd8739ae039.extension}` + `?cache=${0, $1ec27394c1cce6bb$export$f1af843f4d252578}`;
            const soundUrl = this._options.sounds && this._options.sounds[name] || defaultUrl;
            const sound = new (this._options.Sound || (0, $2b962bbbc417e15e$export$2e2bcd8739ae039))(name, soundUrl, {
                audioContext: this._options.disableAudioContextSounds ? null : $2b01ca659bdc22ff$export$2e2bcd8739ae039.audioContext,
                maxDuration: soundDef.maxDuration,
                shouldLoop: soundDef.shouldLoop
            });
            this._soundcache.set(name, sound);
        }
        this._setupAudioHelper();
        this._setupPublisher();
        if (hasChunderURIsChanged && this._streamConnectedPromise) this._setupStream();
        // Setup close protection and make sure we clean up ongoing calls on page close.
        if (typeof window !== 'undefined' && typeof window.addEventListener === 'function' && this._options.closeProtection) {
            window.removeEventListener('beforeunload', this._boundConfirmClose);
            window.addEventListener('beforeunload', this._boundConfirmClose);
        }
    }
    /**
     * Update the token used by this {@link Device} to connect to Twilio.
     * It is recommended to call this API after [[Device.tokenWillExpireEvent]] is emitted,
     * and before or after a call to prevent a potential ~1s audio loss during the update process.
     * @param token
     */ updateToken(token) {
        this._log.debug('.updateToken');
        if (this.state === $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)(`Attempt to "updateToken" when device is in state "${this.state}".`);
        if (typeof token !== 'string') throw new (0, $d122425987f9ca02$export$9c711d4a95378233)($2b01ca659bdc22ff$var$INVALID_TOKEN_MESSAGE);
        this._token = token;
        if (this._stream) this._stream.setToken(this._token);
        if (this._publisher) this._publisher.setToken(this._token);
    }
    /**
     * Called on window's beforeunload event if closeProtection is enabled,
     * preventing users from accidentally navigating away from an active call.
     * @param event
     */ _confirmClose(event) {
        if (!this._activeCall) return '';
        const closeProtection = this._options.closeProtection || false;
        const confirmationMsg = typeof closeProtection !== 'string' ? 'A call is currently in-progress. Leaving or reloading this page will end the call.' : closeProtection;
        (event || window.event).returnValue = confirmationMsg;
        return confirmationMsg;
    }
    /**
     * Destroy the AudioHelper.
     */ _destroyAudioHelper() {
        if (!this._audio) return;
        this._audio._destroy();
        this._audio = null;
    }
    /**
     * Destroy the publisher.
     */ _destroyPublisher() {
        // Attempt to destroy non-existent publisher.
        if (!this._publisher) return;
        this._publisher = null;
    }
    /**
     * Destroy the connection to the signaling server.
     */ _destroyStream() {
        if (this._stream) {
            this._stream.removeListener('close', this._onSignalingClose);
            this._stream.removeListener('connected', this._onSignalingConnected);
            this._stream.removeListener('error', this._onSignalingError);
            this._stream.removeListener('invite', this._onSignalingInvite);
            this._stream.removeListener('offline', this._onSignalingOffline);
            this._stream.removeListener('ready', this._onSignalingReady);
            this._stream.destroy();
            this._stream = null;
        }
        this._onSignalingOffline();
        this._streamConnectedPromise = null;
    }
    /**
     * Find a {@link Call} by its CallSid.
     * @param callSid
     */ _findCall(callSid) {
        return this._calls.find((call)=>call.parameters.CallSid === callSid || call.outboundConnectionId === callSid) || null;
    }
    /**
     * Get chunderws array from the chunderw param
     */ _getChunderws() {
        return typeof this._options.chunderw === 'string' ? [
            this._options.chunderw
        ] : Array.isArray(this._options.chunderw) ? this._options.chunderw : null;
    }
    /**
     * Utility function to log device options
     */ _logOptions(caller, options = {}) {
        // Selectively log options that users can modify.
        // Also, convert user overrides.
        // This prevents potential app crash when calling JSON.stringify
        // and when sending log strings remotely
        const userOptions = [
            'allowIncomingWhileBusy',
            'appName',
            'appVersion',
            'closeProtection',
            'codecPreferences',
            'disableAudioContextSounds',
            'dscp',
            'edge',
            'enableImprovedSignalingErrorPrecision',
            'forceAggressiveIceNomination',
            'logLevel',
            'maxAverageBitrate',
            'maxCallSignalingTimeoutMs',
            'sounds',
            'tokenRefreshMs'
        ];
        const userOptionOverrides = [
            'RTCPeerConnection',
            'enumerateDevices',
            'getUserMedia',
            'MediaStream'
        ];
        if (typeof options === 'object') {
            const toLog = Object.assign({}, options);
            Object.keys(toLog).forEach((key)=>{
                if (!userOptions.includes(key) && !userOptionOverrides.includes(key)) delete toLog[key];
                if (userOptionOverrides.includes(key)) toLog[key] = true;
            });
            this._log.debug(`.${caller}`, JSON.stringify(toLog));
        }
    }
    /**
     * Create a new {@link Call}.
     * @param twimlParams - A flat object containing key:value pairs to be sent to the TwiML app.
     * @param options - Options to be used to instantiate the {@link Call}.
     */ _makeCall(twimlParams_1, options_1) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, arguments, void 0, function*(twimlParams, options, isReconnect = false) {
            var _a;
            // Wait for the input device if it's set by the user
            const inputDevicePromise = (_a = this._audio) === null || _a === void 0 ? void 0 : _a._getInputDevicePromise();
            if (inputDevicePromise) {
                this._log.debug('inputDevicePromise detected, waiting...');
                yield inputDevicePromise;
                this._log.debug('inputDevicePromise resolved');
            }
            const config = {
                audioHelper: this._audio,
                onIgnore: ()=>{
                    this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).stop();
                },
                pstream: yield this._streamConnectedPromise || this._setupStream(),
                publisher: this._publisher,
                soundcache: this._soundcache
            };
            options = Object.assign({
                MediaStream: this._options.MediaStream,
                RTCPeerConnection: this._options.RTCPeerConnection,
                beforeAccept: (currentCall)=>{
                    if (!this._activeCall || this._activeCall === currentCall) return;
                    this._activeCall.disconnect();
                    this._removeCall(this._activeCall);
                },
                codecPreferences: this._options.codecPreferences,
                customSounds: this._options.sounds,
                dialtonePlayer: $2b01ca659bdc22ff$export$2e2bcd8739ae039._dialtonePlayer,
                dscp: this._options.dscp,
                // TODO(csantos): Remove forceAggressiveIceNomination option in 3.x
                forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
                getInputStream: ()=>this._options.fileInputStream || this._callInputStream,
                getSinkIds: ()=>this._callSinkIds,
                maxAverageBitrate: this._options.maxAverageBitrate,
                preflight: this._options.preflight,
                rtcConstraints: this._options.rtcConstraints,
                shouldPlayDisconnect: ()=>{
                    var _a;
                    return (_a = this._audio) === null || _a === void 0 ? void 0 : _a.disconnect();
                },
                twimlParams: twimlParams,
                voiceEventSidGenerator: this._options.voiceEventSidGenerator
            }, options);
            const maybeUnsetPreferredUri = ()=>{
                if (!this._stream) {
                    this._log.warn('UnsetPreferredUri called without a stream');
                    return;
                }
                if (this._activeCall === null && this._calls.length === 0) this._stream.updatePreferredURI(null);
            };
            const call = new (this._options.Call || (0, $73a9091c20261962$export$2e2bcd8739ae039))(config, options);
            this._publisher.info('settings', 'init', {
                MediaStream: !!this._options.MediaStream,
                RTCPeerConnection: !!this._options.RTCPeerConnection,
                enumerateDevices: !!this._options.enumerateDevices,
                getUserMedia: !!this._options.getUserMedia
            }, call);
            call.once('accept', ()=>{
                var _a, _b, _c, _d, _e;
                this._stream.updatePreferredURI(this._preferredURI);
                this._removeCall(call);
                this._activeCall = call;
                if (this._audio) this._audio._maybeStartPollingVolume();
                if (call.direction === (0, $73a9091c20261962$export$2e2bcd8739ae039).CallDirection.Outgoing && ((_a = this._audio) === null || _a === void 0 ? void 0 : _a.outgoing()) && !isReconnect) this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Outgoing).play();
                const data = {
                    edge: this._edge || this._region
                };
                if (this._options.edge) data['selected_edge'] = Array.isArray(this._options.edge) ? this._options.edge : [
                    this._options.edge
                ];
                this._publisher.info('settings', 'edge', data, call);
                if ((_b = this._audio) === null || _b === void 0 ? void 0 : _b.localProcessedStream) (_c = this._audioProcessorEventObserver) === null || _c === void 0 || _c.emit('enabled', false);
                if ((_d = this._audio) === null || _d === void 0 ? void 0 : _d.remoteProcessedStream) (_e = this._audioProcessorEventObserver) === null || _e === void 0 || _e.emit('enabled', true);
            });
            call.addListener('error', (error)=>{
                if (call.status() === 'closed') {
                    this._removeCall(call);
                    maybeUnsetPreferredUri();
                }
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._maybeStopIncomingSound();
            });
            call.once('cancel', ()=>{
                this._log.info(`Canceled: ${call.parameters.CallSid}`);
                this._removeCall(call);
                maybeUnsetPreferredUri();
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._maybeStopIncomingSound();
            });
            call.once('disconnect', ()=>{
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                maybeUnsetPreferredUri();
                /**
                 * NOTE(kamalbennani): We need to stop the incoming sound when the call is
                 * disconnected right after the user has accepted the call (activeCall.accept()), and before
                 * the call has been fully connected (i.e. before the `pstream.answer` event)
                 */ this._maybeStopIncomingSound();
            });
            call.once('reject', ()=>{
                this._log.info(`Rejected: ${call.parameters.CallSid}`);
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                maybeUnsetPreferredUri();
                this._maybeStopIncomingSound();
            });
            call.on('transportClose', ()=>{
                if (call.status() !== (0, $73a9091c20261962$export$2e2bcd8739ae039).State.Pending) return;
                if (this._audio) this._audio._maybeStopPollingVolume();
                this._removeCall(call);
                /**
                 * NOTE(mhuynh): We don't want to call `maybeUnsetPreferredUri` because
                 * a `transportClose` will happen during signaling reconnection.
                 */ this._maybeStopIncomingSound();
            });
            return call;
        });
    }
    /**
     * Stop the incoming sound if no {@link Call}s remain.
     */ _maybeStopIncomingSound() {
        if (!this._calls.length) this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).stop();
    }
    /**
     * Called on the window's `pagehide` event. When the page is entering the
     * back/forward cache (`event.persisted === true`) and there are no active
     * calls, the signaling connection is quiesced without permanently destroying
     * the {@link Device}, so it can be restored on `pageshow`. Otherwise the
     * {@link Device} is destroyed, preserving the historical behavior (a normal
     * page unload, or a persisted transition while media is active and cannot
     * survive the cache).
     */ _onPageHide(event) {
        if (event && event.persisted && this._calls.length === 0 && !this._activeCall && !this._makeCallPromise) {
            this._log.debug('Page entering BFCache; quiescing signaling');
            this._stopRegistrationTimer();
            this._destroyStream();
        } else this.destroy();
    }
    /**
     * Called on the window's `pageshow` event. When the page is restored from the
     * back/forward cache (`event.persisted === true`), re-register if the
     * {@link Device} was registered before entering the cache. A previously
     * destroyed or unregistered {@link Device} is left untouched.
     */ _onPageShow(event) {
        if (!event || !event.persisted) return;
        if (this.state === $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed) return;
        if (this._shouldReRegister && this.state === $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Unregistered) {
            this._log.debug('Page restored from BFCache; re-registering');
            this.register().catch((error)=>{
                this._log.warn('Failed to re-register after BFCache restore', error);
            });
        }
    }
    /**
     * Remove a {@link Call} from device.calls by reference
     * @param call
     */ _removeCall(call) {
        if (this._activeCall === call) {
            this._activeCall = null;
            this._makeCallPromise = null;
        }
        for(let i = this._calls.length - 1; i >= 0; i--)if (call === this._calls[i]) this._calls.splice(i, 1);
    }
    /**
     * Register with the signaling server.
     */ _sendPresence(presence) {
        return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function*() {
            const stream = yield this._streamConnectedPromise;
            if (!stream) return;
            stream.register({
                audio: presence
            });
            if (presence) this._startRegistrationTimer();
            else this._stopRegistrationTimer();
        });
    }
    /**
     * Helper function that sets and emits the state of the device.
     * @param state The new state of the device.
     */ _setState(state) {
        if (state === this.state) return;
        this._state = state;
        const name = this._stateEventMapping[state];
        this._log.debug(`#${name}`);
        this.emit(name);
    }
    /**
     * Set up an audio helper for usage by this {@link Device}.
     */ _setupAudioHelper() {
        if (!this._audioProcessorEventObserver) {
            this._audioProcessorEventObserver = new (0, $67b4c632a6f4c3e5$export$a191d984ff946270)();
            this._audioProcessorEventObserver.on('event', ({ name: name, group: group, isRemote: isRemote })=>{
                this._publisher.info(group, name, {
                    is_remote: isRemote
                }, this._activeCall);
            });
        }
        const audioOptions = {
            audioContext: $2b01ca659bdc22ff$export$2e2bcd8739ae039.audioContext,
            audioProcessorEventObserver: this._audioProcessorEventObserver,
            beforeSetInputDevice: ()=>{
                if (this._makeCallPromise) {
                    this._log.debug('beforeSetInputDevice pause detected');
                    return this._makeCallPromise;
                } else {
                    this._log.debug('beforeSetInputDevice pause not detected, setting default');
                    return Promise.resolve();
                }
            },
            enumerateDevices: this._options.enumerateDevices,
            getUserMedia: this._options.getUserMedia || (0, $6ab936f6d5629f89$export$2e2bcd8739ae039)
        };
        if (this._audio) {
            this._log.info('Found existing audio helper; updating options...');
            this._audio._updateUserOptions(audioOptions);
            return;
        }
        this._audio = new (this._options.AudioHelper || (0, $0188738af1717958$export$2e2bcd8739ae039))(this._updateSinkIds, this._updateInputStream, audioOptions);
        this._audio.on('deviceChange', (lostActiveDevices)=>{
            const activeCall = this._activeCall;
            const deviceIds = lostActiveDevices.map((device)=>device.deviceId);
            this._publisher.info('audio', 'device-change', {
                lost_active_device_ids: deviceIds
            }, activeCall);
            if (activeCall) activeCall['_mediaHandler']._onInputDevicesChanged();
        });
    }
    /**
     * Setup logger's loglevel
     */ _setupLoglevel(logLevel) {
        const level = typeof logLevel === 'number' || typeof logLevel === 'string' ? logLevel : $fe91437b241bf996$exports.levels.ERROR;
        this._log.setDefaultLevel(level);
        this._log.info('Set logger default level to', level);
    }
    /**
     * Create and set a publisher for the {@link Device} to use.
     */ _setupPublisher() {
        if (this._publisher) {
            this._log.info('Found existing publisher; destroying...');
            this._destroyPublisher();
        }
        const publisherOptions = {
            defaultPayload: this._createDefaultPayload,
            metadata: {
                app_name: this._options.appName,
                app_version: this._options.appVersion
            }
        };
        if (this._options.eventgw) publisherOptions.host = this._options.eventgw;
        if (this._home) publisherOptions.host = (0, $54f3bf0deee265ef$export$abdefe87cb23127f)(this._home);
        this._publisher = new (this._options.Publisher || (0, $147f3090e577bd9e$export$2e2bcd8739ae039))($2b01ca659bdc22ff$var$PUBLISHER_PRODUCT_NAME, this.token, publisherOptions);
        if (this._options.publishEvents === false) this._publisher.disable();
        else this._publisher.on('error', (error)=>{
            this._log.warn('Cannot connect to insights.', error);
        });
        return this._publisher;
    }
    /**
     * Set up the connection to the signaling server. Tears down an existing
     * stream if called while a stream exists.
     */ _setupStream() {
        if (this._stream) {
            this._log.info('Found existing stream; destroying...');
            this._destroyStream();
        }
        this._log.info('Setting up VSP');
        this._stream = new (this._options.PStream || (0, $82ba186413fb5a4d$export$2e2bcd8739ae039))(this.token, this._chunderURIs, {
            backoffMaxMs: this._options.backoffMaxMs,
            maxPreferredDurationMs: this._options.maxCallSignalingTimeoutMs
        });
        this._stream.addListener('close', this._onSignalingClose);
        this._stream.addListener('connected', this._onSignalingConnected);
        this._stream.addListener('error', this._onSignalingError);
        this._stream.addListener('invite', this._onSignalingInvite);
        this._stream.addListener('offline', this._onSignalingOffline);
        this._stream.addListener('ready', this._onSignalingReady);
        return this._streamConnectedPromise = (0, $a96769417395afb9$export$ac8784c501f5df0a)(this._stream, 'connected', 'close').then(()=>this._stream);
    }
    /**
     * Start playing the incoming ringtone, and subsequently emit the incoming event.
     * @param call
     * @param play - The function to be used to play the sound. Must return a Promise.
     */ _showIncomingCall(call, play) {
        let timeout;
        return Promise.race([
            play(),
            new Promise((resolve, reject)=>{
                timeout = setTimeout(()=>{
                    const msg = 'Playing incoming ringtone took too long; it might not play. Continuing execution...';
                    reject(new Error(msg));
                }, $2b01ca659bdc22ff$var$RINGTONE_PLAY_TIMEOUT);
            })
        ]).catch((reason)=>{
            this._log.warn(reason.message);
        }).then(()=>{
            clearTimeout(timeout);
            this._log.debug('#incoming', JSON.stringify({
                customParameters: call.customParameters,
                parameters: call.parameters
            }));
            this.emit($2b01ca659bdc22ff$export$2e2bcd8739ae039.EventName.Incoming, call);
        });
    }
    /**
     * Set a timeout to send another register message to the signaling server.
     */ _startRegistrationTimer() {
        this._stopRegistrationTimer();
        this._regTimer = setTimeout(()=>{
            this._sendPresence(true);
        }, $2b01ca659bdc22ff$var$REGISTRATION_INTERVAL);
    }
    /**
     * Stop sending registration messages to the signaling server.
     */ _stopRegistrationTimer() {
        if (this._regTimer) clearTimeout(this._regTimer);
    }
    /**
     * Throw an error if the {@link Device} is destroyed.
     */ _throwIfDestroyed() {
        if (this.state === $2b01ca659bdc22ff$export$2e2bcd8739ae039.State.Destroyed) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)('Device has been destroyed.');
    }
    /**
     * Update the device IDs of output devices being used to play the incoming ringtone through.
     * @param sinkIds - An array of device IDs
     */ _updateRingtoneSinkIds(sinkIds) {
        return Promise.resolve(this._soundcache.get($2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).setSinkIds(sinkIds));
    }
    /**
     * Update the device IDs of output devices being used to play the non-ringtone sounds
     * and Call audio through.
     * @param sinkIds - An array of device IDs
     */ _updateSpeakerSinkIds(sinkIds) {
        Array.from(this._soundcache.entries()).filter((entry)=>entry[0] !== $2b01ca659bdc22ff$export$2e2bcd8739ae039.SoundName.Incoming).forEach((entry)=>entry[1].setSinkIds(sinkIds));
        this._callSinkIds = sinkIds;
        const call = this._activeCall;
        return call ? call._setSinkIds(sinkIds) : Promise.resolve();
    }
}
$2b01ca659bdc22ff$export$2e2bcd8739ae039._defaultSounds = {
    disconnect: {
        filename: 'disconnect',
        maxDuration: 3000
    },
    dtmf0: {
        filename: 'dtmf-0',
        maxDuration: 1000
    },
    dtmf1: {
        filename: 'dtmf-1',
        maxDuration: 1000
    },
    dtmf2: {
        filename: 'dtmf-2',
        maxDuration: 1000
    },
    dtmf3: {
        filename: 'dtmf-3',
        maxDuration: 1000
    },
    dtmf4: {
        filename: 'dtmf-4',
        maxDuration: 1000
    },
    dtmf5: {
        filename: 'dtmf-5',
        maxDuration: 1000
    },
    dtmf6: {
        filename: 'dtmf-6',
        maxDuration: 1000
    },
    dtmf7: {
        filename: 'dtmf-7',
        maxDuration: 1000
    },
    dtmf8: {
        filename: 'dtmf-8',
        maxDuration: 1000
    },
    dtmf9: {
        filename: 'dtmf-9',
        maxDuration: 1000
    },
    dtmfh: {
        filename: 'dtmf-hash',
        maxDuration: 1000
    },
    dtmfs: {
        filename: 'dtmf-star',
        maxDuration: 1000
    },
    incoming: {
        filename: 'incoming',
        shouldLoop: true
    },
    outgoing: {
        filename: 'outgoing',
        maxDuration: 3000
    }
};
/**
 * @mergeModuleWith Device
 */ (function(Device) {
    (function(EventName) {
        EventName["Error"] = "error";
        EventName["Incoming"] = "incoming";
        EventName["Destroyed"] = "destroyed";
        EventName["Unregistered"] = "unregistered";
        EventName["Registering"] = "registering";
        EventName["Registered"] = "registered";
        EventName["TokenWillExpire"] = "tokenWillExpire";
    })(Device.EventName || (Device.EventName = {}));
    (function(State) {
        State["Destroyed"] = "destroyed";
        State["Unregistered"] = "unregistered";
        State["Registering"] = "registering";
        State["Registered"] = "registered";
    })(Device.State || (Device.State = {}));
    (function(SoundName) {
        SoundName["Incoming"] = "incoming";
        SoundName["Outgoing"] = "outgoing";
        SoundName["Disconnect"] = "disconnect";
        SoundName["Dtmf0"] = "dtmf0";
        SoundName["Dtmf1"] = "dtmf1";
        SoundName["Dtmf2"] = "dtmf2";
        SoundName["Dtmf3"] = "dtmf3";
        SoundName["Dtmf4"] = "dtmf4";
        SoundName["Dtmf5"] = "dtmf5";
        SoundName["Dtmf6"] = "dtmf6";
        SoundName["Dtmf7"] = "dtmf7";
        SoundName["Dtmf8"] = "dtmf8";
        SoundName["Dtmf9"] = "dtmf9";
        SoundName["DtmfS"] = "dtmfs";
        SoundName["DtmfH"] = "dtmfh";
    })(Device.SoundName || (Device.SoundName = {}));
})($2b01ca659bdc22ff$export$2e2bcd8739ae039 || ($2b01ca659bdc22ff$export$2e2bcd8739ae039 = {}));






/**
 * {@link RTCIceCandidate} parses an ICE candidate gathered by the browser
 * and returns a IceCandidate object
 */ class $ca86b8c6f86d7448$export$1a8483fdfc1e9c99 {
    /**
     * @constructor
     * @param iceCandidate RTCIceCandidate coming from the browser
     */ constructor(iceCandidate, isRemote = false){
        /**
         * Whether this is deleted from the list of candidate gathered
         */ this.deleted = false;
        let cost;
        const parts = iceCandidate.candidate.split('network-cost ');
        if (parts[1]) cost = parseInt(parts[1], 10);
        this.candidateType = iceCandidate.type;
        this.ip = iceCandidate.ip || iceCandidate.address;
        this.isRemote = isRemote;
        this.networkCost = cost;
        this.port = iceCandidate.port;
        this.priority = iceCandidate.priority;
        this.protocol = iceCandidate.protocol;
        this.relatedAddress = iceCandidate.relatedAddress;
        this.relatedPort = iceCandidate.relatedPort;
        this.tcpType = iceCandidate.tcpType;
        this.transportId = iceCandidate.sdpMid;
    }
    /**
     * Get the payload object for insights
     */ toPayload() {
        return {
            'candidate_type': this.candidateType,
            'deleted': this.deleted,
            'ip': this.ip,
            'is_remote': this.isRemote,
            'network-cost': this.networkCost,
            'port': this.port,
            'priority': this.priority,
            'protocol': this.protocol,
            'related_address': this.relatedAddress,
            'related_port': this.relatedPort,
            'tcp_type': this.tcpType,
            'transport_id': this.transportId
        };
    }
}






const $4137b6b3debf77cf$var$r0 = 94.768; // Constant used in computing "rFactor".
/**
 * Calculate the mos score of a stats object
 * @param {number} rtt
 * @param {number} jitter
 * @param {number} fractionLost - The fraction of packets that have been lost.
 * Calculated by packetsLost / totalPackets
 * @return {number | null} mos - Calculated MOS, `1.0` through roughly `4.5`.
 * Returns `null` when any of the input parameters are not a `non-negative`
 * number.
 */ function $4137b6b3debf77cf$export$2409b27812872cc9(rtt, jitter, fractionLost) {
    if (typeof rtt !== 'number' || typeof jitter !== 'number' || typeof fractionLost !== 'number' || !$4137b6b3debf77cf$export$5776f4809341b9a6(rtt) || !$4137b6b3debf77cf$export$5776f4809341b9a6(jitter) || !$4137b6b3debf77cf$export$5776f4809341b9a6(fractionLost)) return null;
    // Compute the effective latency.
    const effectiveLatency = rtt + jitter * 2 + 10;
    // Compute the initial "rFactor" from effective latency.
    let rFactor = 0;
    switch(true){
        case effectiveLatency < 160:
            rFactor = $4137b6b3debf77cf$var$r0 - effectiveLatency / 40;
            break;
        case effectiveLatency < 1000:
            rFactor = $4137b6b3debf77cf$var$r0 - (effectiveLatency - 120) / 10;
            break;
    }
    // Adjust "rFactor" with the fraction of packets lost.
    switch(true){
        case fractionLost <= rFactor / 2.5:
            rFactor = Math.max(rFactor - fractionLost * 2.5, 6.52);
            break;
        default:
            rFactor = 0;
            break;
    }
    // Compute MOS from "rFactor".
    const mos = 1 + 0.035 * rFactor + 0.000007 * rFactor * (rFactor - 60) * (100 - rFactor);
    return mos;
}
/**
 * Returns true if and only if the parameter passed is a number, is not `NaN`,
 * is finite, and is greater than or equal to `0`.
 * @param n
 */ function $4137b6b3debf77cf$export$5776f4809341b9a6(n) {
    return typeof n === 'number' && !isNaN(n) && isFinite(n) && n >= 0;
}
var $4137b6b3debf77cf$export$2e2bcd8739ae039 = {
    calculate: $4137b6b3debf77cf$export$2409b27812872cc9,
    isNonNegativeNumber: $4137b6b3debf77cf$export$5776f4809341b9a6
};




// How many samples we use when testing metric thresholds
const $2031af13ca117135$var$SAMPLE_COUNT_METRICS = 5;
// How many samples that need to cross the threshold to
// raise or clear a warning.
const $2031af13ca117135$var$SAMPLE_COUNT_CLEAR = 0;
const $2031af13ca117135$var$SAMPLE_COUNT_RAISE = 3;
const $2031af13ca117135$var$SAMPLE_INTERVAL = 1000;
const $2031af13ca117135$var$WARNING_TIMEOUT = 5000;
const $2031af13ca117135$var$DEFAULT_THRESHOLDS = {
    audioInputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    audioOutputLevel: {
        minStandardDeviation: 327.67,
        sampleCount: 10
    },
    bytesReceived: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    bytesSent: {
        clearCount: 2,
        min: 1,
        raiseCount: 3,
        sampleCount: 3
    },
    jitter: {
        max: 30
    },
    mos: {
        min: 3
    },
    packetsLostFraction: [
        {
            max: 1
        },
        {
            clearValue: 1,
            maxAverage: 3,
            sampleCount: 7
        }
    ],
    rtt: {
        max: 400
    }
};
/**
 * Count the number of values that cross the max threshold.
 * @private
 * @param max - The max allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $2031af13ca117135$var$countHigh(max, values) {
    return values.reduce((highCount, value)=>highCount += value > max ? 1 : 0, 0);
}
/**
 * Count the number of values that cross the min threshold.
 * @private
 * @param min - The minimum allowable value.
 * @param values - The values to iterate over.
 * @returns The amount of values in which the stat crossed the threshold.
 */ function $2031af13ca117135$var$countLow(min, values) {
    return values.reduce((lowCount, value)=>lowCount += value < min ? 1 : 0, 0);
}
/**
 * Calculate the standard deviation from a list of numbers.
 * @private
 * @param values The list of numbers to calculate the standard deviation from.
 * @returns The standard deviation of a list of numbers.
 */ function $2031af13ca117135$var$calculateStandardDeviation(values) {
    if (values.length <= 0) return null;
    const valueAverage = values.reduce((partialSum, value)=>partialSum + value, 0) / values.length;
    const diffSquared = values.map((value)=>Math.pow(value - valueAverage, 2));
    const stdDev = Math.sqrt(diffSquared.reduce((partialSum, value)=>partialSum + value, 0) / diffSquared.length);
    return stdDev;
}
/**
 * Flatten a set of numerical sample sets into a single array of samples.
 * @param sampleSets
 */ function $2031af13ca117135$var$flattenSamples(sampleSets) {
    return sampleSets.reduce((flat, current)=>[
            ...flat,
            ...current
        ], []);
}
/**
 * {@link StatsMonitor} polls a peerConnection via PeerConnection.getStats
 * and emits warnings when stats cross the specified threshold values.
 */ class $2031af13ca117135$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * @constructor
     * @param [options] - Optional settings
     */ constructor(options){
        super();
        /**
         * A map of warnings with their raised time
         */ this._activeWarnings = new Map();
        /**
         * A map of stats with the number of exceeded thresholds
         */ this._currentStreaks = new Map();
        /**
         * Keeps track of input volumes in the last second
         */ this._inputVolumes = [];
        /**
         * Keeps track of output volumes in the last second
         */ this._outputVolumes = [];
        /**
         * Sample buffer. Saves most recent samples
         */ this._sampleBuffer = [];
        /**
         * Keeps track of supplemental sample values.
         *
         * Currently used for constant audio detection. Contains an array of volume
         * samples for each sample interval.
         */ this._supplementalSampleBuffers = {
            audioInputLevel: [],
            audioOutputLevel: []
        };
        /**
         * Whether warnings should be enabled
         */ this._warningsEnabled = true;
        options = options || {};
        this._getRTCStats = options.getRTCStats || (0, $31ba44ba404e502a$export$8f85ce3f3acd2643);
        this._mos = options.Mos || (0, $4137b6b3debf77cf$export$2e2bcd8739ae039);
        this._peerConnection = options.peerConnection;
        this._thresholds = Object.assign(Object.assign({}, $2031af13ca117135$var$DEFAULT_THRESHOLDS), options.thresholds);
        const thresholdSampleCounts = Object.values(this._thresholds).map((threshold)=>threshold.sampleCount).filter((sampleCount)=>!!sampleCount);
        this._maxSampleCount = Math.max($2031af13ca117135$var$SAMPLE_COUNT_METRICS, ...thresholdSampleCounts);
        if (this._peerConnection) this.enable(this._peerConnection);
    }
    /**
     * Called when a volume sample is available
     * @param inputVolume - Input volume level from 0 to 32767
     * @param outputVolume - Output volume level from 0 to 32767
     */ addVolumes(inputVolume, outputVolume) {
        this._inputVolumes.push(inputVolume);
        this._outputVolumes.push(outputVolume);
    }
    /**
     * Stop sampling RTC statistics for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ disable() {
        if (this._sampleInterval) {
            clearInterval(this._sampleInterval);
            delete this._sampleInterval;
        }
        return this;
    }
    /**
     * Disable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ disableWarnings() {
        if (this._warningsEnabled) this._activeWarnings.clear();
        this._warningsEnabled = false;
        return this;
    }
    /**
     * Start sampling RTC statistics for this {@link StatsMonitor}.
     * @param peerConnection - A PeerConnection to monitor.
     * @returns The current {@link StatsMonitor}.
     */ enable(peerConnection) {
        if (peerConnection) {
            if (this._peerConnection && peerConnection !== this._peerConnection) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Attempted to replace an existing PeerConnection in StatsMonitor.enable');
            this._peerConnection = peerConnection;
        }
        if (!this._peerConnection) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Can not enable StatsMonitor without a PeerConnection');
        this._sampleInterval = this._sampleInterval || setInterval(this._fetchSample.bind(this), $2031af13ca117135$var$SAMPLE_INTERVAL);
        return this;
    }
    /**
     * Enable warnings for this {@link StatsMonitor}.
     * @returns The current {@link StatsMonitor}.
     */ enableWarnings() {
        this._warningsEnabled = true;
        return this;
    }
    /**
     * Check if there is an active warning for a specific stat and threshold
     * @param statName - The name of the stat to check
     * @param thresholdName - The name of the threshold to check
     * @returns Whether there is an active warning for a specific stat and threshold
     */ hasActiveWarning(statName, thresholdName) {
        const warningId = `${statName}:${thresholdName}`;
        return !!this._activeWarnings.get(warningId);
    }
    /**
     * Add a sample to our sample buffer and remove the oldest if we are over the limit.
     * @param sample - Sample to add
     */ _addSample(sample) {
        const samples = this._sampleBuffer;
        samples.push(sample);
        // We store 1 extra sample so that we always have (current, previous)
        // available for all {sampleBufferSize} threshold validations.
        if (samples.length > this._maxSampleCount) samples.splice(0, samples.length - this._maxSampleCount);
    }
    /**
     * Clear an active warning.
     * @param statName - The name of the stat to clear.
     * @param thresholdName - The name of the threshold to clear
     * @param [data] - Any relevant sample data.
     */ _clearWarning(statName, thresholdName, data) {
        const warningId = `${statName}:${thresholdName}`;
        const activeWarning = this._activeWarnings.get(warningId);
        if (!activeWarning || Date.now() - activeWarning.timeRaised < $2031af13ca117135$var$WARNING_TIMEOUT) return;
        this._activeWarnings.delete(warningId);
        this.emit('warning-cleared', Object.assign(Object.assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: this._thresholds[statName][thresholdName]
            }
        }));
    }
    /**
     * Create a sample object from a stats object using the previous sample, if available.
     * @param stats - Stats retrieved from getStatistics
     * @param [previousSample=null] - The previous sample to use to calculate deltas.
     * @returns A universally-formatted version of RTC stats.
     */ _createSample(stats, previousSample) {
        const previousBytesSent = previousSample && previousSample.totals.bytesSent || 0;
        const previousBytesReceived = previousSample && previousSample.totals.bytesReceived || 0;
        const previousPacketsSent = previousSample && previousSample.totals.packetsSent || 0;
        const previousPacketsReceived = previousSample && previousSample.totals.packetsReceived || 0;
        const previousPacketsLost = previousSample && previousSample.totals.packetsLost || 0;
        const currentBytesSent = stats.bytesSent - previousBytesSent;
        const currentBytesReceived = stats.bytesReceived - previousBytesReceived;
        const currentPacketsSent = stats.packetsSent - previousPacketsSent;
        const currentPacketsReceived = stats.packetsReceived - previousPacketsReceived;
        const currentPacketsLost = stats.packetsLost - previousPacketsLost;
        const currentInboundPackets = currentPacketsReceived + currentPacketsLost;
        const currentPacketsLostFraction = currentInboundPackets > 0 ? currentPacketsLost / currentInboundPackets * 100 : 0;
        const totalInboundPackets = stats.packetsReceived + stats.packetsLost;
        const totalPacketsLostFraction = totalInboundPackets > 0 ? stats.packetsLost / totalInboundPackets * 100 : 100;
        const rttValue = typeof stats.rtt === 'number' || !previousSample ? stats.rtt : previousSample.rtt;
        const audioInputLevelValues = this._inputVolumes.splice(0);
        this._supplementalSampleBuffers.audioInputLevel.push(audioInputLevelValues);
        const audioOutputLevelValues = this._outputVolumes.splice(0);
        this._supplementalSampleBuffers.audioOutputLevel.push(audioOutputLevelValues);
        return {
            audioInputLevel: Math.round((0, $a96769417395afb9$export$cc6710ee5f037d57)(audioInputLevelValues)),
            audioOutputLevel: Math.round((0, $a96769417395afb9$export$cc6710ee5f037d57)(audioOutputLevelValues)),
            bytesReceived: currentBytesReceived,
            bytesSent: currentBytesSent,
            codecName: stats.codecName,
            jitter: stats.jitter,
            mos: this._mos.calculate(rttValue, stats.jitter, previousSample && currentPacketsLostFraction),
            packetsLost: currentPacketsLost,
            packetsLostFraction: currentPacketsLostFraction,
            packetsReceived: currentPacketsReceived,
            packetsSent: currentPacketsSent,
            rtt: rttValue,
            timestamp: stats.timestamp,
            totals: {
                bytesReceived: stats.bytesReceived,
                bytesSent: stats.bytesSent,
                packetsLost: stats.packetsLost,
                packetsLostFraction: totalPacketsLostFraction,
                packetsReceived: stats.packetsReceived,
                packetsSent: stats.packetsSent
            }
        };
    }
    /**
     * Get stats from the PeerConnection and add it to our list of samples.
     */ _fetchSample() {
        this._getSample().then((sample)=>{
            this._addSample(sample);
            this._raiseWarnings();
            this.emit('sample', sample);
        }).catch((error)=>{
            this.disable();
            // We only bubble up any errors coming from pc.getStats()
            // No need to attach a twilioError
            this.emit('error', error);
        });
    }
    /**
     * Get stats from the PeerConnection.
     * @returns A universally-formatted version of RTC stats.
     */ _getSample() {
        return this._getRTCStats(this._peerConnection).then((stats)=>{
            let previousSample = null;
            if (this._sampleBuffer.length) previousSample = this._sampleBuffer[this._sampleBuffer.length - 1];
            return this._createSample(stats, previousSample);
        });
    }
    /**
     * Raise a warning and log its raised time.
     * @param statName - The name of the stat to raise.
     * @param thresholdName - The name of the threshold to raise
     * @param [data] - Any relevant sample data.
     */ _raiseWarning(statName, thresholdName, data) {
        const warningId = `${statName}:${thresholdName}`;
        if (this._activeWarnings.has(warningId)) return;
        this._activeWarnings.set(warningId, {
            timeRaised: Date.now()
        });
        const thresholds = this._thresholds[statName];
        let thresholdValue;
        if (Array.isArray(thresholds)) {
            const foundThreshold = thresholds.find((threshold)=>thresholdName in threshold);
            if (foundThreshold) thresholdValue = foundThreshold[thresholdName];
        } else thresholdValue = this._thresholds[statName][thresholdName];
        this.emit('warning', Object.assign(Object.assign({}, data), {
            name: statName,
            threshold: {
                name: thresholdName,
                value: thresholdValue
            }
        }));
    }
    /**
     * Apply our thresholds to our array of RTCStat samples.
     */ _raiseWarnings() {
        if (!this._warningsEnabled) return;
        Object.keys(this._thresholds).forEach((name)=>this._raiseWarningsForStat(name));
    }
    /**
     * Apply thresholds for a given stat name to our array of
     * RTCStat samples and raise or clear any associated warnings.
     * @param statName - Name of the stat to compare.
     */ _raiseWarningsForStat(statName) {
        const limits = Array.isArray(this._thresholds[statName]) ? this._thresholds[statName] : [
            this._thresholds[statName]
        ];
        limits.forEach((limit)=>{
            const samples = this._sampleBuffer;
            const clearCount = limit.clearCount || $2031af13ca117135$var$SAMPLE_COUNT_CLEAR;
            const raiseCount = limit.raiseCount || $2031af13ca117135$var$SAMPLE_COUNT_RAISE;
            const sampleCount = limit.sampleCount || this._maxSampleCount;
            let relevantSamples = samples.slice(-sampleCount);
            const values = relevantSamples.map((sample)=>sample[statName]);
            // (rrowland) If we have a bad or missing value in the set, we don't
            // have enough information to throw or clear a warning. Bail out.
            const containsNull = values.some((value)=>typeof value === 'undefined' || value === null);
            if (containsNull) return;
            let count;
            if (typeof limit.max === 'number') {
                count = $2031af13ca117135$var$countHigh(limit.max, values);
                if (count >= raiseCount) this._raiseWarning(statName, 'max', {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) this._clearWarning(statName, 'max', {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.min === 'number') {
                count = $2031af13ca117135$var$countLow(limit.min, values);
                if (count >= raiseCount) this._raiseWarning(statName, 'min', {
                    values: values,
                    samples: relevantSamples
                });
                else if (count <= clearCount) this._clearWarning(statName, 'min', {
                    values: values,
                    samples: relevantSamples
                });
            }
            if (typeof limit.maxDuration === 'number' && samples.length > 1) {
                relevantSamples = samples.slice(-2);
                const prevValue = relevantSamples[0][statName];
                const curValue = relevantSamples[1][statName];
                const prevStreak = this._currentStreaks.get(statName) || 0;
                const streak = prevValue === curValue ? prevStreak + 1 : 0;
                this._currentStreaks.set(statName, streak);
                if (streak >= limit.maxDuration) this._raiseWarning(statName, 'maxDuration', {
                    value: streak
                });
                else if (streak === 0) this._clearWarning(statName, 'maxDuration', {
                    value: prevStreak
                });
            }
            if (typeof limit.minStandardDeviation === 'number') {
                const sampleSets = this._supplementalSampleBuffers[statName];
                if (!sampleSets || sampleSets.length < limit.sampleCount) return;
                if (sampleSets.length > limit.sampleCount) sampleSets.splice(0, sampleSets.length - limit.sampleCount);
                const flatSamples = $2031af13ca117135$var$flattenSamples(sampleSets.slice(-sampleCount));
                const stdDev = $2031af13ca117135$var$calculateStandardDeviation(flatSamples);
                if (typeof stdDev !== 'number') return;
                if (stdDev < limit.minStandardDeviation) this._raiseWarning(statName, 'minStandardDeviation', {
                    value: stdDev
                });
                else this._clearWarning(statName, 'minStandardDeviation', {
                    value: stdDev
                });
            }
            [
                [
                    'maxAverage',
                    (x, y)=>x > y
                ],
                [
                    'minAverage',
                    (x, y)=>x < y
                ]
            ].forEach(([thresholdName, comparator])=>{
                if (typeof limit[thresholdName] === 'number' && values.length >= sampleCount) {
                    const avg = (0, $a96769417395afb9$export$cc6710ee5f037d57)(values);
                    if (comparator(avg, limit[thresholdName])) this._raiseWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                    else if (!comparator(avg, limit.clearValue || limit[thresholdName])) this._clearWarning(statName, thresholdName, {
                        values: values,
                        samples: relevantSamples
                    });
                }
            });
        });
    }
}





const $73a9091c20261962$var$BACKOFF_CONFIG = {
    factor: 1.1,
    jitter: 0.5,
    max: 30000,
    min: 1
};
const $73a9091c20261962$var$DTMF_INTER_TONE_GAP = 70;
// Cadence of the feedback tones the caller hears. Intentionally independent of
// the wire's tone timing: this is audible feedback, not a mirror of what the
// recipient receives.
const $73a9091c20261962$var$DTMF_LOCAL_TONE_GAP = 200;
const $73a9091c20261962$var$DTMF_PAUSE_DURATION = 500;
const $73a9091c20261962$var$DTMF_TONE_DURATION = 160;
const $73a9091c20261962$var$METRICS_BATCH_SIZE = 10;
const $73a9091c20261962$var$METRICS_DELAY = 5000;
const $73a9091c20261962$var$MEDIA_DISCONNECT_ERROR = {
    disconnect: true,
    info: {
        code: 31003,
        message: 'Connection with Twilio was interrupted.',
        twilioError: new (0, $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899).ConnectionError()
    }
};
const $73a9091c20261962$var$MULTIPLE_THRESHOLD_WARNING_NAMES = {
    // The stat `packetsLostFraction` is monitored by two separate thresholds,
    // `maxAverage` and `max`. Each threshold emits a different warning name.
    packetsLostFraction: {
        max: 'packet-loss',
        maxAverage: 'packets-lost-fraction'
    }
};
const $73a9091c20261962$var$WARNING_NAMES = {
    audioInputLevel: 'audio-input-level',
    audioOutputLevel: 'audio-output-level',
    bytesReceived: 'bytes-received',
    bytesSent: 'bytes-sent',
    jitter: 'jitter',
    mos: 'mos',
    rtt: 'rtt'
};
const $73a9091c20261962$var$WARNING_PREFIXES = {
    max: 'high-',
    maxAverage: 'high-',
    maxDuration: 'constant-',
    min: 'low-',
    minStandardDeviation: 'constant-'
};
/**
 * A {@link Call} represents a media and signaling connection to a TwiML application.
 */ class $73a9091c20261962$export$2e2bcd8739ae039 extends (0, $5440e9199a418654$exports.EventEmitter) {
    /**
     * Whether this {@link Call} is incoming or outgoing.
     */ get direction() {
        return this._direction;
    }
    /**
     * Audio codec used for this {@link Call}. Expecting {@link Call.Codec} but
     * will copy whatever we get from RTC stats.
     */ get codec() {
        return this._codec;
    }
    /**
     * The connect token is available as soon as the call is established
     * and connected to Twilio. Use this token to reconnect to a call via the {@link Device.connect}
     * method.
     *
     * For incoming calls, it is available in the call object after the {@link Device.incomingEvent} is emitted.
     * For outgoing calls, it is available after the {@link Call.acceptEvent} is emitted.
     */ get connectToken() {
        const signalingReconnectToken = this._signalingReconnectToken;
        const callSid = this.parameters && this.parameters.CallSid ? this.parameters.CallSid : undefined;
        if (!signalingReconnectToken || !callSid) return;
        const customParameters = this.customParameters && typeof this.customParameters.keys === 'function' ? Array.from(this.customParameters.keys()).reduce((result, key)=>{
            result[key] = this.customParameters.get(key);
            return result;
        }, {}) : {};
        const parameters = this.parameters || {};
        return btoa(encodeURIComponent(JSON.stringify({
            customParameters: customParameters,
            parameters: parameters,
            signalingReconnectToken: signalingReconnectToken
        })));
    }
    /**
     * @internal
     * @param config - Mandatory configuration options
     * @param options - Optional settings
     */ constructor(config, options){
        super();
        /**
         * Call parameters received from Twilio for an incoming call.
         */ this.parameters = {};
        /**
         * The number of times input volume has been the same consecutively.
         */ this._inputVolumeStreak = 0;
        /**
         * Whether the call has been answered.
         */ this._isAnswered = false;
        /**
         * Whether the call has been cancelled.
         */ this._isCancelled = false;
        /**
         * Whether the call has been rejected
         */ this._isRejected = false;
        /**
         * The most recent public input volume value. 0 -> 1 representing -100 to -30 dB.
         */ this._latestInputVolume = 0;
        /**
         * The most recent public output volume value. 0 -> 1 representing -100 to -30 dB.
         */ this._latestOutputVolume = 0;
        /**
         * An instance of Logger to use.
         */ this._log = new (0, $596211e588505f95$export$2e2bcd8739ae039)('Call');
        /**
         * State of the {@link Call}'s media.
         */ this._mediaStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Pending;
        /**
         * A map of messages sent via sendMessage API using voiceEventSid as the key.
         * The message will be deleted once an 'ack' or an error is received from the server.
         */ this._messages = new Map();
        /**
         * A batch of metrics samples to send to Insights. Gets cleared after
         * each send and appended to on each new sample.
         */ this._metricsSamples = [];
        /**
         * Options passed to this {@link Call}.
         */ this._options = {
            MediaHandler: (0, $96a759d7ffb58b23$export$2e2bcd8739ae039),
            MediaStream: null,
            enableImprovedSignalingErrorPrecision: false,
            offerSdp: null,
            shouldPlayDisconnect: ()=>true,
            voiceEventSidGenerator: (0, $e37f0f8b9fdc4b95$export$230de48818ef3534)
        };
        /**
         * The number of times output volume has been the same consecutively.
         */ this._outputVolumeStreak = 0;
        /**
         * Whether the {@link Call} should send a hangup on disconnect.
         */ this._shouldSendHangup = true;
        /**
         * State of the {@link Call}'s signaling.
         */ this._signalingStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Pending;
        /**
         * A Map of Sounds to play.
         */ this._soundcache = new Map();
        /**
         * State of the {@link Call}.
         */ this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Pending;
        /**
         * Whether the {@link Call} has been connected. Used to determine if we are reconnected.
         */ this._wasConnected = false;
        /**
         * String representation of {@link Call} instance.
         * @internal
         */ this.toString = ()=>'[Twilio.Call instance]';
        this._emitWarning = (groupPrefix, warningName, threshold, value, wasCleared, warningData)=>{
            const groupSuffix = wasCleared ? '-cleared' : '-raised';
            const groupName = `${groupPrefix}warning${groupSuffix}`;
            // Ignore constant input if the Call is muted (Expected)
            if (warningName === 'constant-audio-input-level' && this.isMuted()) return;
            let level = wasCleared ? 'info' : 'warning';
            // Avoid throwing false positives as warnings until we refactor volume metrics
            if (warningName === 'constant-audio-output-level') level = 'info';
            const payloadData = {
                threshold: threshold
            };
            if (value) {
                if (value instanceof Array) payloadData.values = value.map((val)=>{
                    if (typeof val === 'number') return Math.round(val * 100) / 100;
                    return value;
                });
                else payloadData.value = value;
            }
            this._publisher.post(level, groupName, warningName, {
                data: payloadData
            }, this);
            if (warningName !== 'constant-audio-output-level') {
                const emitName = wasCleared ? 'warning-cleared' : 'warning';
                this._log.debug(`#${emitName}`, warningName);
                this.emit(emitName, warningName, warningData && !wasCleared ? warningData : null);
            }
        };
        /**
         * Called when the {@link Call} receives an ack from signaling
         * @param payload
         */ this._onAck = (payload)=>{
            const { acktype: acktype, callsid: callsid, voiceeventsid: voiceeventsid } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received ack from a different callsid: ${callsid}`);
                return;
            }
            if (acktype === 'message') this._onMessageSent(voiceeventsid);
        };
        /**
         * Called when the {@link Call} is answered.
         * @param payload
         */ this._onAnswer = (payload)=>{
            if (typeof payload.reconnect === 'string') this._signalingReconnectToken = payload.reconnect;
            // answerOnBridge=false will send a 183 which we need to catch in _onRinging when
            // the enableRingingState flag is disabled. In that case, we will receive a 200 after
            // the callee accepts the call firing a second `accept` event if we don't
            // short circuit here.
            if (this._isAnswered && this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) return;
            this._setCallSid(payload);
            this._isAnswered = true;
            this._maybeTransitionToOpen();
        };
        /**
         * Called when the {@link Call} is cancelled.
         * @param payload
         */ this._onCancel = (payload)=>{
            // (rrowland) Is this check necessary? Verify, and if so move to pstream / VSP module.
            const callsid = payload.callsid;
            if (this.parameters.CallSid === callsid) {
                this._isCancelled = true;
                this._publisher.info('connection', 'cancel', null, this);
                this._cleanupEventListeners();
                this._mediaHandler.close();
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
                this._log.debug('#cancel');
                this.emit('cancel');
                this._pstream.removeListener('cancel', this._onCancel);
            }
        };
        /**
         * Called when we receive a connected event from pstream.
         * Re-emits the event.
         */ this._onConnected = ()=>{
            this._log.info('Received connected from pstream');
            if (this._signalingReconnectToken && this._mediaHandler.version) this._pstream.reconnect(this._mediaHandler.version.getSDP(), this.parameters.CallSid, this._signalingReconnectToken);
        };
        /**
         * Called when the {@link Call} is hung up.
         * @param payload
         */ this._onHangup = (payload)=>{
            if (this.status() === $73a9091c20261962$export$2e2bcd8739ae039.State.Closed) return;
            /**
             *  see if callsid passed in message matches either callsid or outbound id
             *  call should always have either callsid or outbound id
             *  if no callsid passed hangup anyways
             */ if (payload.callsid && (this.parameters.CallSid || this.outboundConnectionId)) {
                if (payload.callsid !== this.parameters.CallSid && payload.callsid !== this.outboundConnectionId) return;
            } else if (payload.callsid) // hangup is for another call
            return;
            this._log.info('Received HANGUP from gateway');
            if (payload.error) {
                const code = payload.error.code;
                const errorConstructor = (0, $d122425987f9ca02$export$5a8950f600406bb3)(this._options.enableImprovedSignalingErrorPrecision, code);
                const error = typeof errorConstructor !== 'undefined' ? new errorConstructor(payload.error.message) : new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).ConnectionError('Error sent from gateway in HANGUP', payload.error);
                this._log.error('Received an error from the gateway:', error);
                this._log.debug('#error', error);
                this.emit('error', error);
            }
            this._shouldSendHangup = false;
            this._publisher.info('connection', 'disconnected-by-remote', null, this);
            this._disconnect(null, true);
            this._cleanupEventListeners();
        };
        /**
         * Called when there is a media failure.
         * Manages all media-related states and takes action base on the states
         * @param type - Type of media failure
         */ this._onMediaFailure = (type)=>{
            const { ConnectionDisconnected: ConnectionDisconnected, ConnectionFailed: ConnectionFailed, IceGatheringFailed: IceGatheringFailed, LowBytes: LowBytes } = $73a9091c20261962$export$2e2bcd8739ae039.MediaFailure;
            // These types signifies the end of a single ICE cycle
            const isEndOfIceCycle = type === ConnectionFailed || type === IceGatheringFailed;
            // All browsers except chrome doesn't update pc.iceConnectionState and pc.connectionState
            // after issuing an ICE Restart, which we use to determine if ICE Restart is complete.
            // Since we cannot detect if ICE Restart is complete, we will not retry.
            if (!(0, $a96769417395afb9$export$6446a186d09e379e)(window, window.navigator) && type === ConnectionFailed) return this._mediaHandler.onerror($73a9091c20261962$var$MEDIA_DISCONNECT_ERROR);
            // Ignore subsequent requests if ice restart is in progress
            if (this._mediaStatus === $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) {
                // This is a retry. Previous ICE Restart failed
                if (isEndOfIceCycle) {
                    // We already exceeded max retry time.
                    if (Date.now() - this._mediaReconnectStartTime > $73a9091c20261962$var$BACKOFF_CONFIG.max) {
                        this._log.warn('Exceeded max ICE retries');
                        return this._mediaHandler.onerror($73a9091c20261962$var$MEDIA_DISCONNECT_ERROR);
                    }
                    // Issue ICE restart with backoff
                    try {
                        this._mediaReconnectBackoff.backoff();
                    } catch (error) {
                        // Catch and ignore 'Backoff in progress.' errors. If a backoff is
                        // ongoing and we try to start another one, there shouldn't be a
                        // problem.
                        if (!(error.message && error.message === 'Backoff in progress.')) throw error;
                    }
                }
                return;
            }
            const pc = this._mediaHandler.version.pc;
            const isIceDisconnected = pc && pc.iceConnectionState === 'disconnected';
            const hasLowBytesWarning = this._monitor.hasActiveWarning('bytesSent', 'min') || this._monitor.hasActiveWarning('bytesReceived', 'min');
            // Only certain conditions can trigger media reconnection
            if (type === LowBytes && isIceDisconnected || type === ConnectionDisconnected && hasLowBytesWarning || isEndOfIceCycle) {
                const mediaReconnectionError = new (0, $4bc3a86d2ffe35f2$export$8fcb1fc8290c4899).ConnectionError('Media connection failed.');
                this._log.warn('ICE Connection disconnected.');
                this._publisher.warn('connection', 'error', mediaReconnectionError, this);
                this._publisher.info('connection', 'reconnecting', null, this);
                this._mediaReconnectStartTime = Date.now();
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting;
                this._mediaStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting;
                this._mediaReconnectBackoff.reset();
                this._mediaReconnectBackoff.backoff();
                this._log.debug('#reconnecting');
                this.emit('reconnecting', mediaReconnectionError);
            }
        };
        /**
         * Called when media call is restored
         */ this._onMediaReconnected = ()=>{
            // Only trigger once.
            // This can trigger on pc.onIceConnectionChange and pc.onConnectionChange.
            if (this._mediaStatus !== $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) return;
            this._log.info('ICE Connection reestablished.');
            this._mediaStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
            if (this._signalingStatus === $73a9091c20261962$export$2e2bcd8739ae039.State.Open) {
                this._publisher.info('connection', 'reconnected', null, this);
                this._log.debug('#reconnected');
                this.emit('reconnected');
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
            }
        };
        /**
         * Raised when a Call receives a message from the backend.
         * @param payload - A record representing the payload of the message from the
         * Twilio backend.
         */ this._onMessageReceived = (payload)=>{
            const { callsid: callsid, content: content, contenttype: contenttype, messagetype: messagetype, voiceeventsid: voiceeventsid } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received a message from a different callsid: ${callsid}`);
                return;
            }
            const data = {
                content: content,
                contentType: contenttype,
                messageType: messagetype,
                voiceEventSid: voiceeventsid
            };
            this._publisher.info('call-message', messagetype, {
                content_type: contenttype,
                event_type: 'received',
                voice_event_sid: voiceeventsid
            }, this);
            this._log.debug('#messageReceived', JSON.stringify(data));
            this.emit('messageReceived', data);
        };
        /**
         * Raised when a Call receives an 'ack' with an 'acktype' of 'message.
         * This means that the message sent via sendMessage API has been received by the signaling server.
         * @param voiceEventSid
         */ this._onMessageSent = (voiceEventSid)=>{
            if (!this._messages.has(voiceEventSid)) {
                this._log.warn(`Received a messageSent with a voiceEventSid that doesn't exists: ${voiceEventSid}`);
                return;
            }
            const message = this._messages.get(voiceEventSid);
            this._messages.delete(voiceEventSid);
            this._publisher.info('call-message', message === null || message === void 0 ? void 0 : message.messageType, {
                content_type: message === null || message === void 0 ? void 0 : message.contentType,
                event_type: 'sent',
                voice_event_sid: voiceEventSid
            }, this);
            this._log.debug('#messageSent', JSON.stringify(message));
            this.emit('messageSent', message);
        };
        /**
         * When we get a RINGING signal from PStream, update the {@link Call} status.
         * @param payload
         */ this._onRinging = (payload)=>{
            this._setCallSid(payload);
            // If we're not in 'connecting' or 'ringing' state, this event was received out of order.
            if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Connecting && this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Ringing) return;
            const hasEarlyMedia = !!payload.sdp;
            this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Ringing;
            this._publisher.info('connection', 'outgoing-ringing', {
                hasEarlyMedia: hasEarlyMedia
            }, this);
            this._log.debug('#ringing');
            this.emit('ringing', hasEarlyMedia);
        };
        /**
         * Called each time StatsMonitor emits a sample.
         * Emits stats event and batches the call stats metrics and sends them to Insights.
         * @param sample
         */ this._onRTCSample = (sample)=>{
            const callMetrics = Object.assign(Object.assign({}, sample), {
                inputVolume: this._latestInputVolume,
                outputVolume: this._latestOutputVolume
            });
            this._codec = callMetrics.codecName;
            this._metricsSamples.push(callMetrics);
            if (this._metricsSamples.length >= $73a9091c20261962$var$METRICS_BATCH_SIZE) this._publishMetrics();
            this.emit('sample', sample);
        };
        /**
         * Called when an 'error' event is received from the signaling stream.
         */ this._onSignalingError = (payload)=>{
            const { callsid: callsid, voiceeventsid: voiceeventsid, error: error } = payload;
            if (this.parameters.CallSid !== callsid) {
                this._log.warn(`Received an error from a different callsid: ${callsid}`);
                return;
            }
            if (voiceeventsid && this._messages.has(voiceeventsid)) {
                // Do not emit an error here. Device is handling all signaling related errors.
                this._messages.delete(voiceeventsid);
                this._log.warn(`Received an error while sending a message.`, payload);
                this._publisher.error('call-message', 'error', {
                    code: error.code,
                    message: error.message,
                    voice_event_sid: voiceeventsid
                }, this);
                let twilioError;
                const errorConstructor = (0, $d122425987f9ca02$export$5a8950f600406bb3)(!!this._options.enableImprovedSignalingErrorPrecision, error.code);
                if (typeof errorConstructor !== 'undefined') twilioError = new errorConstructor(error);
                if (!twilioError) {
                    this._log.error('Unknown Call Message Error: ', error);
                    twilioError = new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).UnknownError(error.message, error);
                }
                this._log.debug('#error', error, twilioError);
                this.emit('error', twilioError);
            }
        };
        /**
         * Called when signaling is restored
         */ this._onSignalingReconnected = ()=>{
            if (this._signalingStatus !== $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) return;
            this._log.info('Signaling Connection reestablished.');
            this._signalingStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
            if (this._mediaStatus === $73a9091c20261962$export$2e2bcd8739ae039.State.Open) {
                this._publisher.info('connection', 'reconnected', null, this);
                this._log.debug('#reconnected');
                this.emit('reconnected');
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
            }
        };
        /**
         * Called when we receive a transportClose event from pstream.
         * Re-emits the event.
         */ this._onTransportClose = ()=>{
            this._log.error('Received transportClose from pstream');
            this._log.debug('#transportClose');
            this.emit('transportClose');
            if (this._signalingReconnectToken) {
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting;
                this._signalingStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting;
                this._publisher.info('connection', 'reconnecting', null, this);
                this._log.debug('#reconnecting');
                this.emit('reconnecting', new (0, $4bc3a86d2ffe35f2$export$ab09c81dbb29a8b1).ConnectionDisconnected());
            } else {
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
                this._signalingStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
            }
        };
        /**
         * Re-emit an StatsMonitor warning as a {@link Call}.warning or .warning-cleared event.
         * @param warningData
         * @param wasCleared - Whether this is a -cleared or -raised event.
         */ this._reemitWarning = (warningData, wasCleared)=>{
            const groupPrefix = /^audio/.test(warningData.name) ? 'audio-level-' : 'network-quality-';
            const warningPrefix = $73a9091c20261962$var$WARNING_PREFIXES[warningData.threshold.name];
            /**
             * NOTE: There are two "packet-loss" warnings: `high-packet-loss` and
             * `high-packets-lost-fraction`, so in this case we need to use a different
             * `WARNING_NAME` mapping.
             */ let warningName;
            if (warningData.name in $73a9091c20261962$var$MULTIPLE_THRESHOLD_WARNING_NAMES) warningName = $73a9091c20261962$var$MULTIPLE_THRESHOLD_WARNING_NAMES[warningData.name][warningData.threshold.name];
            else if (warningData.name in $73a9091c20261962$var$WARNING_NAMES) warningName = $73a9091c20261962$var$WARNING_NAMES[warningData.name];
            const warning = warningPrefix + warningName;
            this._emitWarning(groupPrefix, warning, warningData.threshold.value, warningData.values || warningData.value, wasCleared, warningData);
        };
        /**
         * Re-emit an StatsMonitor warning-cleared as a .warning-cleared event.
         * @param warningData
         */ this._reemitWarningCleared = (warningData)=>{
            this._reemitWarning(warningData, true);
        };
        this._soundcache = config.soundcache;
        if (typeof config.onIgnore === 'function') this._onIgnore = config.onIgnore;
        const message = options && options.twimlParams || {};
        this.customParameters = new Map(Object.entries(message).map(([key, val])=>[
                key,
                String(val)
            ]));
        Object.assign(this._options, options);
        if (this._options.callParameters) this.parameters = this._options.callParameters;
        if (this._options.reconnectToken) this._signalingReconnectToken = this._options.reconnectToken;
        this._voiceEventSidGenerator = this._options.voiceEventSidGenerator || (0, $e37f0f8b9fdc4b95$export$230de48818ef3534);
        this._direction = this.parameters.CallSid && !this._options.reconnectCallSid ? $73a9091c20261962$export$2e2bcd8739ae039.CallDirection.Incoming : $73a9091c20261962$export$2e2bcd8739ae039.CallDirection.Outgoing;
        if (this.parameters) this.callerInfo = this.parameters.StirStatus ? {
            isVerified: this.parameters.StirStatus === 'TN-Validation-Passed-A'
        } : null;
        else this.callerInfo = null;
        this._mediaReconnectBackoff = new (0, $e2f41017236580ee$export$2e2bcd8739ae039)($73a9091c20261962$var$BACKOFF_CONFIG);
        this._mediaReconnectBackoff.on('ready', ()=>this._mediaHandler.iceRestart());
        // temporary call sid to be used for outgoing calls
        this.outboundConnectionId = $73a9091c20261962$var$generateTempCallSid();
        const publisher = this._publisher = config.publisher;
        if (this._direction === $73a9091c20261962$export$2e2bcd8739ae039.CallDirection.Incoming) publisher.info('connection', 'incoming', null, this);
        else publisher.info('connection', 'outgoing', {
            preflight: this._options.preflight,
            reconnect: !!this._options.reconnectCallSid
        }, this);
        const monitor = this._monitor = new (this._options.StatsMonitor || (0, $2031af13ca117135$export$2e2bcd8739ae039))();
        monitor.on('sample', this._onRTCSample);
        // First 20 seconds or so are choppy, so let's not bother with these warnings.
        monitor.disableWarnings();
        setTimeout(()=>monitor.enableWarnings(), $73a9091c20261962$var$METRICS_DELAY);
        monitor.on('warning', (data, wasCleared)=>{
            if (data.name === 'bytesSent' || data.name === 'bytesReceived') this._onMediaFailure($73a9091c20261962$export$2e2bcd8739ae039.MediaFailure.LowBytes);
            this._reemitWarning(data, wasCleared);
        });
        monitor.on('warning-cleared', (data)=>{
            this._reemitWarningCleared(data);
        });
        this._mediaHandler = new this._options.MediaHandler(config.audioHelper, config.pstream, {
            MediaStream: this._options.MediaStream,
            RTCPeerConnection: this._options.RTCPeerConnection,
            codecPreferences: this._options.codecPreferences,
            dscp: this._options.dscp,
            forceAggressiveIceNomination: this._options.forceAggressiveIceNomination,
            maxAverageBitrate: this._options.maxAverageBitrate
        });
        this.on('volume', (inputVolume, outputVolume)=>{
            this._inputVolumeStreak = this._checkVolume(inputVolume, this._inputVolumeStreak, this._latestInputVolume, 'input');
            this._outputVolumeStreak = this._checkVolume(outputVolume, this._outputVolumeStreak, this._latestOutputVolume, 'output');
            this._latestInputVolume = inputVolume;
            this._latestOutputVolume = outputVolume;
        });
        this._mediaHandler.onaudio = (remoteAudio)=>{
            this._log.debug('#audio');
            this.emit('audio', remoteAudio);
        };
        this._mediaHandler.onvolume = (inputVolume, outputVolume, internalInputVolume, internalOutputVolume)=>{
            // (rrowland) These values mock the 0 -> 32767 format used by legacy getStats. We should look into
            // migrating to a newer standard, either 0.0 -> linear or -127 to 0 in dB, matching the range
            // chosen below.
            monitor.addVolumes(internalInputVolume / 255 * 32767, internalOutputVolume / 255 * 32767);
            // (rrowland) 0.0 -> 1.0 linear
            this.emit('volume', inputVolume, outputVolume);
        };
        this._mediaHandler.ondtlstransportstatechange = (state)=>{
            const level = state === 'failed' ? 'error' : 'debug';
            this._publisher.post(level, 'dtls-transport-state', state, null, this);
        };
        this._mediaHandler.onpcconnectionstatechange = (state)=>{
            let level = 'debug';
            const dtlsTransport = this._mediaHandler.getRTCDtlsTransport();
            if (state === 'failed') level = dtlsTransport && dtlsTransport.state === 'failed' ? 'error' : 'warning';
            this._publisher.post(level, 'pc-connection-state', state, null, this);
        };
        this._mediaHandler.onicecandidate = (candidate)=>{
            const payload = new (0, $ca86b8c6f86d7448$export$1a8483fdfc1e9c99)(candidate).toPayload();
            this._publisher.debug('ice-candidate', 'ice-candidate', payload, this);
        };
        this._mediaHandler.onselectedcandidatepairchange = (pair)=>{
            const localCandidatePayload = new (0, $ca86b8c6f86d7448$export$1a8483fdfc1e9c99)(pair.local).toPayload();
            const remoteCandidatePayload = new (0, $ca86b8c6f86d7448$export$1a8483fdfc1e9c99)(pair.remote, true).toPayload();
            this._publisher.debug('ice-candidate', 'selected-ice-candidate-pair', {
                local_candidate: localCandidatePayload,
                remote_candidate: remoteCandidatePayload
            }, this);
        };
        this._mediaHandler.oniceconnectionstatechange = (state)=>{
            const level = state === 'failed' ? 'error' : 'debug';
            this._publisher.post(level, 'ice-connection-state', state, null, this);
        };
        this._mediaHandler.onicegatheringfailure = (type)=>{
            this._publisher.warn('ice-gathering-state', type, null, this);
            this._onMediaFailure($73a9091c20261962$export$2e2bcd8739ae039.MediaFailure.IceGatheringFailed);
        };
        this._mediaHandler.onicegatheringstatechange = (state)=>{
            this._publisher.debug('ice-gathering-state', state, null, this);
        };
        this._mediaHandler.onsignalingstatechange = (state)=>{
            this._publisher.debug('signaling-state', state, null, this);
        };
        this._mediaHandler.ondisconnected = (msg)=>{
            this._log.warn(msg);
            this._publisher.warn('network-quality-warning-raised', 'ice-connectivity-lost', {
                message: msg
            }, this);
            this._log.debug('#warning', 'ice-connectivity-lost');
            this.emit('warning', 'ice-connectivity-lost');
            this._onMediaFailure($73a9091c20261962$export$2e2bcd8739ae039.MediaFailure.ConnectionDisconnected);
        };
        this._mediaHandler.onfailed = (msg)=>{
            this._onMediaFailure($73a9091c20261962$export$2e2bcd8739ae039.MediaFailure.ConnectionFailed);
        };
        this._mediaHandler.onconnected = ()=>{
            // First time _mediaHandler is connected, but ICE Gathering issued an ICE restart and succeeded.
            if (this._status === $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) this._onMediaReconnected();
        };
        this._mediaHandler.onreconnected = (msg)=>{
            this._log.info(msg);
            this._publisher.info('network-quality-warning-cleared', 'ice-connectivity-lost', {
                message: msg
            }, this);
            this._log.debug('#warning-cleared', 'ice-connectivity-lost');
            this.emit('warning-cleared', 'ice-connectivity-lost');
            this._onMediaReconnected();
        };
        this._mediaHandler.onerror = (e)=>{
            if (e.disconnect === true) this._disconnect(e.info && e.info.message);
            const error = e.info.twilioError || new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).UnknownError(e.info.message);
            this._log.error('Received an error from MediaStream:', e);
            this._log.debug('#error', error);
            this.emit('error', error);
        };
        this._mediaHandler.onopen = ()=>{
            // NOTE(mroberts): While this may have been happening in previous
            // versions of Chrome, since Chrome 45 we have seen the
            // PeerConnection's onsignalingstatechange handler invoked multiple
            // times in the same signalingState 'stable'. When this happens, we
            // invoke this onopen function. If we invoke it twice without checking
            // for _status 'open', we'd accidentally close the PeerConnection.
            //
            // See <https://code.google.com/p/webrtc/issues/detail?id=4996>.
            if (this._status === $73a9091c20261962$export$2e2bcd8739ae039.State.Open || this._status === $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting) return;
            else if (this._status === $73a9091c20261962$export$2e2bcd8739ae039.State.Ringing || this._status === $73a9091c20261962$export$2e2bcd8739ae039.State.Connecting) {
                this.mute(this._mediaHandler.isMuted);
                this._mediaStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
                this._maybeTransitionToOpen();
            } else // call was probably canceled sometime before this
            this._mediaHandler.close();
        };
        this._mediaHandler.onclose = ()=>{
            this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
            if (this._options.shouldPlayDisconnect && this._options.shouldPlayDisconnect() && !this._isCancelled && !this._isRejected) this._soundcache.get((0, $2b01ca659bdc22ff$export$2e2bcd8739ae039).SoundName.Disconnect).play();
            monitor.disable();
            this._publishMetrics();
            if (!this._isCancelled && !this._isRejected) {
                // tslint:disable no-console
                this._log.debug('#disconnect');
                this.emit('disconnect', this);
            }
        };
        this._pstream = config.pstream;
        this._pstream.on('ack', this._onAck);
        this._pstream.on('cancel', this._onCancel);
        this._pstream.on('error', this._onSignalingError);
        this._pstream.on('ringing', this._onRinging);
        this._pstream.on('transportClose', this._onTransportClose);
        this._pstream.on('connected', this._onConnected);
        this._pstream.on('message', this._onMessageReceived);
        this.on('error', (error)=>{
            this._publisher.error('connection', 'error', {
                code: error.code,
                message: error.message
            }, this);
            if (this._pstream && this._pstream.status === 'disconnected') this._cleanupEventListeners();
        });
        this.on('disconnect', ()=>{
            this._cleanupEventListeners();
        });
    }
    /**
     * Set the audio input tracks from a given stream.
     * @internal
     * @param stream
     */ _setInputTracksFromStream(stream) {
        return this._mediaHandler.setInputTracksFromStream(stream);
    }
    /**
     * Set the audio output sink IDs.
     * @internal
     * @param sinkIds
     */ _setSinkIds(sinkIds) {
        return this._mediaHandler._setSinkIds(sinkIds);
    }
    /**
     * Accept the incoming {@link Call}.
     * @param [options]
     */ accept(options) {
        this._log.debug('.accept', options);
        if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Pending) {
            this._log.debug(`.accept noop. status is '${this._status}'`);
            return;
        }
        options = options || {};
        const rtcConfiguration = options.rtcConfiguration || this._options.rtcConfiguration;
        const rtcConstraints = options.rtcConstraints || this._options.rtcConstraints || {};
        const audioConstraints = {
            audio: typeof rtcConstraints.audio !== 'undefined' ? rtcConstraints.audio : true
        };
        this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Connecting;
        const connect = ()=>{
            if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Connecting) {
                // call must have been canceled
                this._cleanupEventListeners();
                this._mediaHandler.close();
                return;
            }
            const onAnswer = (pc)=>{
                // Report that the call was answered, and directionality
                const eventName = this._direction === $73a9091c20261962$export$2e2bcd8739ae039.CallDirection.Incoming ? 'accepted-by-local' : 'accepted-by-remote';
                this._publisher.info('connection', eventName, null, this);
                // Report the preferred codec and params as they appear in the SDP
                const { codecName: codecName, codecParams: codecParams } = (0, $adb118a246ff8f2c$export$f93ca60aaaaaacb8)(this._mediaHandler.version.getSDP());
                this._publisher.info('settings', 'codec', {
                    codec_params: codecParams,
                    selected_codec: codecName
                }, this);
                // Enable RTC monitoring
                this._monitor.enable(pc);
            };
            const sinkIds = typeof this._options.getSinkIds === 'function' && this._options.getSinkIds();
            if (Array.isArray(sinkIds)) this._mediaHandler._setSinkIds(sinkIds).catch(()=>{
            // (rrowland) We don't want this to throw to console since the customer
            // can't control this. This will most commonly be rejected on browsers
            // that don't support setting sink IDs.
            });
            this._pstream.addListener('hangup', this._onHangup);
            if (this._direction === $73a9091c20261962$export$2e2bcd8739ae039.CallDirection.Incoming) {
                this._isAnswered = true;
                this._pstream.on('answer', this._onAnswer);
                this._mediaHandler.answerIncomingCall(this.parameters.CallSid, this._options.offerSdp, rtcConfiguration, onAnswer);
            } else {
                const params = Array.from(this.customParameters.entries()).map((pair)=>`${encodeURIComponent(pair[0])}=${encodeURIComponent(pair[1])}`).join('&');
                this._pstream.on('answer', this._onAnswer);
                this._mediaHandler.makeOutgoingCall(params, this._signalingReconnectToken, this._options.reconnectCallSid || this.outboundConnectionId, rtcConfiguration, onAnswer);
            }
        };
        if (this._options.beforeAccept) this._options.beforeAccept(this);
        const inputStream = typeof this._options.getInputStream === 'function' && this._options.getInputStream();
        const promise = inputStream ? this._mediaHandler.setInputTracksFromStream(inputStream) : this._mediaHandler.openDefaultDeviceWithConstraints(audioConstraints);
        promise.then(()=>{
            this._publisher.info('get-user-media', 'succeeded', {
                data: {
                    audioConstraints: audioConstraints
                }
            }, this);
            connect();
        }, (error)=>{
            let twilioError;
            if (error.code === 31208 || [
                'PermissionDeniedError',
                'NotAllowedError'
            ].indexOf(error.name) !== -1) {
                twilioError = new (0, $4bc3a86d2ffe35f2$export$21b1583df4547a66).PermissionDeniedError();
                this._publisher.error('get-user-media', 'denied', {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, this);
            } else {
                twilioError = new (0, $4bc3a86d2ffe35f2$export$21b1583df4547a66).AcquisitionFailedError();
                this._publisher.error('get-user-media', 'failed', {
                    data: {
                        audioConstraints: audioConstraints,
                        error: error
                    }
                }, this);
            }
            this._disconnect();
            this._log.debug('#error', error);
            this.emit('error', twilioError);
        });
    }
    /**
     * Disconnect from the {@link Call}.
     */ disconnect() {
        this._log.debug('.disconnect');
        this._disconnect();
    }
    /**
     * Get the local MediaStream, if set.
     */ getLocalStream() {
        return this._mediaHandler && this._mediaHandler.stream;
    }
    /**
     * Get the remote MediaStream, if set.
     */ getRemoteStream() {
        return this._mediaHandler && this._mediaHandler._remoteStream;
    }
    /**
     * Ignore the incoming {@link Call}.
     */ ignore() {
        this._log.debug('.ignore');
        if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Pending) {
            this._log.debug(`.ignore noop. status is '${this._status}'`);
            return;
        }
        this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
        this._mediaHandler.ignore(this.parameters.CallSid);
        this._publisher.info('connection', 'ignored-by-local', null, this);
        if (this._onIgnore) this._onIgnore();
    }
    /**
     * Check whether call is muted
     */ isMuted() {
        return this._mediaHandler.isMuted;
    }
    /**
     * Mute incoming audio.
     * @param shouldMute - Whether the incoming audio should be muted. Defaults to true.
     */ mute(shouldMute = true) {
        this._log.debug('.mute', shouldMute);
        const wasMuted = this._mediaHandler.isMuted;
        this._mediaHandler.mute(shouldMute);
        const isMuted = this._mediaHandler.isMuted;
        if (wasMuted !== isMuted) {
            this._publisher.info('connection', isMuted ? 'muted' : 'unmuted', null, this);
            this._log.debug('#mute', isMuted);
            this.emit('mute', isMuted, this);
        }
    }
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has given call quality feedback. Called without a score, this
     *   will report that the customer declined to give feedback.
     * @param score - The end-user's rating of the call; an
     *   integer 1 through 5. Or undefined if the user declined to give
     *   feedback.
     * @param issue - The primary issue the end user
     *   experienced on the call. Can be: ['one-way-audio', 'choppy-audio',
     *   'dropped-call', 'audio-latency', 'noisy-call', 'echo']
     */ postFeedback(score, issue) {
        if (typeof score === 'undefined' || score === null) return this._postFeedbackDeclined();
        if (!Object.values($73a9091c20261962$export$2e2bcd8739ae039.FeedbackScore).includes(score)) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)(`Feedback score must be one of: ${Object.values($73a9091c20261962$export$2e2bcd8739ae039.FeedbackScore)}`);
        if (typeof issue !== 'undefined' && issue !== null && !Object.values($73a9091c20261962$export$2e2bcd8739ae039.FeedbackIssue).includes(issue)) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)(`Feedback issue must be one of: ${Object.values($73a9091c20261962$export$2e2bcd8739ae039.FeedbackIssue)}`);
        return this._publisher.info('feedback', 'received', {
            issue_name: issue,
            quality_score: score
        }, this, true);
    }
    /**
     * Reject the incoming {@link Call}.
     */ reject() {
        this._log.debug('.reject');
        if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Pending) {
            this._log.debug(`.reject noop. status is '${this._status}'`);
            return;
        }
        this._isRejected = true;
        this._pstream.reject(this.parameters.CallSid);
        this._mediaHandler.reject(this.parameters.CallSid);
        this._publisher.info('connection', 'rejected-by-local', null, this);
        this._cleanupEventListeners();
        this._mediaHandler.close();
        this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Closed;
        this._log.debug('#reject');
        this.emit('reject');
    }
    /**
     * Send a string of digits.
     * @param digits
     */ sendDigits(digits) {
        this._log.debug('.sendDigits', digits);
        if (digits.match(/[^0-9*#w]/)) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('Illegal character passed into sendDigits');
        const customSounds = this._options.customSounds || {};
        const sequence = [];
        digits.split('').forEach((digit)=>{
            let dtmf = digit !== 'w' ? `dtmf${digit}` : '';
            if (dtmf === 'dtmf*') dtmf = 'dtmfs';
            if (dtmf === 'dtmf#') dtmf = 'dtmfh';
            sequence.push(dtmf);
        });
        let tonesInRun = 0;
        const playNextDigit = ()=>{
            const digit = sequence.shift();
            if (digit) {
                tonesInRun++;
                if (this._options.dialtonePlayer && !customSounds[digit]) this._options.dialtonePlayer.play(digit);
                else this._soundcache.get(digit).play();
            }
            if (sequence.length) {
                let delay;
                if (digit) delay = $73a9091c20261962$var$DTMF_LOCAL_TONE_GAP;
                else {
                    // A pause ('w') is an empty string here and plays no sound. The wire
                    // starts its pause timer at the start of a run, so the pause overlaps
                    // that run's tones. Subtract the tones already played to match it.
                    delay = Math.max(0, $73a9091c20261962$var$DTMF_PAUSE_DURATION - tonesInRun * $73a9091c20261962$var$DTMF_LOCAL_TONE_GAP);
                    tonesInRun = 0;
                }
                setTimeout(()=>playNextDigit(), delay);
            }
        };
        playNextDigit();
        const dtmfSender = this._mediaHandler.getOrCreateDTMFSender();
        function insertDTMF(dtmfs) {
            if (!dtmfs.length) return;
            const dtmf = dtmfs.shift();
            if (dtmf && dtmf.length) dtmfSender.insertDTMF(dtmf, $73a9091c20261962$var$DTMF_TONE_DURATION, $73a9091c20261962$var$DTMF_INTER_TONE_GAP);
            setTimeout(insertDTMF.bind(null, dtmfs), $73a9091c20261962$var$DTMF_PAUSE_DURATION);
        }
        if (dtmfSender) {
            if (!('canInsertDTMF' in dtmfSender) || dtmfSender.canInsertDTMF) {
                this._log.info('Sending digits using RTCDTMFSender');
                // NOTE(mroberts): We can't just map 'w' to ',' since
                // RTCDTMFSender's pause duration is 2 s and Twilio's is more
                // like 500 ms. Instead, we will fudge it with setTimeout.
                insertDTMF(digits.split('w'));
                return;
            }
            this._log.info('RTCDTMFSender cannot insert DTMF');
        }
        // send pstream message to send DTMF
        this._log.info('Sending digits over PStream');
        if (this._pstream !== null && this._pstream.status !== 'disconnected') this._pstream.dtmf(this.parameters.CallSid, digits);
        else {
            const error = new (0, $4bc3a86d2ffe35f2$export$a0a7c95426af7b48).ConnectionError('Could not send DTMF: Signaling channel is disconnected');
            this._log.debug('#error', error);
            this.emit('error', error);
        }
    }
    /**
     * Send a message to Twilio. Your backend application can listen for these
     * messages to allow communication between your frontend and backend applications.
     * <br/><br/>This feature is currently in Beta.
     * @param message - The message object to send.
     * @returns A voice event sid that uniquely identifies the message that was sent.
     */ sendMessage(message) {
        this._log.debug('.sendMessage', JSON.stringify(message));
        const { content: content, contentType: contentType, messageType: messageType } = message;
        if (typeof content === 'undefined' || content === null) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('`content` is empty');
        if (typeof messageType !== 'string') throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('`messageType` must be a string.');
        if (messageType.length === 0) throw new (0, $d122425987f9ca02$export$9c711d4a95378233)('`messageType` must be a non-empty string.');
        if (this._pstream === null) throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)('Could not send CallMessage; Signaling channel is disconnected');
        const callSid = this.parameters.CallSid;
        if (typeof this.parameters.CallSid === 'undefined') throw new (0, $d122425987f9ca02$export$b251fc1661a3152d)('Could not send CallMessage; Call has no CallSid');
        const voiceEventSid = this._voiceEventSidGenerator();
        this._messages.set(voiceEventSid, {
            content: content,
            contentType: contentType,
            messageType: messageType,
            voiceEventSid: voiceEventSid
        });
        this._pstream.sendMessage(callSid, content, contentType, messageType, voiceEventSid);
        return voiceEventSid;
    }
    /**
     * Get the current {@link Call} status.
     */ status() {
        return this._status;
    }
    /**
     * Check the volume passed, emitting a warning if one way audio is detected or cleared.
     * @param currentVolume - The current volume for this direction
     * @param streakFieldName - The name of the field on the {@link Call} object that tracks how many times the
     *   current value has been repeated consecutively.
     * @param lastValueFieldName - The name of the field on the {@link Call} object that tracks the most recent
     *   volume for this direction
     * @param direction - The directionality of this audio track, either 'input' or 'output'
     * @returns The current streak; how many times in a row the same value has been polled.
     */ _checkVolume(currentVolume, currentStreak, lastValue, direction) {
        const wasWarningRaised = currentStreak >= 10;
        let newStreak = 0;
        if (lastValue === currentVolume) newStreak = currentStreak;
        if (newStreak >= 10) this._emitWarning('audio-level-', `constant-audio-${direction}-level`, 10, newStreak, false);
        else if (wasWarningRaised) this._emitWarning('audio-level-', `constant-audio-${direction}-level`, 10, newStreak, true);
        return newStreak;
    }
    /**
     * Clean up event listeners.
     */ _cleanupEventListeners() {
        const cleanup = ()=>{
            if (!this._pstream) return;
            this._pstream.removeListener('ack', this._onAck);
            this._pstream.removeListener('answer', this._onAnswer);
            this._pstream.removeListener('cancel', this._onCancel);
            this._pstream.removeListener('error', this._onSignalingError);
            this._pstream.removeListener('hangup', this._onHangup);
            this._pstream.removeListener('ringing', this._onRinging);
            this._pstream.removeListener('transportClose', this._onTransportClose);
            this._pstream.removeListener('connected', this._onConnected);
            this._pstream.removeListener('message', this._onMessageReceived);
        };
        // This is kind of a hack, but it lets us avoid rewriting more code.
        // Basically, there's a sequencing problem with the way PeerConnection raises
        // the
        //
        //   Cannot establish call. SDK is disconnected
        //
        // error in Call#accept. It calls PeerConnection#onerror, which emits
        // the error event on Call. An error handler on Call then calls
        // cleanupEventListeners, but then control returns to Call#accept. It's
        // at this point that we add a listener for the answer event that never gets
        // removed. setTimeout will allow us to rerun cleanup again, _after_
        // Call#accept returns.
        cleanup();
        setTimeout(cleanup, 0);
    }
    /**
     * Create the payload wrapper for a batch of metrics to be sent to Insights.
     */ _createMetricPayload() {
        const payload = {
            call_sid: this.parameters.CallSid,
            dscp: !!this._options.dscp,
            sdk_version: (0, $1ec27394c1cce6bb$export$f1af843f4d252578)
        };
        if (this._options.gateway) payload.gateway = this._options.gateway;
        payload.direction = this._direction;
        return payload;
    }
    /**
     * Disconnect the {@link Call}.
     * @param message - A message explaining why the {@link Call} is being disconnected.
     * @param wasRemote - Whether the disconnect was triggered locally or remotely.
     */ _disconnect(message, wasRemote) {
        message = typeof message === 'string' ? message : null;
        if (this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Open && this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Connecting && this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Reconnecting && this._status !== $73a9091c20261962$export$2e2bcd8739ae039.State.Ringing) return;
        this._log.info('Disconnecting...');
        // send pstream hangup message
        if (this._pstream !== null && this._pstream.status !== 'disconnected' && this._shouldSendHangup) {
            const callsid = this.parameters.CallSid || this.outboundConnectionId;
            if (callsid) this._pstream.hangup(callsid, message);
        }
        this._cleanupEventListeners();
        this._mediaHandler.close();
        if (!wasRemote) this._publisher.info('connection', 'disconnected-by-local', null, this);
    }
    /**
     * Transition to {@link CallStatus.Open} if criteria is met.
     */ _maybeTransitionToOpen() {
        this._wasConnected;
        if (this._isAnswered) {
            this._onSignalingReconnected();
            this._signalingStatus = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
            if (this._mediaHandler && this._mediaHandler.status === 'open') {
                this._status = $73a9091c20261962$export$2e2bcd8739ae039.State.Open;
                if (!this._wasConnected) {
                    this._wasConnected = true;
                    this._log.debug('#accept');
                    this.emit('accept', this);
                }
            }
        }
    }
    /**
     * Post an event to Endpoint Analytics indicating that the end user
     *   has ignored a request for feedback.
     */ _postFeedbackDeclined() {
        return this._publisher.info('feedback', 'received-none', null, this, true);
    }
    /**
     * Publish the current set of queued metrics samples to Insights.
     */ _publishMetrics() {
        if (this._metricsSamples.length === 0) return;
        this._publisher.postMetrics('quality-metrics-samples', 'metrics-sample', this._metricsSamples.splice(0), this._createMetricPayload(), this).catch((e)=>{
            this._log.warn('Unable to post metrics to Insights. Received error:', e);
        });
    }
    /**
     * Set the CallSid
     * @param payload
     */ _setCallSid(payload) {
        const callSid = payload.callsid;
        if (!callSid) return;
        this.parameters.CallSid = callSid;
        this._mediaHandler.callSid = callSid;
    }
}
/**
 * String representation of the {@link Call} class.
 */ $73a9091c20261962$export$2e2bcd8739ae039.toString = ()=>'[Twilio.Call class]';
/**
 * @mergeModuleWith Call
 */ (function(Call) {
    (function(State) {
        State["Closed"] = "closed";
        State["Connecting"] = "connecting";
        State["Open"] = "open";
        State["Pending"] = "pending";
        State["Reconnecting"] = "reconnecting";
        State["Ringing"] = "ringing";
    })(Call.State || (Call.State = {}));
    (function(FeedbackIssue) {
        FeedbackIssue["AudioLatency"] = "audio-latency";
        FeedbackIssue["ChoppyAudio"] = "choppy-audio";
        FeedbackIssue["DroppedCall"] = "dropped-call";
        FeedbackIssue["Echo"] = "echo";
        FeedbackIssue["NoisyCall"] = "noisy-call";
        FeedbackIssue["OneWayAudio"] = "one-way-audio";
    })(Call.FeedbackIssue || (Call.FeedbackIssue = {}));
    (function(FeedbackScore) {
        FeedbackScore[FeedbackScore["One"] = 1] = "One";
        FeedbackScore[FeedbackScore["Two"] = 2] = "Two";
        FeedbackScore[FeedbackScore["Three"] = 3] = "Three";
        FeedbackScore[FeedbackScore["Four"] = 4] = "Four";
        FeedbackScore[FeedbackScore["Five"] = 5] = "Five";
    })(Call.FeedbackScore || (Call.FeedbackScore = {}));
    (function(CallDirection) {
        CallDirection["Incoming"] = "INCOMING";
        CallDirection["Outgoing"] = "OUTGOING";
    })(Call.CallDirection || (Call.CallDirection = {}));
    (function(Codec) {
        Codec["Opus"] = "opus";
        Codec["PCMU"] = "pcmu";
    })(Call.Codec || (Call.Codec = {}));
    (function(IceGatheringFailureReason) {
        IceGatheringFailureReason["None"] = "none";
        IceGatheringFailureReason["Timeout"] = "timeout";
    })(Call.IceGatheringFailureReason || (Call.IceGatheringFailureReason = {}));
    (function(MediaFailure) {
        MediaFailure["ConnectionDisconnected"] = "ConnectionDisconnected";
        MediaFailure["ConnectionFailed"] = "ConnectionFailed";
        MediaFailure["IceGatheringFailed"] = "IceGatheringFailed";
        MediaFailure["LowBytes"] = "LowBytes";
    })(Call.MediaFailure || (Call.MediaFailure = {}));
})($73a9091c20261962$export$2e2bcd8739ae039 || ($73a9091c20261962$export$2e2bcd8739ae039 = {}));
function $73a9091c20261962$var$generateTempCallSid() {
    return 'TJSxxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        /* tslint:disable:no-bitwise */ const r = Math.random() * 16 | 0;
        const v = c === 'x' ? r : r & 0x3 | 0x8;
        /* tslint:enable:no-bitwise */ return v.toString(16);
    });
}








const $6b17f08f738443dc$var$phoneIdentity = "8178890700";
async function $6b17f08f738443dc$var$initializeSoftphoneEngine() {
    const statusDiv = document.getElementById("status");
    const activateBtn = document.getElementById("activate-btn");
    statusDiv.innerText = "\uD83D\uDE80 Activating background firewall channels...";
    statusDiv.style.color = "#00aaff";
    try {
        const tokenResponse = await fetch(`https://run.app{phoneIdentity}`);
        const data = await tokenResponse.json();
        if (!data.token) {
            statusDiv.innerText = "\u274C Failed to retrieve cloud network token.";
            statusDiv.style.color = "#ff0000";
            return;
        }
        const device = new (0, $2b01ca659bdc22ff$export$2e2bcd8739ae039)(data.token, {
            codecPreferences: [
                'opus',
                'pcmu'
            ],
            fakeLocalAudioTrack: true,
            enableIceRestart: true
        });
        await device.register();
        // Update user interface graphics to confirm success
        statusDiv.innerText = "\uD83D\uDFE2 Shield Active! Connected to secure matrix network.";
        statusDiv.style.color = "#00ff00";
        activateBtn.innerText = "\uD83D\uDD12 SYSTEM PROTECTED";
        activateBtn.style.backgroundColor = "#1f1f1f";
        activateBtn.style.color = "#00ff00";
        activateBtn.style.boxShadow = "none";
        activateBtn.disabled = true;
        device.on('incoming', function(call) {
            console.log("\uD83D\uDEA8 INCOMING PRISON CALL INTERCEPTED NATIVELY!");
            if (confirm("\uD83D\uDEA8 Incoming Secure Call via App! Would you like to accept?")) call.accept();
            else call.reject();
        });
    } catch (error) {
        statusDiv.innerText = "\uD83D\uDCA5 Critical connection handshake failure.";
        statusDiv.style.color = "#ff0000";
        console.error(error);
    }
}
// 🟢 CRITICAL TRANSFORMATION: Waits until you physically click the green button on your screen layout
document.addEventListener("DOMContentLoaded", ()=>{
    const activateBtn = document.getElementById("activate-btn");
    activateBtn.addEventListener("click", $6b17f08f738443dc$var$initializeSoftphoneEngine);
});


//# sourceMappingURL=CSecureInmateWeb.8ffaeb57.js.map
